import * as yM from "chance";
import OM from "lodash";
import * as cS from "crypto";
import { scryptSync as uS, createDecipheriv as vM, randomBytes as Km, createCipheriv as PM } from "crypto";
import * as dS from "http";
import * as lS from "https";
import * as Ta from "url-parse";
import ga from "url-parse";
import { v4 as mS } from "uuid";
import * as Ia from "country-list";
import s from "@hapi/joi";
import RM from "base64url";
import { format as $M, addSeconds as Ua } from "date-fns";
import ln from "lodash/cloneDeep";
import MM from "semver-compare";
import SS from "lodash/omit";
const bM = {
  // TODO write tests to make sure these don't change
  AUTH_FAILED_DEFAULT: "AUTH_FAILED_DEFAULT",
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  MAX_LOGIN_ATTEMPTS_EXCEEDED: "MAX_LOGIN_ATTEMPTS_EXCEEDED",
  USER_DELETED: "USER_DELETED",
  INVALID_PERMISSIONS: "INVALID_PERMISSIONS"
}, VM = {
  // TODO write tests to make sure these don't change
  UNRECOGNIZED_EMAIL_VERIFICATION_ISSUE: "UNRECOGNIZED_EMAIL_VERIFICATION_ISSUE",
  EMAIL_NOT_VERIFIED_TOKEN_SENT: "EMAIL_NOT_VERIFIED_TOKEN_SENT",
  EMAIL_VERIFICATION_TOKEN_EXPIRED: "EMAIL_VERIFICATION_TOKEN_EXPIRED",
  EMAIL_VERIFICATION_TOKEN_NOT_SENT: "EMAIL_VERIFICATION_TOKEN_NOT_SENT",
  PHANTOM_USER_FORBIDDEN: "PHANTOM_USER_FORBIDDEN"
}, LM = {
  LICENSE_EXPIRED: "LICENSE_EXPIRED",
  LICENSE_SESSION_OVERLAPPING_EXCEEDED: "LICENSE_SESSION_OVERLAPPING_EXCEEDED",
  LICENSE_NOT_STARTED: "LICENSE_NOT_STARTED",
  LICENSE_SUSPENDED: "LICENSE_SUSPENDED",
  LICENSE_NO_ACTIVE_PRODUCT_ACCESS: "LICENSE_NO_ACTIVE_PRODUCT_ACCESS",
  USER_NOT_MEMBER_COST_CENTER: "USER_NOT_MEMBER_COST_CENTER",
  USER_NOT_MEMBER_PRODUCT_ACCESS: "USER_NOT_MEMBER_PRODUCT_ACCESS",
  LICENSE_WHITELIST_MISMATCH: "LICENSE_WHITELIST_MISMATCH",
  LICENSE_COUNTRY_WHITELIST_MISMATCH: "LICENSE_COUNTRY_WHITELIST_MISMATCH",
  USER_COUNTRY_WHITELIST_MISMATCH: "USER_COUNTRY_WHITELIST_MISMATCH",
  PRODUCT_VERSION_DISABLED: "PRODUCT_VERSION_DISABLED",
  LICENSE_SESSION_VERSION_PARSE_ERROR: "LICENSE_SESSION_VERSION_PARSE_ERROR",
  TRIAL_DEVICE_EXISTS: "TRIAL_DEVICE_EXISTS",
  TRIAL_FLOWJO_10_DISABLED: "TRIAL_FLOWJO_10_DISABLED",
  TRIAL_REGION_RESTRICTED: "TRIAL_REGION_RESTRICTED"
}, qM = {
  PRODUCT_DEACTIVATED: "PRODUCT_DEACTIVATED",
  NO_VALID_LICENSES: "NO_VALID_LICENSES"
}, FM = {
  EOT_NOT_FOUND: "EOT_NOT_FOUND",
  EOT_EXPIRED: "EOT_EXPIRED",
  EOT_MISSING_END_DATE: "EOT_MISSING_END_DATE",
  EOT_DEVICE_MISMATCH: "EOT_DEVICE_MISMATCH"
}, wM = {
  CANNOT_CREATE_USER: "CANNOT_CREATE_USER",
  CANNOT_CREATE_COST_CENTER: "CANNOT_CREATE_COST_CENTER",
  CANNOT_REGISTER_SEQ_GEQ_TRIAL: "CANNOT_REGISTER_SEQ_GEQ_TRIAL",
  CANNOT_REGISTER_PRODUCT_TRIAL_REGION_RESTRICTED: "CANNOT_REGISTER_PRODUCT_TRIAL_REGION_RESTRICTED",
  CONNECTION_PROBLEM: "CONNECTION_PROBLEM",
  CANNOT_RESET_FORGOTTEN_PASSWORD: "CANNOT_RESET_FORGOTTEN_PASSWORD",
  CANNOT_CHANGE_PASSWORD: "CANNOT_CHANGE_PASSWORD",
  SUCCESS_CHANGE_PASSWORD: "SUCCESS_CHANGE_PASSWORD",
  CANNOT_GET_USER_AGREEMENT_ACCEPTANCE: "CANNOT_GET_USER_AGREEMENT_ACCEPTANCE",
  CANNOT_SET_USER_AGREEMENT_ACCEPTANCE: "CANNOT_SET_USER_AGREEMENT_ACCEPTANCE",
  CANNOT_FIND_USER_AGREEMENT: "CANNOT_FIND_USER_AGREEMENT"
}, GM = {
  BAD_JWT: "BAD_JWT"
}, jM = {
  CANNOT_ADD_USERS: "CANNOT_ADD_USERS",
  CANNOT_SET_SUSPENDED: "CANNOT_SET_SUSPENDED",
  CANNOT_SET_END_DATE: "CANNOT_SET_END_DATE",
  PRODUCT_NOT_FOUND: "PRODUCT_NOT_FOUND",
  INVALID_PRODUCT_ID: "INVALID_PRODUCT_ID",
  INVALID_PRODUCT_NAME: "INVALID_PRODUCT_NAME",
  INVALID_PRODUCT_VERSION: "INVALID_PRODUCT_VERSION",
  PRODUCT_SCHEMA_VALIDATION_FAILED: "PRODUCT_SCHEMA_VALIDATION_FAILED",
  PRODUCT_MIGRATION_FAILED: "PRODUCT_MIGRATION_FAILED",
  CANNOT_CREATE_PRODUCT: "CANNOT_CREATE_PRODUCT",
  CANNOT_UPDATE_PRODUCT: "CANNOT_UPDATE_PRODUCT",
  CANNOT_UPDATE_PRODUCT_ASSETS: "CANNOT_UPDATE_PRODUCT_ASSETS",
  CANNOT_UPDATE_PRODUCT_WHITELIST: "CANNOT_UPDATE_PRODUCT_WHITELIST",
  DUPLICATE_PRODUCT: "DUPLICATE_PRODUCT",
  INVALID_WHITELISTED_COUNTRIES: "INVALID_WHITELISTED_COUNTRIES",
  INVALID_PRODUCT_ASSETS: "INVALID_PRODUCT_ASSETS",
  MISSING_REQUIRED_FIELD: "MISSING_REQUIRED_FIELD"
}, xM = {
  NO_USER_PASSWORD_RESET_CODE: "NO_USER_PASSWORD_RESET_CODE",
  INVALID_PASSWORD_RESET_CODE: "INVALID_PASSWORD_RESET_CODE",
  EXPIRED_PASSWORD_RESET_CODE: "EXPIRED_PASSWORD_RESET_CODE",
  SUCCESS_GENERATE_PASSWORD_RESET_CODE: "SUCCESS_GENERATE_PASSWORD_RESET_CODE",
  SUCCESS_PASSWORD_RESET: "SUCCESS_PASSWORD_RESET"
}, kM = {
  INVALID_PASSWORD_CONFIRMATION: "INVALID_PASSWORD",
  MISMATCHED_USER: "MISMATCHED_USER"
}, HM = {
  CANNOT_AUTHORIZE_USER_ADMIN: "CANNOT_AUTHORIZE_USER_ADMIN",
  NO_EXISTING_LICENSE_FOR_EMAIL: "NO_EXISTING_LICENSE_FOR_EMAIL",
  CONFLICTING_LICENSES_FOR_ADMIN: "CONFLICTING_LICENSES_FOR_ADMIN"
}, BM = {
  BAD_CLOUD_ACTION_TYPE: "BAD_CLOUD_ACTION_TYPE",
  NO_USER_AGREEMENT_PAIR: "NO_USER_AGREEMENT_PAIR",
  USER_PERMISSION_ERROR: "USER_PERMISSION_ERROR",
  MISSING_USER_AGREEMENT: "MISSING_USER_AGREEMENT",
  USER_AGREEMENT_CONNECTION_PROBLEM: "USER_AGREEMENT_CONNECTION_PROBLEM"
}, XM = {
  INVALID_EMAIL_ADDRESS: "INVALID_EMAIL_ADDRESS",
  INVALID_USER_ID: "INVALID_USER_ID",
  INVALID_TOKEN: "INVALID_TOKEN",
  EXPIRED_TOKEN: "EXPIRED_TOKEN",
  TOKEN_ALREADY_SENT: "TOKEN_ALREADY_SENT",
  TOKEN_NEVER_SENT: "TOKEN_NEVER_SENT",
  EMAIL_ALREADY_VERIFIED: "EMAIL_ALREADY_VERIFIED"
}, JM = {
  NO_CLIENT_CONNECTION: "NO_CLIENT_CONNECTION"
}, WM = {
  INVALID_COST_CENTER: "INVALID_COST_CENTER",
  INVALID_USER_ID: "INVALID_USER_ID",
  INVALID_PRODUCT_ACCESS: "INVALID_PRODUCT_ACCESS",
  CANNOT_INVITE_USER: "CANNOT_INVITE_USER",
  NO_MATCHED_TOKEN: "NO_MATCHED_TOKEN",
  INVITE_CANCELLED: "INVITE_CANCELLED",
  INVITE_EXPIRED: "INVITE_EXPIRED",
  INVALID_INVITE: "INVALID_INVITE",
  CANNOT_CANCEL_INVITE: "CANNOT_CANCEL_INVITE",
  USER_HAS_EXISTING_PRODUCT_ACCESS: "USER_HAS_EXISTING_PRODUCT_ACCESS",
  USER_HAS_ADDITIONAL_PHANTOM_INVITE: "USER_HAS_ADDITIONAL_PHANTOM_INVITE"
}, YM = {
  UNVERIFIED_TOKEN_NOT_SENT: "UNVERIFIED_TOKEN_NOT_SENT",
  UNVERIFIED_TOKEN_SENT: "UNVERIFIED_TOKEN_SENT",
  UNVERIFIED_TOKEN_EXPIRED: "UNVERIFIED_TOKEN_EXPIRED"
}, zM = {
  EXCEEDED_MAX_DEVICES: "EXCEEDED_MAX_DEVICES",
  ADDED_AUTHORIZED_DEVICE_NEW: "ADDED_AUTHORIZED_DEVICE_NEW",
  DEACTIVATED_DEVICE: "DEACTIVATED_DEVICE",
  NO_MATCHING_PRODUCT_ACCESS_FOR_DEVICE: "NO_MATCHING_PRODUCT_ACCESS_FOR_DEVICE",
  NO_REMAINING_REMOVALS: "NO_REMAINING_REMOVALS",
  NO_MATCHING_DEVICE: "NO_MATCHING_DEVICE",
  ALREADY_DEACTIVATED: "ALREADY_DEACTIVATED",
  UNABLE_TO_RENAME: "UNABLE_TO_RENAME",
  UNABLE_TO_REMOVE: "UNABLE_TO_REMOVE",
  UNABLE_TO_ADD_ACTIVE_DEVICE_ALREADY_EXISTS: "UNABLE_TO_ADD_ACTIVE_DEVICE_ALREADY_EXISTS"
}, KM = {
  MAX_SHARED_COMPUTER_CHANGES: "MAX_SHARED_COMPUTER_CHANGES",
  MAX_SHARED_COMPUTERS: "MAX_SHARED_COMPUTERS",
  NO_REMAINING_SEATS: "NO_REMAINING_SEATS",
  NO_MATCHING_SHARED_COMUPUTER: "NO_MATCHING_SHARED_COMUPUTER",
  DUPLICATE_SHARED_COMPUTER_LABEL: "DUPLICATE_SHARED_COMPUTER_LABEL",
  DUPLICATE_SHARED_COMPUTER_IDENTIFIER: "DUPLICATE_SHARED_COMPUTER_IDENTIFIER",
  FWM_SHARED_COMPUTER_NO_END_DATE: "FWM_SHARED_COMPUTER_NO_END_DATE",
  FWM_MISSING_IDENTIFIER_DATA: "FWM_MISSING_IDENTIFIER_DATA",
  FWM_IDENTIFIER_PARSING_ERROR: "FWM_IDENTIFIER_PARSING_ERROR"
}, ZM = {
  NO_MATCHING_PRODUCT_FEATURE: "NO_MATCHING_PRODUCT"
}, QM = {
  NON_EXISTING_USER: "NON_EXISTING_USER",
  NO_USER_FOR_EMAIL: "NO_USER_FOR_EMAIL",
  NO_PHANTOM_USERS: "NO_PHANTOM_USERS"
};
function eb(e, t, r) {
  return {
    errorCode: e,
    errorText: t,
    url: r
  };
}
function tb(e, t, r) {
  return {
    userMessageCode: e,
    userMessageText: t,
    url: r
  };
}
function Ve(e) {
  Error.captureStackTrace(this, this.constructor), this.name = "CloudError", this.message = e || "";
}
Ve.prototype = Object.create(Error.prototype);
function Na(e, t) {
  Ve.call(this), this.userId = e, this.name = "InvalidUserId", t ? t = ` ${t}` : t = "", this.message = `User id ${e} is invalid.${t}`;
}
Na.prototype = Object.create(Ve.prototype);
function ES(e, t) {
  Ve.call(this), this.userId = e, this.name = "CannotFindUserUserError", t ? t = ` ${t}` : t = "", this.message = `Cannot find user id ${e}.${t}`;
}
ES.prototype = Object.create(Ve.prototype);
const TX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CannotFindUserUserError: ES,
  CloudError: Ve,
  InvalidUserId: Na,
  authErrorCodes: bM,
  authErrorTypes: GM,
  authorizedDeviceMessageTypes: zM,
  changePasswordErrorTypes: kM,
  cloudErrorTypes: wM,
  coAdminsErrorMessages: QM,
  createCloudErrorObject: eb,
  createCloudUserMessageObject: tb,
  elasticsearchErrorTypes: JM,
  emailUnverifiedErrorTypes: YM,
  emailVerificationErrorTypes: XM,
  extendedOfflineTokenErrorCodes: FM,
  forgotPasswordErrorTypes: xM,
  inviteUserErrorTypes: WM,
  licenseErrorCodes: qM,
  licenseMessageCodes: LM,
  productErrorTypes: jM,
  productFeaturesErrorMessages: ZM,
  sharedComputersErrorMessages: KM,
  userAdminErrorTypes: HM,
  userAgreementsErrorTypes: BM,
  userMessageCodes: VM
}, Symbol.toStringTag, { value: "Module" })), _S = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, AS = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/, rb = /^[0-9a-f]{128}$/;
function fS() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function nb() {
  return mS();
}
function ya() {
  return nb();
}
const U = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DATE_TIME_REGEX: _S,
  SHA512_REGEX: rb,
  UUID_REGEX: AS,
  currentTime: fS,
  newUUID: ya
}, Symbol.toStringTag, { value: "Module" })), ob = (e) => {
  const { id: t, date: r, type: n } = e;
  return {
    id: t || ya(),
    date: r || fS(),
    type: n
  };
}, sb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertStamp: ob
}, Symbol.toStringTag, { value: "Module" })), Oa = "SET_ALERT", va = "DISMISS_ALERT";
function ab(e) {
  return {
    type: Oa,
    alert: e
  };
}
function ib(e) {
  return {
    type: va,
    id: e
  };
}
const cb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DISMISS_ALERT: va,
  SET_ALERT: Oa,
  dismissAlert: ib,
  setAlert: ab
}, Symbol.toStringTag, { value: "Module" }));
function hS(e, t) {
  const { alert: r } = t;
  return { ...e, [r.id]: r };
}
function CS(e, t) {
  const { id: r } = t, n = { ...e };
  return delete n[r], n;
}
function ub(e, t) {
  let r = e;
  switch (r || (r = {}), t.type) {
    case Oa:
      return hS(r, t);
    case va:
      return CS(r, t);
    default:
      return r;
  }
}
const db = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alerts: ub,
  handleDismissAlert: CS,
  handleSetAlert: hS
}, Symbol.toStringTag, { value: "Module" }));
function lb(e, t) {
  let r = {}, n = {}, o = {}, a = {};
  return e === "cloud" && (r = {
    headerDefaultTitle: t.noticeHeaderDefaultTitle,
    headerBackgroundColor: t.alertTopBackgroundColor,
    headerHeight: t.alertTopHeaderHeight,
    outlineColor: t.alertTopOutlineColor,
    headerColor: t.headerColor,
    headerFontSize: t.headerFontSize
  }, n = {
    headerDefaultTitle: t.noticeHeaderDefaultTitle,
    headerBackgroundColor: t.alertHeaderBackgroundColor,
    headerHeight: t.alertHeaderHeight,
    outlineColor: t.alertOutlineColor,
    headerColor: t.headerColor,
    headerFontSize: t.headerFontSize
  }, o = {
    headerDefaultTitle: t.alertHeaderDefaultTitle,
    headerBackgroundColor: t.alertHeaderBackgroundColor,
    headerHeight: t.alertHeaderHeight,
    outlineColor: t.alertOutlineColor,
    buttonStyling: t.buttonStyling,
    headerColor: t.headerColor,
    headerFontSize: t.headerFontSize
  }, a = {
    headerDefaultTitle: t.alertHeaderDefaultTitle,
    headerBackgroundColor: t.alertHeaderBackgroundColor,
    headerHeight: t.alertHeaderHeight,
    outlineColor: t.alertOutlineColor,
    headerColor: t.headerColor,
    headerFontSize: t.headerFontSize
  }), {
    alertTop: r,
    alertRight: n,
    alertMiddle: o,
    alertBottom: a
  };
}
const mb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alertUiTypeConfig: lb
}, Symbol.toStringTag, { value: "Module" }));
function Sb(e) {
  const r = window.location.search.substring(1).split("&");
  for (let n = 0; n < r.length; n += 1) {
    const o = r[n].split("=");
    if (decodeURIComponent(o[0]) === e)
      return decodeURIComponent(o[1]);
  }
  return null;
}
function Eb(e) {
  const t = e || window.event, r = "Leaving or reloading the page will interrupt any data syncing or file uploads in progress. Are you sure you want to continue?";
  return t && (t.returnValue = r), r;
}
const _b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  confirmOnPageExit: Eb,
  getQueryVariable: Sb
}, Symbol.toStringTag, { value: "Module" })), Ab = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alert: sb,
  AlertActions: cb,
  AlertReducers: db,
  AlertUiConfig: mb,
  AlertUtils: _b
}, Symbol.toStringTag, { value: "Module" }));
function fb(e) {
  const t = [];
  function r() {
    const n = e.shift();
    if (!n)
      return Promise.resolve();
    let o;
    try {
      o = n();
    } catch (a) {
      o = Promise.reject(a);
    }
    return o || console.log("nextFunctionResult", n, o), o.then((a) => {
      t.push({ result: a });
    }).catch((a) => {
      t.push({ err: a });
    }).then(r);
  }
  return r().then(() => t);
}
const hb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  asyncMap: fb
}, Symbol.toStringTag, { value: "Module" })), Pa = 5e3, Cb = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  MOVED_PERANENTLY: 301,
  FOUND: 302,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  GONE: 401,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504
};
function mn(e, t = null) {
  return new Promise((r, n) => {
    let o, a = null, i = !1;
    setTimeout(() => {
      if (!i) {
        const m = `${e.protocol}://${e.host}:${e.port}/${e.path}`;
        n(new Error(`Reponse timeout for ${e.method} to ${m}`));
      }
    }, e.timeout), e.protocol === "https:" ? o = lS : o = dS;
    const c = o.request(e, (m) => {
      a = m.statusCode;
      let d = "";
      m.setEncoding !== void 0 && m.setEncoding("utf8"), m.on("data", (p) => {
        d += p;
      }), m.on("end", () => {
        i = !0, r({ data: d, code: a });
      });
    });
    c.on("error", (m) => {
      i = !0, n(m);
    });
    try {
      t !== null && c.write(t), c.end();
    } catch (m) {
      n(m);
    }
  });
}
function Db(e, t, r = {}, n = !0, o = Pa) {
  const a = new ga(e);
  let { port: i } = a;
  i ? i = parseInt(i, 10) : a.protocol === "https:" ? i = 443 : i = 80;
  const c = JSON.stringify(t), d = {
    "Content-Type": "application/json;charset=UTF-8",
    "Content-Length": c.length,
    ...r
  }, p = a.query || "", N = {
    protocol: a.protocol,
    host: a.hostname,
    port: i,
    path: a.pathname + p,
    method: "PUT",
    headers: d,
    rejectUnauthorized: n,
    timeout: o
  };
  return mn(N, c);
}
function pb(e, t = {}, r = !0, n = Pa) {
  const o = new ga(e);
  let { port: a } = o;
  a ? a = parseInt(a, 10) : o.protocol === "https:" ? a = 443 : a = 80;
  const i = o.query || "", c = {
    protocol: o.protocol,
    host: o.hostname,
    port: a,
    path: o.pathname + i,
    method: "DELETE",
    headers: t,
    rejectUnauthorized: r,
    timeout: n
  };
  return mn(c);
}
function Tb(e, t = {}, r = !0, n = Pa) {
  const o = new ga(e);
  let { port: a } = o;
  a ? a = parseInt(a, 10) : o.protocol === "https:" ? a = 443 : a = 80;
  const i = o.query || "", c = {
    protocol: o.protocol,
    host: o.hostname,
    port: a,
    path: o.pathname + i,
    method: "GET",
    headers: t,
    rejectUnauthorized: r,
    timeout: n
  };
  return mn(c);
}
const gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getJson: Tb,
  httpOperationAsync: mn,
  reponses: Cb,
  sendDelete: pb,
  sendJson: Db
}, Symbol.toStringTag, { value: "Module" }));
function DS(e) {
  const t = e.toLowerCase();
  let r;
  return t === "cloud" && (r = "cloud"), r;
}
function Ib() {
  const t = window.location.hostname.substring(5), r = DS("cloud"), n = r + t;
  return r === "flowjo.com" ? "cloud.flowjo.com" : n;
}
function Ub(e) {
  const r = window.location.hostname.substring(5);
  return e === "flowjo.com" ? "flowjo.com" : e.toLowerCase() + r;
}
const Nb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getNamespaceForSubdomain: DS,
  mapCloudEnvToProdEnv: Ub,
  mapProdEnvToCloudEnv: Ib
}, Symbol.toStringTag, { value: "Module" })), pS = Ia.getData().map((e) => [e.name, e.code]), yb = Ia.getCodes(), Ob = Ia.getNames(), Sn = {};
pS.forEach(([e, t]) => {
  Sn[t] = e;
});
const Ra = {};
pS.forEach(([e, t]) => {
  Ra[e] = t;
});
const En = [
  ["North America", "US"],
  ["Europe", "EU"],
  ["Asia Pacific", "AP"],
  ["China", "CN"]
], vb = En.map((e) => e[1]), Pb = En.map((e) => e[0]), _n = {};
En.forEach(([e, t]) => {
  _n[t] = e;
});
const $a = {};
En.forEach(([e, t]) => {
  $a[e] = t;
});
const TS = {
  AF: "Afghanistan",
  BY: "Belarus",
  CF: "Central African Republic (the)",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo (the)",
  CU: "Cuba",
  ER: "Eritrea",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  LB: "Lebanon",
  LY: "Libya",
  KP: "Korea (the Democratic People's Republic of)",
  RU: "Russian Federation (the)",
  SO: "Somalia",
  SD: "Sudan (the)",
  SY: "Syrian Arab Republic (the)",
  VE: "Venezuela (Bolivarian Republic of)"
}, Ut = "world wide";
function Rb(e) {
  return Sn[e.toUpperCase()];
}
function $b(e) {
  return Ra[e];
}
function Mb(e) {
  return _n[e.toUpperCase()];
}
function bb(e) {
  return $a[e];
}
const Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  COUNTRY_CODES: yb,
  COUNTRY_CODES_BY_NAME: Ra,
  COUNTRY_NAMES: Ob,
  COUNTRY_NAMES_BY_CODE: Sn,
  REGION_CODES: vb,
  REGION_CODES_BY_NAME: $a,
  REGION_NAMES: Pb,
  REGION_NAMES_BY_CODE: _n,
  WORLD_WIDE: Ut,
  embargoedCountries: TS,
  getCountryCode: $b,
  getCountryName: Rb,
  getRegionCode: bb,
  getRegionName: Mb
}, Symbol.toStringTag, { value: "Module" }));
function Lb() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function qb() {
  return (/* @__PURE__ */ new Date()).valueOf();
}
function Fb(e) {
  return new Date(e || "").valueOf();
}
function wb(e) {
  return e.toISOString();
}
const Gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertEpochToIso: wb,
  convertIsoToEpoch: Fb,
  currentTime: Lb,
  getCurrentEpochTimeUtc: qb
}, Symbol.toStringTag, { value: "Module" })), gX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alerts: Ab,
  Async: hb,
  Net: gb,
  ProductEnvMap: Nb,
  Regional: Vb,
  StringUtils: U,
  Time: Gb
}, Symbol.toStringTag, { value: "Module" }));
function l(e) {
  const { init: t } = e, r = [];
  t && r.push(t);
  const n = (o) => {
    const a = { ...n.references };
    return typeof o == "object" && Object.keys(o).forEach((i) => {
      a[i] = o[i];
    }), n.inits.forEach((i) => i({ instance: a })), Object.keys(n.methods).forEach((i) => {
      Object.defineProperty(a, [i], { value: "static", writable: !0 }), a[i] = n.methods[i];
    }), a;
  };
  return n.references = { ...n.references, ...e.refs }, n.methods = { ...n.methods, ...e.methods }, n.inits = r, n.compose = (...o) => (o.forEach((a) => {
    n.references = { ...a.references, ...n.references }, n.methods = { ...a.methods, ...n.methods }, n.inits = n.inits.concat(a.inits);
  }), n), n.refs = (o) => {
    const a = l({ refs: n.references, methods: n.methods });
    return Array.isArray(n.inits) && n.inits.forEach((i) => a.inits.push(i)), a.references = { ...a.references, ...o }, a;
  }, n;
}
const jb = () => (/* @__PURE__ */ new Date()).toISOString(), xb = () => mS(), gS = "1", Nt = l({
  refs: {
    id: null,
    version: null,
    name: null,
    region: null,
    productVersion: null,
    type: null,
    isActive: null,
    releaseDate: null,
    assets: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = xb());
    const t = jb();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), (e.isActive === null || e.isActive === void 0) && (e.isActive = !0), e.assets || (e.assets = {});
  },
  methods: {
    getDecoratedName() {
      return `${this.name} ${this.productVersion} ${this.type}-${this.region}`.trim();
    }
  }
});
function kb(e) {
  const t = { ...e };
  return Nt(t);
}
function Hb(e, t, r, n, o, a, i = {}) {
  return Nt({
    name: e,
    productVersion: t,
    region: r,
    type: n,
    releaseDate: o,
    isActive: a,
    assets: i
  });
}
const Bb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PRODUCT_SCHEMA_VERSION: gS,
  ProductStamp: Nt,
  createProduct: Hb,
  createProductFromJson: kb
}, Symbol.toStringTag, { value: "Module" })), f = Object.freeze({
  INVALID_CHARS_SYMBOLS: "contains invalid characters ^/:*?<>\\|",
  INVALID_CHARS_ALPHANUMERIC: "contains invalid characters.  must only contain 0-9, a-f,",
  LEADING_OR_TRAILING_SPACES: "contains leading or trailing spaces",
  NON_STRING_NUMBER_REQUIRED: "must not be of type string",
  CONSECUTIVE_SPACES: "contains two or more consecutive spaces",
  VALUE_REQUIRED: '"value" is required',
  STRING_REQUIRED: '"value" must be a string',
  NEW_LINE: "contains line break",
  TABS: "contains tabs",
  COUNTRY_CODE: "is not a valid country code",
  REGION_CODE: "is not a valid Region code",
  INVALID_EMAIL: "invalid email",
  EXCEEDS_MAX_CHARS: "length must be less than or equal to",
  USER_ID: "incorrect user id",
  MAX_CUSTOM_FIELDS: "exceeds maximum number of custom fields allowed",
  DUPLICATE_INDEX: "not allowed to have duplicate order indexes",
  DUPLICATE_SHARED_COMPUTER_LABEL: "duplicate label detected in shared computers",
  START_DATE_BEFORE_END_DATE: "start date must be prior to end date",
  DUPLICATE_PRODUCT: "duplicate product",
  INVALID_LENGTH: "invalid length"
}), E = s.extend((e) => ({
  base: e.number(),
  type: "nonStringNumber",
  messages: {
    nonString: `"{{#label}}" ${f.NON_STRING_NUMBER_REQUIRED}`
  },
  validate(t, r) {
    if (typeof t != "number")
      return { value: t, errors: r.error("nonString") };
  }
})), Xb = s.extend((e) => ({
  base: e.string(),
  type: "hwa",
  messages: {
    invalidChars: f.INVALID_CHARS_ALPHANUMERIC
  },
  rules: {
    hardwareAddress: {
      validate(t, r) {
        const n = /^([a-f0-9])+$/;
        return t.match(n) ? t : r.error("invalidChars");
      }
    }
  }
})), Ma = s.extend((e) => ({
  base: e.string(),
  type: "fingerprint",
  messages: {
    invalidChars: f.INVALID_CHARS_ALPHANUMERIC,
    invalidLength: f.INVALID_LENGTH
  },
  validate(t, r) {
    const n = /^([a-f0-9])+$/;
    return t.match(n) ? t.length !== 16 ? { value: t, errors: r.error("invalidLength") } : t : { value: t, errors: r.error("invalidChars") };
  }
})), P = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: f.INVALID_CHARS_SYMBOLS,
    newlines: f.NEW_LINE,
    tabs: f.TABS,
    consecutiveSpaces: f.CONSECUTIVE_SPACES,
    leadingOrTrailingSpaces: f.LEADING_OR_TRAILING_SPACES
  },
  validate(t, r) {
    if (t.match(/[\^/:*?<>\\|]/))
      return { value: t, errors: r.error("invalidChars") };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error("newlines") };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error("tabs") };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error("consecutiveSpaces") };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error("leadingOrTrailingSpaces") };
  }
})), Jb = s.extend((e) => ({
  base: e.string(),
  type: "country",
  messages: {
    invalidCountryCode: `{{#value}} ${f.COUNTRY_CODE}`
  },
  validate(t, r) {
    if (!Sn[t])
      return { value: t, errors: r.error("invalidCountryCode") };
  }
})), Wb = s.extend((e) => ({
  base: e.string(),
  type: "region",
  messages: {
    invalidRegionCode: `{{#value}} ${f.REGION_CODE}`
  },
  validate(t, r) {
    if (!_n[t])
      return { value: t, errors: r.error("invalidRegionCode") };
  }
})), _e = Xb.hwa().min(12).max(12).required(), Yb = Ma.fingerprint().required(), v = E.nonStringNumber().min(0).integer().required(), g = E.nonStringNumber().min(1).integer().required(), I = s.string().regex(AS), u = I.required(), h = s.string().regex(_S), D = h.required();
I.required();
const A = s.alternatives().try(null, h).required(), T = s.boolean().truthy("true", "1", 1).falsy("false", "0", 0), Ir = P.nameString(), R = Jb.country().required(), ne = Wb.region().required(), me = s.string().allow(null), IS = s.any().valid("1").optional(), US = u, NS = s.number().integer().min(1).required(), yS = s.string().trim().min(1).max(100).required(), OS = s.string().trim().min(1).max(50).required(), vS = s.string().trim().min(1).max(50).required(), PS = s.string().trim().min(1).max(50).required(), Ur = s.boolean().optional(), zb = Ur, RS = h.allow(null).optional(), $S = h.optional(), MS = h.allow(null).optional(), bS = s.object().unknown(!0).optional(), VS = s.object({
  schemaVersion: IS,
  id: US,
  version: NS,
  name: yS,
  region: OS,
  productVersion: vS,
  type: PS,
  isActive: Ur,
  // Also allow 'active' for products that were saved before the field was renamed
  active: Ur,
  releaseDate: RS,
  assets: bS,
  createdAt: $S,
  updatedAt: MS
}).unknown(!0);
function Kb(e) {
  return VS.validate(e, { abortEarly: !1, stripUnknown: !1 });
}
const w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProductActiveFlagSchema: zb,
  ProductAssetsSchema: bS,
  ProductCreatedAtSchema: $S,
  ProductIdSchema: US,
  ProductIsActiveFlagSchema: Ur,
  ProductNameSchema: yS,
  ProductRegionSchema: OS,
  ProductReleaseDateSchema: RS,
  ProductSchemaV1: VS,
  ProductTypeSchema: PS,
  ProductUpdatedAtSchema: MS,
  ProductVersionNumberSchema: NS,
  ProductVersionStringSchema: vS,
  SchemaVersionSchema: IS,
  validateProductV1: Kb
}, Symbol.toStringTag, { value: "Module" })), Zb = Bb, Qb = w, eV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PRODUCT_SCHEMA_VERSION: gS,
  ProductSchema: Zb,
  ProductSchemaValidators: Qb,
  ProductStamp: Nt
}, Symbol.toStringTag, { value: "Module" })), An = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  DATE: "date"
}, LS = "US", qS = "DESKTOP", ba = "2", _ = {
  cloud: "Cloud",
  envoy: "Envoy",
  flowJo: "FlowJo",
  seqGeq: "SeqGeq",
  bdrc: "Bdrc",
  infinicytIvd: "InfinicytIvd",
  // CE-IVD
  infinicytUsIvd: "InfinicytUsIvd",
  // US-IVD
  infinicytRuo: "InfinicytRuo",
  infinicytEa: "InfinicytEa",
  infinicytIuo: "InfinicytIuo",
  facsWorkflowManager: "FacsWorkflowManager"
}, tV = ["cloud", "envoy"], FS = Object.fromEntries(
  Object.entries(_).filter(([e]) => !tV.includes(e))
), rV = ["cloud", "envoy", "bdrc"], wS = Object.fromEntries(
  Object.entries(_).filter(([e]) => !rV.includes(e))
), GS = {
  [_.flowJo]: "FlowJo™",
  [_.seqGeq]: "SeqGeq™",
  [_.bdrc]: "BD® Research Cloud",
  [_.infinicytIvd]: "BD Infinicyt™ CE-IVD",
  [_.infinicytUsIvd]: "BD Infinicyt™ US-IVD",
  [_.infinicytRuo]: "BD Infinicyt™ RUO",
  [_.infinicytEa]: "BD Infinicyt™ EA",
  [_.infinicytIuo]: "BD Infinicyt™ IUO",
  [_.facsWorkflowManager]: "BD FACS™ Workflow Manager"
}, jS = {
  [_.flowJo]: "FlowJo",
  [_.seqGeq]: "SeqGeq",
  [_.bdrc]: "BD Research Cloud",
  // ® (in case we need this character later)
  [_.infinicytIvd]: "BD Infinicyt CE-IVD",
  [_.infinicytUsIvd]: "BD Infinicyt US-IVD",
  [_.infinicytRuo]: "BD Infinicyt RUO",
  [_.infinicytEa]: "BD Infinicyt EA",
  [_.infinicytIuo]: "BD Infinicyt IUO",
  [_.facsWorkflowManager]: "BD FACS Workflow Manager"
}, xS = Object.values(_), fn = {
  beta: "Beta",
  release: "Release",
  trial: "Trial",
  training: "Training"
}, kS = Object.values(fn), yt = l({
  refs: {
    whitelistedCountries: null,
    schemaVersion: null,
    assets: null,
    active: null
  },
  init: ({ instance: e }) => {
    e.whitelistedCountries || (e.whitelistedCountries = []), e.schemaVersion || (e.schemaVersion = ba), (e.active === null || e.active === void 0) && (e.isActive !== null && e.isActive !== void 0 ? e.active = e.isActive : e.active = !0), "isActive" in e && delete e.isActive;
  }
}).compose(Nt);
function HS(e) {
  const t = { ...e };
  return yt(t);
}
function Va(e, t, r, n, o, a, i = [], c = {}) {
  return yt({
    name: e,
    productVersion: t,
    region: r,
    type: n,
    releaseDate: o,
    active: a,
    whitelistedCountries: i,
    assets: c
  });
}
const nV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_PRODUCT_REGION: LS,
  DEFAULT_PRODUCT_TYPE: qS,
  NAMES: _,
  NAMES_LICENSED_PRODUCTS: wS,
  NAMES_UI_TABS: FS,
  NAME_VALUES: xS,
  PRODUCT_ACCESS_FEATURE_VALUE_TYPES: An,
  PRODUCT_DISPLAY_NAMES: jS,
  PRODUCT_MARKETING_NAMES: GS,
  PRODUCT_SCHEMA_VERSION: ba,
  ProductStamp: yt,
  TYPES: fn,
  TYPE_VALUES: kS,
  createProduct: Va,
  createProductFromJson: HS
}, Symbol.toStringTag, { value: "Module" })), BS = s.object({
  url: s.string().uri().trim().min(1).max(2e3).required(),
  label: s.string().trim().max(500).optional()
}).unknown(!1), XS = s.object({
  id: s.string().trim().min(1).max(100).pattern(/^[a-zA-Z][a-zA-Z0-9_-]*$/).required().messages({
    "string.pattern.base": "Category ID must start with a letter and contain only letters, numbers, dashes, and underscores"
  }),
  label: s.string().trim().min(1).max(200).required(),
  items: s.array().items(BS).min(0).required()
}).unknown(!1), La = s.object({
  version: s.number().valid(2).required(),
  categories: s.array().items(XS).min(0).required()
}).unknown(!1);
function Nr(e) {
  return La.validate(e, { abortEarly: !1, stripUnknown: !1 });
}
function JS(e) {
  const t = e.map((n) => n.id), r = t.filter((n, o) => t.indexOf(n) !== o);
  return r.length > 0 ? `Duplicate category IDs found: ${r.join(", ")}` : null;
}
function oV() {
  return {
    version: 2,
    categories: []
  };
}
function sV(e, t) {
  return e.categories.find((r) => r.id === t);
}
function aV(e, t, r, n) {
  const o = e.categories.findIndex((c) => c.id === t), a = { id: t, label: r, items: n }, i = [...e.categories];
  return o >= 0 ? i[o] = a : i.push(a), { ...e, categories: i };
}
const hn = s.any().valid("2").optional(), { ProductIdSchema: Cn } = w, { ProductVersionNumberSchema: Dn } = w, { ProductNameSchema: pn } = w, { ProductRegionSchema: Tn } = w, { ProductVersionStringSchema: gn } = w, { ProductTypeSchema: In } = w, { ProductActiveFlagSchema: Un } = w, { ProductReleaseDateSchema: Nn } = w, { ProductCreatedAtSchema: yn } = w, { ProductUpdatedAtSchema: On } = w, vn = s.array().items(s.string().length(2).uppercase()).required(), Pn = s.alternatives().try(
  La,
  s.object().length(0)
  // Allow empty object {}
), qa = s.object({
  schemaVersion: hn,
  id: Cn,
  version: Dn,
  name: pn,
  region: Tn,
  productVersion: gn,
  type: In,
  active: Un,
  releaseDate: Nn,
  whitelistedCountries: vn,
  // New in v2
  assets: Pn,
  createdAt: yn,
  updatedAt: On
}).unknown(!1);
function WS(e) {
  return qa.validate(e, { abortEarly: !1, stripUnknown: !1 });
}
function Fa(e) {
  return s.object({
    schemaVersion: hn,
    id: Cn,
    version: Dn,
    name: pn,
    region: Tn,
    productVersion: gn,
    type: In,
    active: Un,
    releaseDate: Nn,
    whitelistedCountries: vn,
    assets: Pn,
    createdAt: yn,
    updatedAt: On
  }).unknown(!0).validate(e, { abortEarly: !1, stripUnknown: !1 });
}
const iV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ProductActiveFlagSchema: Un,
  ProductAssetsSchema: Pn,
  ProductCreatedAtSchema: yn,
  ProductIdSchema: Cn,
  ProductNameSchema: pn,
  ProductRegionSchema: Tn,
  ProductReleaseDateSchema: Nn,
  ProductSchemaV2: qa,
  ProductTypeSchema: In,
  ProductUpdatedAtSchema: On,
  ProductVersionNumberSchema: Dn,
  ProductVersionStringSchema: gn,
  ProductWhitelistedCountriesSchema: vn,
  SchemaVersionSchema: hn,
  validateProductV2: WS,
  validateProductV2Creation: Fa
}, Symbol.toStringTag, { value: "Module" })), cV = nV, uV = iV, dV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NAMES: _,
  ProductSchema: cV,
  ProductSchemaValidators: uV,
  ProductStamp: yt,
  TYPES: fn,
  createProduct: Va
}, Symbol.toStringTag, { value: "Module" })), ua = ["1", "2"], Se = ua[ua.length - 1], wa = {
  1: eV,
  2: dV
}, Ga = wa[Se], { ProductSchema: lV, ProductSchemaValidators: mV } = Ga, SV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENT_SCHEMA_VERSION: Se,
  DEFAULT_PRODUCT_REGION: LS,
  DEFAULT_PRODUCT_TYPE: qS,
  KNOWN_VERSIONS: ua,
  NAMES: _,
  NAMES_LICENSED_PRODUCTS: wS,
  NAMES_UI_TABS: FS,
  NAME_VALUES: xS,
  PRODUCT_ACCESS_FEATURE_VALUE_TYPES: An,
  PRODUCT_DISPLAY_NAMES: jS,
  PRODUCT_MARKETING_NAMES: GS,
  PRODUCT_SCHEMA_VERSION: ba,
  ProductActiveFlagSchema: Un,
  ProductAssetsSchema: Pn,
  ProductCreatedAtSchema: yn,
  ProductIdSchema: Cn,
  ProductNameSchema: pn,
  ProductRegionSchema: Tn,
  ProductReleaseDateSchema: Nn,
  ProductSchema: lV,
  ProductSchemaV2: qa,
  ProductSchemaValidators: mV,
  ProductStamp: yt,
  ProductTypeSchema: In,
  ProductUpdatedAtSchema: On,
  ProductVersionNumberSchema: Dn,
  ProductVersionStringSchema: gn,
  ProductWhitelistedCountriesSchema: vn,
  SchemaVersionSchema: hn,
  TYPES: fn,
  TYPE_VALUES: kS,
  createProduct: Va,
  createProductFromJson: HS,
  currentProductSchema: Ga,
  productSchemas: wa,
  validateProductV2: WS,
  validateProductV2Creation: Fa
}, Symbol.toStringTag, { value: "Module" }));
function YS(e) {
  return e != null && "version" in e && e.version === 2;
}
function zS(e) {
  return e ? !("version" in e) || e.version === 1 : !1;
}
const KS = s.object({
  name: s.string().trim().min(1).max(500).required(),
  url: s.string().uri().trim().min(1).max(2e3).required()
}), ZS = s.object({
  version: s.number().valid(1).optional(),
  installerUrl: s.string().uri().trim().max(2e3).allow("").optional(),
  installerUrlLabel: s.string().trim().max(500).allow("").optional(),
  instructionsUrl: s.string().uri().trim().max(2e3).allow("").optional(),
  userAccessControlModuleUrl: s.string().uri().trim().max(2e3).allow("").optional(),
  userAccessControlModuleUrlLabel: s.string().trim().max(500).allow("").optional(),
  referenceDatabases: s.array().items(KS).optional()
}).unknown(!1);
function QS(e) {
  return ZS.validate(e, { abortEarly: !1, stripUnknown: !1 });
}
const eE = 2;
function tE(e) {
  const t = [];
  return e.installerUrl && e.installerUrl.trim() && t.push({
    id: "installer",
    label: "Installer",
    items: [
      {
        url: e.installerUrl.trim(),
        label: e.installerUrlLabel?.trim() || void 0
      }
    ]
  }), e.instructionsUrl && e.instructionsUrl.trim() && t.push({
    id: "installation-instructions",
    label: "Installation Instructions",
    items: [
      {
        url: e.instructionsUrl.trim()
      }
    ]
  }), e.userAccessControlModuleUrl && e.userAccessControlModuleUrl.trim() && t.push({
    id: "user-access-control-module",
    label: "User Access Control Module",
    items: [
      {
        url: e.userAccessControlModuleUrl.trim(),
        label: e.userAccessControlModuleUrlLabel?.trim() || void 0
      }
    ]
  }), e.referenceDatabases && e.referenceDatabases.length > 0 && t.push({
    id: "reference-databases",
    label: "Reference Databases",
    items: e.referenceDatabases.map((r) => ({
      url: r.url.trim(),
      label: r.name.trim()
    }))
  }), {
    version: eE,
    categories: t
  };
}
function ja(e) {
  if (!e || typeof e == "object" && Object.keys(e).length === 0)
    return {
      success: !0,
      data: { version: eE, categories: [] },
      migrated: !0,
      fromVersion: e?.version || 0
    };
  try {
    if (YS(e)) {
      const t = Nr(e);
      if (t.error)
        return {
          success: !1,
          error: `Invalid v2 assets: ${t.error.message}`
        };
      const r = JS(e.categories);
      return r ? {
        success: !1,
        error: r
      } : {
        success: !0,
        data: e,
        migrated: !1
      };
    }
    if (zS(e)) {
      const t = QS(e);
      if (t.error)
        return {
          success: !1,
          error: `Invalid v1 assets: ${t.error.message}`
        };
      const r = tE(e), n = Nr(r);
      return n.error ? {
        success: !1,
        error: `Migration produced invalid v2 assets: ${n.error.message}`
      } : {
        success: !0,
        data: r,
        migrated: !0,
        fromVersion: e.version || 1
      };
    }
    return {
      success: !1,
      error: "Unknown asset schema version"
    };
  } catch (t) {
    return {
      success: !1,
      error: `Migration error: ${t instanceof Error ? t.message : String(t)}`
    };
  }
}
function EV(e) {
  const t = ja(e);
  if (!t.success || !t.data)
    throw new Error(t.error || "Failed to migrate assets to latest version");
  return t.data;
}
let Rn = console;
function rE(e) {
  Rn = e;
}
function nE() {
  return Rn;
}
function _V(e, t, r) {
  const { ProductSchemaValidators: n } = wa[t], o = n.validateProductV2 ? n.validateProductV2(r) : { error: null };
  if (o.error)
    throw Rn.error(
      `Product schema validation failed during migration from v${e} to v${t}:`,
      o.error.message
    ), new Error(`Product schema validation error: ${o.error.message}`);
  return r;
}
function AV(e, t, r) {
  if (e !== t)
    throw new Error(
      `Expected schema version ${t} but got ${e} when migrating to ${r}`
    );
}
function xa(e) {
  if (!e)
    throw new Error("Cannot migrate undefined product");
  e.schemaVersion && AV(e.schemaVersion, "1", "2");
  let n = e.assets || {};
  if (n && typeof n == "object") {
    const c = ja(n);
    c.success && c.data && (n = c.data);
  }
  const o = ce();
  let a = !0;
  e.active !== void 0 ? a = e.active : e.isActive !== void 0 && (a = e.isActive);
  const i = {
    ...e,
    schemaVersion: "2",
    whitelistedCountries: e.whitelistedCountries || [],
    assets: n,
    active: a,
    createdAt: e.createdAt || o,
    updatedAt: o
  };
  return "family" in i && delete i.family, "isActive" in i && delete i.isActive, _V("1", "2", i);
}
function $n(e) {
  if (!e || e.schemaVersion === Se && Array.isArray(e.whitelistedCountries))
    return e;
  const t = `${e.schemaVersion || "1"}`;
  switch (t) {
    case "1":
      e = xa(e);
    case "2":
      break;
    default:
      Rn.warn(`Unknown product schema version: ${t}`), Array.isArray(e.whitelistedCountries) || (e.whitelistedCountries = []), e.schemaVersion = Se, e.updatedAt = ce();
  }
  return e;
}
function da(e) {
  if (!e)
    return e;
  const t = Se, r = e.schemaVersion || "1", n = Array.isArray(e.whitelistedCountries);
  return r === t && n ? e : $n(e);
}
function la(e) {
  return $n(e);
}
function oE(e) {
  return e ? !e.schemaVersion || e.schemaVersion === "1" : !1;
}
function sE(e) {
  return e ? e.schemaVersion === "2" : !1;
}
const fV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ensureLatestVersion: da,
  getMigrationLogger: nE,
  isProductSchemaV1: oE,
  isProductSchemaV2: sE,
  migrateSchema: $n,
  migrateSchema1to2: xa,
  migrateToLatest: la,
  setMigrationLogger: rE
}, Symbol.toStringTag, { value: "Module" }));
function hV(e) {
  if (!e)
    return {
      isValid: !1,
      error: "Product data is required"
    };
  const r = ["name", "productVersion", "region", "type"].filter((a) => !e[a]);
  if (r.length > 0)
    return {
      isValid: !1,
      error: `Missing required fields: ${r.join(", ")}`,
      details: { missingFields: r }
    };
  const n = {
    ...e,
    schemaVersion: Se,
    id: e.id || F(),
    // Use real UUID for validation
    version: e.version || 1,
    active: e.active !== void 0 ? e.active : !0,
    whitelistedCountries: e.whitelistedCountries || [],
    assets: e.assets || { version: 2, categories: [] },
    createdAt: e.createdAt || (/* @__PURE__ */ new Date()).toISOString(),
    updatedAt: e.updatedAt || (/* @__PURE__ */ new Date()).toISOString()
  }, o = Fa(n);
  return o.error ? {
    isValid: !1,
    error: o.error.message || "Product validation failed",
    details: o.error.details
  } : { isValid: !0 };
}
function CV(e) {
  if (!e)
    return {
      isValid: !1,
      error: "Product data is required"
    };
  if (!e.id)
    return {
      isValid: !1,
      error: "Product ID is required for updates"
    };
  if (e.whitelistedCountries !== void 0) {
    if (!Array.isArray(e.whitelistedCountries))
      return {
        isValid: !1,
        error: "whitelistedCountries must be an array"
      };
    const t = e.whitelistedCountries.filter(
      (r) => typeof r != "string" || r.length !== 2 || r !== r.toUpperCase()
    );
    if (t.length > 0)
      return {
        isValid: !1,
        error: "Invalid country codes in whitelistedCountries",
        details: { invalidCountries: t }
      };
  }
  return { isValid: !0 };
}
function DV(e) {
  if (!e)
    return {
      isValid: !1,
      error: "Assets data is required"
    };
  if (typeof e != "object" || Array.isArray(e))
    return {
      isValid: !1,
      error: "Assets must be an object"
    };
  if (Object.keys(e).length === 0)
    return { isValid: !0 };
  const t = Nr(e);
  return t.error ? {
    isValid: !1,
    error: t.error.message || "Assets validation failed",
    details: t.error.details
  } : { isValid: !0 };
}
function pV(e) {
  if (!Array.isArray(e))
    return {
      isValid: !1,
      error: "whitelistedCountries must be an array"
    };
  const t = e.filter(
    (r) => typeof r != "string" || r.length !== 2 || r !== r.toUpperCase()
  );
  return t.length > 0 ? {
    isValid: !1,
    error: 'Invalid country codes: must be 2-letter uppercase strings (e.g., "US", "CA")',
    details: { invalidCountries: t }
  } : { isValid: !0 };
}
function TV(e) {
  return !e || typeof e != "string" ? {
    isValid: !1,
    error: "Product name must be a non-empty string"
  } : e.trim().length === 0 ? {
    isValid: !1,
    error: "Product name cannot be empty or whitespace only"
  } : e.length > 100 ? {
    isValid: !1,
    error: "Product name cannot exceed 100 characters"
  } : { isValid: !0 };
}
function gV(e) {
  return !e || typeof e != "string" ? {
    isValid: !1,
    error: "Product version must be a non-empty string"
  } : e.trim().length === 0 ? {
    isValid: !1,
    error: "Product version cannot be empty or whitespace only"
  } : e.length > 50 ? {
    isValid: !1,
    error: "Product version cannot exceed 50 characters"
  } : { isValid: !0 };
}
function IV(e) {
  return !e || typeof e != "string" ? {
    isValid: !1,
    error: "Product ID must be a non-empty string"
  } : /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(e) ? { isValid: !0 } : {
    isValid: !1,
    error: "Product ID must be a valid UUID"
  };
}
const { ProductSchema: $, ProductSchemaValidators: UV } = Ga, { NAMES: O } = $, { NAMES_UI_TABS: NV } = $, { NAMES_LICENSED_PRODUCTS: yV } = $, { PRODUCT_MARKETING_NAMES: OV } = $, { PRODUCT_DISPLAY_NAMES: vV } = $, { NAME_VALUES: PV } = $, { TYPES: Mn } = $, { TYPE_VALUES: ka } = $, { PRODUCT_ACCESS_FEATURE_VALUE_TYPES: RV } = $, { DEFAULT_PRODUCT_REGION: aE } = $, { DEFAULT_PRODUCT_TYPE: iE } = $, { ProductStamp: $V } = $, { createProduct: MV } = $, { createProductFromJson: bV } = $, IX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AssetCategorySchema: XS,
  AssetItemSchema: BS,
  AssetSchemaV1: ZS,
  AssetSchemaV2: La,
  CURRENT_PRODUCT_SCHEMA_VERSION: Se,
  DEFAULT_PRODUCT_REGION: aE,
  DEFAULT_PRODUCT_TYPE: iE,
  NAMES: O,
  NAMES_LICENSED_PRODUCTS: yV,
  NAMES_UI_TABS: NV,
  NAME_VALUES: PV,
  PRODUCT_ACCESS_FEATURE_VALUE_TYPES: RV,
  PRODUCT_DISPLAY_NAMES: vV,
  PRODUCT_MARKETING_NAMES: OV,
  ProductSchema: $,
  ProductSchemaConstants: SV,
  ProductSchemaMigrate: fV,
  ProductSchemaValidators: UV,
  ProductStamp: $V,
  ReferenceDatabaseV1Schema: KS,
  TYPES: Mn,
  TYPE_VALUES: ka,
  createEmptyAssetsV2: oV,
  createProduct: MV,
  createProductFromJson: bV,
  ensureLatestAssetVersion: EV,
  ensureLatestProductSchema: da,
  ensureLatestVersion: da,
  findCategoryById: sV,
  getMigrationLogger: nE,
  isAssetsV1: zS,
  isAssetsV2: YS,
  isProductSchemaV1: oE,
  isProductSchemaV2: sE,
  migrateAssetsToLatest: ja,
  migrateProductToLatest: la,
  migrateSchema: $n,
  migrateSchema1to2: xa,
  migrateToLatest: la,
  migrateV1ToV2: tE,
  setMigrationLogger: rE,
  upsertCategory: aV,
  validateAssetsV1: QS,
  validateAssetsV2: Nr,
  validateCategoryIdUniqueness: JS,
  validateProductAssets: DV,
  validateProductCreation: hV,
  validateProductId: IV,
  validateProductName: TV,
  validateProductUpdate: CV,
  validateProductVersionString: gV,
  validateWhitelistedCountries: pV
}, Symbol.toStringTag, { value: "Module" })), { newUUID: VV, currentTime: LV } = U, qV = "1", FV = {
  individual: "individual",
  institutional: "institutional"
}, Ha = l({
  refs: {
    id: null,
    version: null,
    name: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = VV());
    const t = LV();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []);
  }
});
function wV(e) {
  const t = { ...e, objects: {} };
  return Ha(t);
}
function GV(e, t, r, n) {
  return Ha({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n
  });
}
const jV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  COST_CENTER_SCHEMA_VERSION: qV,
  COST_CENTER_TYPES: FV,
  CostCenterStamp: Ha,
  createCostCenter: GV,
  createCostCenterFromJson: wV
}, Symbol.toStringTag, { value: "Module" })), xV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: jV
}, Symbol.toStringTag, { value: "Module" })), { newUUID: Ba, currentTime: bn } = U, Xa = "10", ut = {
  individual: "individual",
  institutional: "institutional"
}, yr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Or = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, vr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, ma = {
  hwa: "hwa"
}, H = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, Ae = "world wide", Le = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Ba()), e.type || (e.type = H.trial);
    const t = bn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = yr.active);
  }
}), Ja = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0,
    authorizedDevicesOverride: null
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {}), e.authorizedDevicesOverride = !1;
  }
}).compose(Le), cE = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Ba()), e.status || (e.status = vr.active);
    const t = bn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), uE = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(Le), dE = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = Ae;
  }
}).compose(Le, Ja), lE = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = Ae;
  }
}).compose(Le, Ja), mE = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(Le, uE), Vn = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = bn();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), SE = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Vn), EE = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Vn), _E = l({
  refs: {}
}).compose(Vn);
function kV(e, t, r, n, o, a, i, c, m, d, p) {
  return cE({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function HV(e, t, r, n) {
  return SE({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function BV(e, t, r, n) {
  return EE({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function XV(e, t, r, n) {
  return _E({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function JV(e, t, r, n = H.release, o = [], a, i = 0, c = {}) {
  return dE({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function WV(e, t, r, n = H.release, o = [], a, i = 0, c = {}) {
  return lE({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function YV(e, t, r, n, o, a, i = H.release, c = []) {
  return mE({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function zV(e, t) {
  e.productAccess.forEach(t);
}
function Ln(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function qn(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function KV(e, t, r = H.release) {
  return Ln(e, _.envoy, t, r);
}
function ZV(e, t = H.release) {
  return Ln(e, _.seqGeq, Ae, t);
}
function QV(e, t = H.release) {
  return Ln(e, _.flowJo, Ae, t);
}
function eL(e) {
  return qn(e, _.envoy);
}
function tL(e) {
  return qn(e, _.seqGeq);
}
function rL(e) {
  return qn(e, _.flowJo);
}
function nL(e, t) {
  return e.users.indexOf(t) > -1;
}
function oL(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const Wa = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    admins: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Ba());
    const t = bn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.admins || (e.admins = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = Xa;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function sL(e) {
  return Wa(e);
}
function Ya(e, t, r, n, o, a, i) {
  return Wa({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function AE(e) {
  return `${e} Individual Cost Center`;
}
function aL(e, t, r) {
  return Ya(
    AE(t),
    e,
    t,
    ut.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function iL(e, t, r, n, o) {
  return Ya(
    e,
    t,
    r,
    ut.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const cL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: yr,
  COST_CENTER_SCHEMA_VERSION: Xa,
  COST_CENTER_TYPES: ut,
  CUSTOM_FIELD_KEY_STATUSES: Or,
  CostCenterStamp: Wa,
  EnvoyLicenseStamp: mE,
  EnvoyUserStamp: _E,
  FlowJoLicenseStamp: lE,
  FlowJoUserStamp: EE,
  GroupsLicenseStamp: uE,
  PRODUCT_ACCESS_TYPES: H,
  ProductAccessStamp: Le,
  ProductAccessUserStamp: Vn,
  SHARED_COMPUTER_IDENTIFIER_TYPES: ma,
  SHARED_COMPUTER_STATUSES: vr,
  SeqGeqLicenseStamp: dE,
  SeqGeqUserStamp: SE,
  SharedComputerStamp: cE,
  UsersLicenseStamp: Ja,
  WORLD_WIDE: Ae,
  createCostCenter: Ya,
  createCostCenterFromJson: sL,
  createEnvoyProductAccess: YV,
  createEnvoyUser: XV,
  createFlowJoProductAccess: WV,
  createFlowJoUser: BV,
  createIndividualCostCenter: aL,
  createInstitutionalCostCenter: iL,
  createSeqGeqProductAccess: JV,
  createSeqGeqUser: HV,
  createSharedComputer: kV,
  findEnvoyProduct: KV,
  findFirstEnvoyProduct: eL,
  findFirstFlowJoProduct: rL,
  findFirstProduct: qn,
  findFirstSeqGeqProduct: tL,
  findFlowJoProduct: QV,
  findProduct: Ln,
  findSeqGeqProduct: ZV,
  getIndividualCostCenterName: AE,
  isUserMemberOfCostCenter: nL,
  isUserMemberOfUserProductAccess: oL,
  iterateProducts: zV
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: qe } = U, fE = 1, hE = 256, CE = 5, DE = 253, pE = 1, TE = 36, gE = 30, IE = 5e3, UE = 400, NE = 100, yE = 20, Fn = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, OE = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < CE || t.length > DE)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), vE = OE.emailDomain(), PE = s.any().valid(Fn.seqGeq).required(), RE = s.any().valid(Fn.flowJo).required(), $E = s.any().valid(Fn.envoy).required(), ME = s.any().valid(Ae).required(), bE = s.any().valid(Ae).required(), VE = s.any().valid(Xa).required(), LE = s.array().items(vE).unique().max(gE).required(), qE = P.nameString().min(fE).max(hE).required(), uL = P.nameString().min(pE).max(TE).required(), dL = Object.keys(ut).map((e) => ut[e]), FE = s.string().valid(...dL).required(), wE = s.array().items(I).max(IE).unique().required(), GE = s.array().items(I).unique().required(), za = s.array().items(I).max(UE).unique().required(), jE = s.array().items(I).max(yE).unique().required(), Ka = h.required(), Za = s.alternatives().try(null, h).required(), xE = E.nonStringNumber().min(0).integer().required(), kE = E.nonStringNumber().min(1).integer().required(), Qa = E.nonStringNumber().min(1).integer().required(), ei = E.nonStringNumber().min(1).integer().required(), ti = E.nonStringNumber().min(1).integer().required(), ri = E.nonStringNumber().min(1).integer().required(), HE = E.nonStringNumber().min(0).integer().required(), lL = Object.keys(yr).map((e) => yr[e]), BE = s.string().valid(...lL).required(), XE = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Or.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), JE = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), mL = Object.keys(Or).map(
  (e) => Or[e]
), WE = s.string().valid(...mL).required(), YE = E.nonStringNumber().min(0).integer().required(), zE = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  required: T,
  status: WE,
  createdAt: D,
  updatedAt: A,
  orderIndex: YE
}), KE = s.alternatives().try("", s.string().max(256)).required(), ZE = s.object().keys({
  id: u,
  keyId: u,
  value: KE,
  createdAt: D,
  updatedAt: A
}), QE = JE.objects().pattern(qe, ZE).idCheck().required(), e_ = XE.customFieldKey().pattern(qe, zE).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), SL = Object.keys(H).map(
  (e) => H[e]
), t_ = s.string().valid(...SL).required(), r_ = E.nonStringNumber().min(0).integer().required(), n_ = s.alternatives().try(null, s.string().uri()).required(), o_ = s.alternatives().try(null, h).required(), s_ = s.alternatives().try(null, h).required(), a_ = s.alternatives().try(null, h).required(), ni = {
  userId: u,
  suspended: T,
  startDate: s_,
  endDate: o_,
  lastUsed: a_,
  customFieldValues: QE
}, EL = Object.keys(vr).map(
  (e) => vr[e]
), i_ = s.string().valid(...EL).required(), _L = Object.keys(ma).map(
  (e) => ma[e]
), c_ = s.string().valid(..._L).required(), u_ = _e.hardwareAddress().required(), d_ = s.object().keys({
  type: c_,
  value: u_
}), l_ = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), m_ = s.alternatives().try(d_).required(), S_ = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  identifier: m_,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: Ka,
  endDate: Za,
  contactLabel: s.alternatives().try(null, s.string().min(1).max(256)),
  status: i_
}), E_ = l_.sharedComputers().pattern(qe, S_).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), __ = s.object().keys({
  ...ni,
  maxBoundDevices: Qa,
  maxAnnualDeviceDeactivations: ei,
  maxSimultaenousSessions: ti,
  offlineDurationDays: ri
}), A_ = s.object().keys({
  ...ni,
  maxBoundDevices: Qa,
  maxAnnualDeviceDeactivations: ei,
  maxSimultaenousSessions: ti,
  offlineDurationDays: ri
}), f_ = s.object().keys({
  ...ni
  // no difference for now, new attributes go here
}), wn = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), h_ = wn.objects().pattern(qe, __).idCheck().startDateCheck().required(), AL = wn.objects().pattern(qe, A_).idCheck().startDateCheck().required(), fL = wn.objects().pattern(qe, f_).idCheck().required(), C_ = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), D_ = C_.product().keys({
  activityState: BE,
  admins: jE,
  createdAt: D,
  endDate: Za,
  id: u,
  owner: u,
  startDate: Ka,
  type: t_,
  updatedAt: A,
  version: g
}), p_ = D_.keys({
  name: $E,
  region: ne,
  groups: za,
  diskSpaceGb: v,
  yearlyDlGb: v
}).dateCheck(), T_ = D_.keys({
  annualChanges: xE,
  maxActiveUsers: kE,
  users: h_,
  logLevel: r_,
  loggingUrl: n_,
  customFieldKeys: e_,
  sharedComputers: E_,
  maxSharedComputers: HE,
  authorizedDevicesOverride: T
}), g_ = T_.keys({
  name: PE,
  region: ME
}).dateCheck(), I_ = T_.keys({
  name: RE,
  region: bE
}).dateCheck(), U_ = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), N_ = U_.products().items(p_, g_, I_).max(NE).idCheck().required(), y_ = s.object().keys({
  id: u,
  name: qE,
  owner: u,
  users: wE,
  admins: GE,
  groups: za,
  countryCode: R,
  type: FE,
  whitelistDomains: LE,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: VE,
  productAccess: N_
});
function hL(e) {
  return !y_.validate(e).error;
}
const CL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: BE,
  AnnualChangesSchema: xE,
  CostCenterAdminsSchema: GE,
  CostCenterGroupsSchema: za,
  CostCenterObjectSchema: y_,
  CostCenterTypesSchema: FE,
  CostCenterUsersSchema: wE,
  CustomFieldKeyOrderSchema: YE,
  CustomFieldKeySchema: zE,
  CustomFieldValueRecordSchema: ZE,
  CustomFieldValueSchema: KE,
  DOMAIN_MAX_LENGTH: DE,
  DOMAIN_MIN_LENGTH: CE,
  EmailDomainValidation: OE,
  EmailDomainValidationSchema: vE,
  EndDateSchema: Za,
  EnvoyNameSchema: $E,
  EnvoyProductSchema: p_,
  EnvoyUserSchema: f_,
  FlowJoNameSchema: RE,
  FlowJoRegionSchema: bE,
  FlowJoSchema: I_,
  FlowJoUserSchema: A_,
  HardwareAddressSchema: u_,
  LogLevelSchema: r_,
  LoggingUrlSchema: n_,
  MAX_COST_CENTER_GROUPS: UE,
  MAX_COST_CENTER_PRODUCTS: NE,
  MAX_COST_CENTER_USERS: IE,
  MAX_PRODUCT_ACCESS_ADMINS: yE,
  MAX_WHITELIST_EMAIL_DOMAINS: gE,
  MaxActiveUsersSchema: kE,
  MaxAnnualDeviceDeactivationsSchema: ei,
  MaxBoundDevicesSchema: Qa,
  MaxSimultaenousSessionsSchema: ti,
  NAME_MAX_LENGTH: hE,
  NAME_MIN_LENGTH: fE,
  NameValidationSchema: qE,
  OfflineDurationDaysSchema: ri,
  PRODUCT_NAMES: Fn,
  ProductAccessAdminsSchema: jE,
  ProductAccessCustomFieldKeysSchema: e_,
  ProductAccessCustomFieldStatusSchema: WE,
  ProductAccessCustomKeyValidator: XE,
  ProductAccessSchema: N_,
  ProductAccessSchemaValidator: U_,
  ProductAccessTypesSchema: t_,
  ProductAccessUserEndDate: o_,
  ProductAccessUserLastUsedDate: a_,
  ProductAccessUserStartDate: s_,
  ProductAccessUsersEnvoySchema: fL,
  ProductAccessUsersFlowJoSchema: AL,
  ProductAccessUsersSeqGeqSchema: h_,
  ProductAccessUsersValidator: wn,
  ProductBaseValidator: C_,
  REGION_MAX_LENGTH: TE,
  REGION_MIN_LENGTH: pE,
  RegionValidationSchema: uL,
  SchemaVersionSchema: VE,
  SeqGeqNameSchema: PE,
  SeqGeqRegionSchema: ME,
  SeqGeqSchema: g_,
  SeqGeqUserSchema: __,
  SharedComputerHWAIdentifierSchema: d_,
  SharedComputerIdentifierSchema: m_,
  SharedComputerIdentifierTypeSchema: c_,
  SharedComputerSchema: S_,
  SharedComputerSchemaValidator: l_,
  SharedComputerStatusSchema: i_,
  SharedComputersMaxSchema: HE,
  SharedComputersSchema: E_,
  StartDateSchema: Ka,
  UserLicenseCustomFieldValuesSchema: QE,
  UserLicenseCustomValueValidator: JE,
  WhilelistDomainsSchema: LE,
  isUserValid: hL
}, Symbol.toStringTag, { value: "Module" })), DL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: cL,
  CostCenterValidators: CL
}, Symbol.toStringTag, { value: "Module" })), { newUUID: oi, currentTime: Gn } = U, si = "11", dt = {
  individual: "individual",
  institutional: "institutional"
}, Pr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Rr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, $r = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, Sa = {
  hwa: "hwa"
}, oe = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, fe = "world wide", jn = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = oi()), e.type || (e.type = oe.trial);
    const t = Gn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Pr.active);
  }
}), ai = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0,
    authorizedDevicesOverride: null
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {}), e.authorizedDevicesOverride = !1;
  }
}).compose(jn), O_ = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = oi()), e.status || (e.status = $r.active);
    const t = Gn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), v_ = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = fe;
  }
}).compose(jn, ai), P_ = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = fe;
  }
}).compose(jn, ai), ii = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = Gn();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), R_ = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(ii), $_ = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(ii);
function pL(e, t, r, n, o, a, i, c, m, d, p) {
  return O_({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function TL(e, t, r, n) {
  return R_({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function gL(e, t, r, n) {
  return $_({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function IL(e, t, r, n = oe.release, o = [], a, i = 0, c = {}) {
  return v_({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function UL(e, t, r, n = oe.release, o = [], a, i = 0, c = {}) {
  return P_({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function NL(e, t) {
  e.productAccess.forEach(t);
}
function ci(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
const ui = (e, t) => e?.productAccess?.find((r) => r.name === t);
function yL(e, t = oe.release) {
  return ci(e, _.seqGeq, fe, t);
}
function OL(e, t = oe.release) {
  return ci(e, _.flowJo, fe, t);
}
function vL(e) {
  return ui(e, _.seqGeq);
}
function PL(e) {
  return ui(e, _.flowJo);
}
function RL(e, t) {
  return e.users.indexOf(t) > -1;
}
function $L(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const di = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    admins: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = oi());
    const t = Gn();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.admins || (e.admins = []), e.productAccess || (e.productAccess = []), e.schemaVersion = si;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function ML(e) {
  return di(e);
}
function li(e, t, r, n, o, a, i) {
  return di({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function M_(e) {
  return `${e} Individual Cost Center`;
}
function bL(e, t, r) {
  return li(
    M_(t),
    e,
    t,
    dt.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function VL(e, t, r, n, o) {
  return li(
    e,
    t,
    r,
    dt.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const LL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Pr,
  COST_CENTER_SCHEMA_VERSION: si,
  COST_CENTER_TYPES: dt,
  CUSTOM_FIELD_KEY_STATUSES: Rr,
  CostCenterStamp: di,
  FlowJoLicenseStamp: P_,
  FlowJoUserStamp: $_,
  PRODUCT_ACCESS_TYPES: oe,
  ProductAccessStamp: jn,
  ProductAccessUserStamp: ii,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Sa,
  SHARED_COMPUTER_STATUSES: $r,
  SeqGeqLicenseStamp: v_,
  SeqGeqUserStamp: R_,
  SharedComputerStamp: O_,
  UsersLicenseStamp: ai,
  WORLD_WIDE: fe,
  createCostCenter: li,
  createCostCenterFromJson: ML,
  createFlowJoProductAccess: UL,
  createFlowJoUser: gL,
  createIndividualCostCenter: bL,
  createInstitutionalCostCenter: VL,
  createSeqGeqProductAccess: IL,
  createSeqGeqUser: TL,
  createSharedComputer: pL,
  findFirstFlowJoProduct: PL,
  findFirstProduct: ui,
  findFirstSeqGeqProduct: vL,
  findFlowJoProduct: OL,
  findProduct: ci,
  findSeqGeqProduct: yL,
  getIndividualCostCenterName: M_,
  isUserMemberOfCostCenter: RL,
  isUserMemberOfUserProductAccess: $L,
  iterateProducts: NL
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Ot } = U, b_ = 1, V_ = 256, L_ = 5, q_ = 253, F_ = 1, w_ = 36, G_ = 100, j_ = 5e3, x_ = 100, k_ = 20, mi = {
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, H_ = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < L_ || t.length > q_)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), B_ = H_.emailDomain(), X_ = s.any().valid(mi.seqGeq).required(), J_ = s.any().valid(mi.flowJo).required(), W_ = s.any().valid(fe).required(), Y_ = s.any().valid(fe).required(), z_ = s.any().valid(si).required(), K_ = s.array().items(B_).unique().max(G_).required(), Z_ = P.nameString().min(b_).max(V_).required(), qL = P.nameString().min(F_).max(w_).required(), FL = Object.keys(dt).map((e) => dt[e]), Q_ = s.string().valid(...FL).required(), eA = s.array().items(I).max(j_).unique().required(), tA = s.array().items(I).unique().required(), rA = s.array().items(I).max(k_).unique().required(), Si = h.required(), Ei = s.alternatives().try(null, h).required(), nA = E.nonStringNumber().min(0).integer().required(), oA = E.nonStringNumber().min(1).integer().required(), _i = E.nonStringNumber().min(1).integer().required(), Ai = E.nonStringNumber().min(1).integer().required(), fi = E.nonStringNumber().min(1).integer().required(), hi = E.nonStringNumber().min(1).integer().required(), sA = E.nonStringNumber().min(0).integer().required(), wL = Object.keys(Pr).map((e) => Pr[e]), aA = s.string().valid(...wL).required(), iA = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Rr.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), cA = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), GL = Object.keys(Rr).map(
  (e) => Rr[e]
), uA = s.string().valid(...GL).required(), dA = E.nonStringNumber().min(0).integer().required(), lA = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  required: T,
  status: uA,
  createdAt: D,
  updatedAt: A,
  orderIndex: dA
}), mA = s.alternatives().try("", s.string().max(256)).required(), SA = s.object().keys({
  id: u,
  keyId: u,
  value: mA,
  createdAt: D,
  updatedAt: A
}), EA = cA.objects().pattern(Ot, SA).idCheck().required(), _A = iA.customFieldKey().pattern(Ot, lA).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), jL = Object.keys(oe).map(
  (e) => oe[e]
), AA = s.string().valid(...jL).required(), fA = E.nonStringNumber().min(0).integer().required(), hA = s.alternatives().try(null, s.string().uri()).required(), CA = s.alternatives().try(null, h).required(), DA = s.alternatives().try(null, h).required(), pA = s.alternatives().try(null, h).required(), TA = {
  userId: u,
  suspended: T,
  startDate: DA,
  endDate: CA,
  lastUsed: pA,
  customFieldValues: EA
}, xL = Object.keys($r).map(
  (e) => $r[e]
), gA = s.string().valid(...xL).required(), kL = Object.keys(Sa).map(
  (e) => Sa[e]
), IA = s.string().valid(...kL).required(), UA = _e.hardwareAddress().required(), NA = s.object().keys({
  type: IA,
  value: UA
}), yA = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), OA = s.alternatives().try(NA).required(), vA = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  identifier: OA,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: Si,
  endDate: Ei,
  contactLabel: s.alternatives().try(null, s.string().min(1).max(256)),
  status: gA
}), PA = yA.sharedComputers().pattern(Ot, vA).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), RA = s.object().keys({
  ...TA,
  maxBoundDevices: _i,
  maxAnnualDeviceDeactivations: Ai,
  maxSimultaenousSessions: fi,
  offlineDurationDays: hi
}), $A = s.object().keys({
  ...TA,
  maxBoundDevices: _i,
  maxAnnualDeviceDeactivations: Ai,
  maxSimultaenousSessions: fi,
  offlineDurationDays: hi
}), Ci = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), MA = Ci.objects().pattern(Ot, RA).idCheck().startDateCheck().required(), HL = Ci.objects().pattern(Ot, $A).idCheck().startDateCheck().required(), bA = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), BL = bA.product().keys({
  activityState: aA,
  admins: rA,
  createdAt: D,
  endDate: Ei,
  id: u,
  owner: u,
  startDate: Si,
  type: AA,
  updatedAt: A,
  version: g
}), VA = BL.keys({
  annualChanges: nA,
  maxActiveUsers: oA,
  users: MA,
  logLevel: fA,
  loggingUrl: hA,
  customFieldKeys: _A,
  sharedComputers: PA,
  maxSharedComputers: sA,
  authorizedDevicesOverride: T
}), LA = VA.keys({
  name: X_,
  region: W_
}).dateCheck(), qA = VA.keys({
  name: J_,
  region: Y_
}).dateCheck(), FA = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), wA = FA.products().items(LA, qA).max(x_).idCheck().required(), GA = s.object().keys({
  id: u,
  name: Z_,
  owner: u,
  users: eA,
  admins: tA,
  countryCode: R,
  type: Q_,
  whitelistDomains: K_,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: z_,
  productAccess: wA
});
function XL(e) {
  return !GA.validate(e).error;
}
const JL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: aA,
  AnnualChangesSchema: nA,
  CostCenterAdminsSchema: tA,
  CostCenterObjectSchema: GA,
  CostCenterTypesSchema: Q_,
  CostCenterUsersSchema: eA,
  CustomFieldKeyOrderSchema: dA,
  CustomFieldKeySchema: lA,
  CustomFieldValueRecordSchema: SA,
  CustomFieldValueSchema: mA,
  DOMAIN_MAX_LENGTH: q_,
  DOMAIN_MIN_LENGTH: L_,
  EmailDomainValidation: H_,
  EmailDomainValidationSchema: B_,
  EndDateSchema: Ei,
  FlowJoNameSchema: J_,
  FlowJoRegionSchema: Y_,
  FlowJoSchema: qA,
  FlowJoUserSchema: $A,
  HardwareAddressSchema: UA,
  LogLevelSchema: fA,
  LoggingUrlSchema: hA,
  MAX_COST_CENTER_PRODUCTS: x_,
  MAX_COST_CENTER_USERS: j_,
  MAX_PRODUCT_ACCESS_ADMINS: k_,
  MAX_WHITELIST_EMAIL_DOMAINS: G_,
  MaxActiveUsersSchema: oA,
  MaxAnnualDeviceDeactivationsSchema: Ai,
  MaxBoundDevicesSchema: _i,
  MaxSimultaenousSessionsSchema: fi,
  NAME_MAX_LENGTH: V_,
  NAME_MIN_LENGTH: b_,
  NameValidationSchema: Z_,
  OfflineDurationDaysSchema: hi,
  PRODUCT_NAMES: mi,
  ProductAccessAdminsSchema: rA,
  ProductAccessCustomFieldKeysSchema: _A,
  ProductAccessCustomFieldStatusSchema: uA,
  ProductAccessCustomKeyValidator: iA,
  ProductAccessSchema: wA,
  ProductAccessSchemaValidator: FA,
  ProductAccessTypesSchema: AA,
  ProductAccessUserEndDate: CA,
  ProductAccessUserLastUsedDate: pA,
  ProductAccessUserStartDate: DA,
  ProductAccessUsersFlowJoSchema: HL,
  ProductAccessUsersSeqGeqSchema: MA,
  ProductAccessUsersValidator: Ci,
  ProductBaseValidator: bA,
  REGION_MAX_LENGTH: w_,
  REGION_MIN_LENGTH: F_,
  RegionValidationSchema: qL,
  SchemaVersionSchema: z_,
  SeqGeqNameSchema: X_,
  SeqGeqRegionSchema: W_,
  SeqGeqSchema: LA,
  SeqGeqUserSchema: RA,
  SharedComputerHWAIdentifierSchema: NA,
  SharedComputerIdentifierSchema: OA,
  SharedComputerIdentifierTypeSchema: IA,
  SharedComputerSchema: vA,
  SharedComputerSchemaValidator: yA,
  SharedComputerStatusSchema: gA,
  SharedComputersMaxSchema: sA,
  SharedComputersSchema: PA,
  StartDateSchema: Si,
  UserLicenseCustomFieldValuesSchema: EA,
  UserLicenseCustomValueValidator: cA,
  WhilelistDomainsSchema: K_,
  isUserValid: XL
}, Symbol.toStringTag, { value: "Module" })), WL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: LL,
  CostCenterValidators: JL
}, Symbol.toStringTag, { value: "Module" })), Di = 2, pi = 1, YL = 3, lt = 90, Ti = 365, gi = 10001, UX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  END_DATE_YEARS_DEFAULT: YL,
  ID_SEQUENCE_START_NUMBER: gi,
  THRESHOLD_DAYS_DEFAULT: lt,
  THRESHOLD_DAYS_MAX: Ti,
  numClientsMin: pi,
  numConnectionsMin: Di
}, Symbol.toStringTag, { value: "Module" })), { newUUID: Fe, currentTime: vt } = U, Ii = "12", mt = {
  individual: "individual",
  institutional: "institutional"
}, Mr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended",
  pending: "pending"
}, br = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, Vr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, Pt = {
  hwa: "hwa",
  fingerprint: "fingerprint",
  fwmEncryptedFingerprint: "fwmEncryptedFingerprint"
}, Re = {
  beta: "Beta",
  release: "Release",
  trial: "Trial",
  training: "Training"
}, xn = "world wide", Ui = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null,
    features: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Fe()), e.type || (e.type = Re.trial);
    const t = vt();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Mr.active), e.features || (e.features = {});
  }
}), jA = l({
  refs: {
    id: null,
    productFeatureId: null,
    name: null,
    value: null,
    valueType: null,
    enabled: null,
    createdAt: null,
    updatedAt: null,
    version: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Fe());
    const t = vt();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.enabled || (e.enabled = !0);
  }
}), xA = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0,
    authorizedDevicesOverride: null
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {}), e.authorizedDevicesOverride = !1;
  }
}).compose(Ui), Ni = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Fe()), e.status || (e.status = Vr.active);
    const t = vt();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), kA = l({
  refs: {
    numConnections: Di,
    numClients: pi,
    autoReview: !1,
    docManage: !1,
    hardwareIdentifier: void 0,
    licenseNumber: void 0,
    renewalId: void 0,
    issueDateUtc: void 0,
    thresholdDays: lt
  },
  init: ({ instance: e }) => {
    e.renewalId || (e.renewalId = Fe()), e.numConnections || (e.numConnections = 2), e.numClients || (e.numClients = 1), e.autoReview || (e.autoReview = !1), e.docManage || (e.docManage = !1), e.thresholdDays || (e.thresholdDays = lt);
  }
}).compose(Ni), HA = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.region = xn;
  }
}).compose(Ui, xA), kn = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = vt();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), BA = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(kn), zL = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(kn), KL = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(kn);
function ZL(e, t, r, n, o, a, i, c, m, d, p, N) {
  return r.type === Pt.fwmEncryptedFingerprint ? kA({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p,
    ...N
  }) : Ni({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function QL(e, t, r, n) {
  return BA({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function eq(e, t, r, n, o = Re.release, a = [], i, c = 0, m = {}) {
  return HA({
    name: e,
    owner: t,
    startDate: r,
    endDate: n,
    type: o,
    admins: a,
    maxActiveUsers: i,
    maxSharedComputers: c,
    sharedComputers: m
  });
}
function tq(e, t, r, n, o) {
  return jA({
    id: Fe(),
    productFeatureId: e,
    name: t,
    value: r,
    valueType: n,
    enabled: o
  });
}
function rq(e, t) {
  e.productAccess.forEach(t);
}
function nq(e, t, r = xn, n = Re.release) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
const oq = (e, t) => e?.productAccess?.find((r) => r.name === t);
function sq(e, t) {
  return e.users.indexOf(t) > -1;
}
function aq(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const yi = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    admins: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Fe());
    const t = vt();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.admins || (e.admins = []), e.productAccess || (e.productAccess = []), e.schemaVersion = Ii;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function iq(e) {
  return yi(e);
}
function Oi(e, t, r, n, o, a, i) {
  return yi({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function XA(e) {
  return `${e} Individual Cost Center`;
}
function cq(e, t, r) {
  return Oi(
    XA(t),
    e,
    t,
    mt.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function uq(e, t, r, n, o) {
  return Oi(
    e,
    t,
    r,
    mt.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const dq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Mr,
  COST_CENTER_SCHEMA_VERSION: Ii,
  COST_CENTER_TYPES: mt,
  CUSTOM_FIELD_KEY_STATUSES: br,
  CostCenterStamp: yi,
  FWMSharedComputerStamp: kA,
  FlowJoUserStamp: KL,
  PRODUCT_ACCESS_TYPES: Re,
  ProductAccessFeatureStamp: jA,
  ProductAccessStamp: Ui,
  ProductAccessUserStamp: kn,
  ProductLicenseStamp: HA,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Pt,
  SHARED_COMPUTER_STATUSES: Vr,
  SeqGeqUserStamp: zL,
  SharedComputerStamp: Ni,
  UsersLicenseStamp: xA,
  WORLD_WIDE: xn,
  createCostCenter: Oi,
  createCostCenterFromJson: iq,
  createIndividualCostCenter: cq,
  createInstitutionalCostCenter: uq,
  createProductAccess: eq,
  createProductAccessFeature: tq,
  createProductUser: QL,
  createSharedComputer: ZL,
  findFirstProduct: oq,
  findProduct: nq,
  getIndividualCostCenterName: XA,
  isUserMemberOfCostCenter: sq,
  isUserMemberOfUserProductAccess: aq,
  iterateProducts: rq,
  productUserStamp: BA
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Rt } = U, JA = 1, WA = 256, YA = 5, zA = 253, KA = 1, ZA = 36, QA = 100, ef = 5e3, tf = 100, rf = 20, nf = {
  envoy: "Envoy",
  cloud: "Cloud",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo",
  infinicytRuo: "InfinicytRuo",
  infinicytIvd: "InfinicytIvd",
  infinicytEa: "InfinicytEa",
  infinicytIuo: "InfinicytIuo",
  facsWorkflowManager: "FacsWorkflowManager",
  bdrc: "Bdrc"
}, of = Array.from(Object.values(nf)), sf = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < YA || t.length > zA)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), af = sf.emailDomain(), cf = s.any().valid(...of).required(), uf = s.any().valid(xn).required(), df = s.any().valid(Ii).required(), lf = s.array().items(af).unique().max(QA).required(), mf = P.nameString().min(JA).max(WA).required(), lq = P.nameString().min(KA).max(ZA).required(), mq = Object.keys(mt).map((e) => mt[e]), Sf = s.string().valid(...mq).required(), Ef = s.array().items(I).max(ef).unique().required(), _f = s.array().items(I).unique().required(), Af = s.array().items(I).max(rf).unique().required(), ff = Array.from(
  Object.values(An)
), hf = s.any().valid(...ff).required(), Cf = s.alternatives().try(
  T,
  // boolean
  E.nonStringNumber(),
  // number
  s.string().max(256),
  // string
  h
  // date
), Df = s.object().keys({
  id: u,
  productFeatureId: u,
  name: s.string().min(1).max(256).required(),
  value: Cf,
  valueType: hf,
  enabled: T,
  createdAt: D,
  updatedAt: A,
  version: g
}), pf = s.extend((e) => ({
  base: e.object(),
  type: "productFeatures",
  messages: {
    idCheck: "mismatching key-id to object-id",
    productFeaturesNameDuplicateCheck: "duplicate feature name detected in product features"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("productFeatures.idCheck") : t;
      }
    },
    productFeaturesNameDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.name) && (o = !0), n.push(i.name);
        }), o ? r.error("productFeatures.productFeaturesNameDuplicateCheck") : t;
      }
    }
  }
})), Tf = pf.productFeatures().pattern(Rt, [Df]).idCheck().productFeaturesNameDuplicateCheck().required(), vi = h.required(), Pi = s.alternatives().try(null, h).required(), gf = E.nonStringNumber().min(0).integer().required(), If = E.nonStringNumber().min(1).integer().required(), Uf = E.nonStringNumber().min(1).integer().required(), Nf = E.nonStringNumber().min(0).integer().required(), yf = E.nonStringNumber().min(1).integer().required(), Of = E.nonStringNumber().min(1).integer().required(), vf = E.nonStringNumber().min(0).integer().required(), Sq = Object.keys(Mr).map((e) => Mr[e]), Pf = s.string().valid(...Sq).required(), Rf = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === br.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), $f = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), Eq = Object.keys(br).map(
  (e) => br[e]
), Mf = s.string().valid(...Eq).required(), bf = E.nonStringNumber().min(0).integer().required(), Vf = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  required: T,
  status: Mf,
  createdAt: D,
  updatedAt: A,
  orderIndex: bf
}), Lf = s.alternatives().try("", s.string().max(256)).required(), qf = s.object().keys({
  id: u,
  keyId: u,
  value: Lf,
  createdAt: D,
  updatedAt: A
}), Ff = $f.objects().pattern(Rt, qf).idCheck().required(), wf = Rf.customFieldKey().pattern(Rt, Vf).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), _q = Object.keys(Re).map(
  (e) => Re[e]
), Gf = s.string().valid(..._q).required(), jf = E.nonStringNumber().min(0).integer().required(), xf = s.alternatives().try(null, s.string().uri()).required(), kf = s.alternatives().try(null, h).required(), Hf = s.alternatives().try(null, h).required(), Bf = s.alternatives().try(null, h).required(), Aq = {
  userId: u,
  suspended: T,
  startDate: Hf,
  endDate: kf,
  lastUsed: Bf,
  customFieldValues: Ff
}, fq = Object.keys(Vr).map(
  (e) => Vr[e]
), Xf = s.string().valid(...fq).required(), Jf = s.string().valid(Pt.hwa).required(), Wf = s.string().valid(Pt.fingerprint).required(), Yf = s.string().valid(Pt.fwmEncryptedFingerprint).required(), zf = s.string().min(1).required(), Kf = _e.hardwareAddress().required(), Zf = Ma.fingerprint().required(), Qf = s.object().keys({
  type: Jf,
  value: Kf
}), eh = s.object().keys({
  type: Wf,
  value: Zf
}), th = s.object().keys({
  type: Yf,
  value: zf
}), rh = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), nh = s.alternatives().try(
  Qf,
  eh,
  th
).required(), Ri = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  identifier: nh,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: vi,
  endDate: Pi,
  contactLabel: s.alternatives().try(null, s.string().min(1).max(256)),
  status: Xf
}), oh = E.nonStringNumber().min(0).integer().required(), sh = E.nonStringNumber().min(0).integer().required(), ah = Ri.append({
  endDate: h.required(),
  docManage: T.required(),
  autoReview: T.required(),
  numClients: oh,
  numConnections: sh,
  licenseNumber: E.nonStringNumber().min(gi).required(),
  hardwareIdentifier: s.string().min(1).required(),
  renewalId: I.required(),
  issueDateUtc: h.required(),
  thresholdDays: E.nonStringNumber().min(0).max(Ti).integer().required()
}), ih = rh.sharedComputers().pattern(Rt, [Ri, ah]).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), ch = s.object().keys({
  ...Aq,
  maxBoundDevices: Uf,
  maxAnnualDeviceDeactivations: Nf,
  maxSimultaenousSessions: yf,
  offlineDurationDays: Of
}), uh = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), dh = uh.objects().pattern(Rt, ch).idCheck().startDateCheck().required(), lh = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), hq = lh.product().keys({
  activityState: Pf,
  admins: Af,
  createdAt: D,
  endDate: Pi,
  id: u,
  owner: u,
  startDate: vi,
  type: Gf,
  updatedAt: A,
  version: g,
  features: Tf
}), Cq = hq.keys({
  annualChanges: gf,
  maxActiveUsers: If,
  users: dh,
  logLevel: jf,
  loggingUrl: xf,
  customFieldKeys: wf,
  sharedComputers: ih,
  maxSharedComputers: vf,
  authorizedDevicesOverride: T
}), mh = Cq.keys({
  name: cf,
  region: uf
}).dateCheck(), Sh = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), Eh = Sh.products().items(mh).max(tf).idCheck().required(), _h = s.object().keys({
  id: u,
  name: mf,
  owner: u,
  users: Ef,
  admins: _f,
  countryCode: R,
  type: Sf,
  whitelistDomains: lf,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: df,
  productAccess: Eh
});
function Dq(e) {
  return !_h.validate(e).error;
}
const pq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Pf,
  AnnualChangesSchema: gf,
  CostCenterAdminsSchema: _f,
  CostCenterObjectSchema: _h,
  CostCenterTypesSchema: Sf,
  CostCenterUsersSchema: Ef,
  CustomFieldKeyOrderSchema: bf,
  CustomFieldKeySchema: Vf,
  CustomFieldValueRecordSchema: qf,
  CustomFieldValueSchema: Lf,
  DOMAIN_MAX_LENGTH: zA,
  DOMAIN_MIN_LENGTH: YA,
  EmailDomainValidation: sf,
  EmailDomainValidationSchema: af,
  EndDateSchema: Pi,
  FWMEncryptedFingerprintSchema: zf,
  FWMEncryptedSharedComputerFingerprintIdentifierSchema: th,
  FacsWorkflowSharedComputerSchema: ah,
  FingerprintSchema: Zf,
  HardwareAddressSchema: Kf,
  LogLevelSchema: jf,
  LoggingUrlSchema: xf,
  MAX_COST_CENTER_PRODUCTS: tf,
  MAX_COST_CENTER_USERS: ef,
  MAX_PRODUCT_ACCESS_ADMINS: rf,
  MAX_WHITELIST_EMAIL_DOMAINS: QA,
  MaxActiveUsersSchema: If,
  MaxAnnualDeviceDeactivationsSchema: Nf,
  MaxBoundDevicesSchema: Uf,
  MaxClientsSchema: oh,
  MaxConnectionsSchema: sh,
  MaxSimultaenousSessionsSchema: yf,
  NAME_MAX_LENGTH: WA,
  NAME_MIN_LENGTH: JA,
  NameValidationSchema: mf,
  OfflineDurationDaysSchema: Of,
  PRODUCT_NAMES: nf,
  PRODUCT_NAMES_LIST: of,
  ProductAccessAdminsSchema: Af,
  ProductAccessCustomFieldKeysSchema: wf,
  ProductAccessCustomFieldStatusSchema: Mf,
  ProductAccessCustomKeyValidator: Rf,
  ProductAccessFeatureTypeSchema: hf,
  ProductAccessFeatureValueSchema: Cf,
  ProductAccessFeatureValueTypesList: ff,
  ProductAccessSchema: Eh,
  ProductAccessSchemaValidator: Sh,
  ProductAccessTypesSchema: Gf,
  ProductAccessUserEndDate: kf,
  ProductAccessUserLastUsedDate: Bf,
  ProductAccessUserStartDate: Hf,
  ProductAccessUsersProductSchema: dh,
  ProductAccessUsersValidator: uh,
  ProductBaseValidator: lh,
  ProductFeatureSchema: Df,
  ProductFeaturesSchema: Tf,
  ProductFeaturesSchemaValidator: pf,
  ProductNameSchema: cf,
  ProductRegionSchema: uf,
  ProductSchema: mh,
  ProductUserSchema: ch,
  REGION_MAX_LENGTH: ZA,
  REGION_MIN_LENGTH: KA,
  RegionValidationSchema: lq,
  SchemaVersionSchema: df,
  SharedComputerFWMIdentifierTypeSchema: Yf,
  SharedComputerFingerprintIdentifierSchema: eh,
  SharedComputerFingerprintIdentifierTypeSchema: Wf,
  SharedComputerHWAIdentifierSchema: Qf,
  SharedComputerHWAIdentifierTypeSchema: Jf,
  SharedComputerIdentifierSchema: nh,
  SharedComputerSchema: Ri,
  SharedComputerSchemaValidator: rh,
  SharedComputerStatusSchema: Xf,
  SharedComputersMaxSchema: vf,
  SharedComputersSchema: ih,
  StartDateSchema: vi,
  UserLicenseCustomFieldValuesSchema: Ff,
  UserLicenseCustomValueValidator: $f,
  WhilelistDomainsSchema: lf,
  isUserValid: Dq
}, Symbol.toStringTag, { value: "Module" })), Tq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: dq,
  CostCenterValidators: pq
}, Symbol.toStringTag, { value: "Module" })), { newUUID: we, currentTime: $t } = U, $i = "13", St = {
  individual: "individual",
  institutional: "institutional"
}, Lr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended",
  pending: "pending"
}, qr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, Fr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, Ee = {
  hwa: "hwa",
  fingerprint: "fingerprint",
  fwmEncryptedFingerprint: "fwmEncryptedFingerprint"
}, $e = {
  beta: "Beta",
  release: "Release",
  trial: "Trial",
  training: "Training"
}, Hn = "world wide", Bn = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null,
    features: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = we()), e.type || (e.type = $e.trial);
    const t = $t();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Lr.active), e.features || (e.features = {});
  }
}), Mi = l({
  refs: {
    id: null,
    productFeatureId: null,
    name: null,
    value: null,
    valueType: null,
    enabled: null,
    createdAt: null,
    updatedAt: null,
    version: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = we());
    const t = $t();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.enabled || (e.enabled = !0);
  }
}), bi = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0,
    authorizedDevicesOverride: null
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {}), e.authorizedDevicesOverride = !1;
  }
}).compose(Bn), Xn = l({
  refs: {
    id: null,
    label: null,
    identifiers: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = we()), e.status || (e.status = Fr.active);
    const t = $t();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), Vi = l({
  refs: {
    numConnections: Di,
    numClients: pi,
    autoReview: !1,
    docManage: !1,
    hardwareIdentifier: void 0,
    licenseNumber: void 0,
    renewalId: void 0,
    issueDateUtc: void 0,
    thresholdDays: lt
  },
  init: ({ instance: e }) => {
    e.renewalId || (e.renewalId = we()), e.numConnections || (e.numConnections = 2), e.numClients || (e.numClients = 1), e.autoReview || (e.autoReview = !1), e.docManage || (e.docManage = !1), e.thresholdDays || (e.thresholdDays = lt);
  }
}).compose(Xn), Li = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.region = Hn;
  }
}).compose(Bn, bi), Mt = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = $t();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), qi = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Mt), Ah = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Mt), fh = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Mt);
function gq(e, t, r, n, o, a, i, c, m, d, p, N) {
  return r && r.some(
    (M) => M.type === Ee.fwmEncryptedFingerprint
  ) ? Vi({
    id: e,
    label: t,
    identifiers: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p,
    ...N
  }) : Xn({
    id: e,
    label: t,
    identifiers: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function Iq(e, t, r, n) {
  return qi({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function Uq(e, t, r, n, o = $e.release, a = [], i, c = 0, m = {}) {
  return Li({
    name: e,
    owner: t,
    startDate: r,
    endDate: n,
    type: o,
    admins: a,
    maxActiveUsers: i,
    maxSharedComputers: c,
    sharedComputers: m
  });
}
function Nq(e, t, r, n, o) {
  return Mi({
    id: we(),
    productFeatureId: e,
    name: t,
    value: r,
    valueType: n,
    enabled: o
  });
}
function yq(e, t) {
  e.productAccess.forEach(t);
}
function Oq(e, t, r = Hn, n = $e.release) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
const vq = (e, t) => e?.productAccess?.find((r) => r.name === t);
function Pq(e, t) {
  return e.users.indexOf(t) > -1;
}
function Rq(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const Jn = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    admins: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = we());
    const t = $t();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.admins || (e.admins = []), e.productAccess || (e.productAccess = []), e.schemaVersion = $i;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function $q(e) {
  return Jn(e);
}
function Fi(e, t, r, n, o, a, i) {
  return Jn({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function hh(e) {
  return `${e} Individual Cost Center`;
}
function Mq(e, t, r) {
  return Fi(
    hh(t),
    e,
    t,
    St.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function bq(e, t, r, n, o) {
  return Fi(
    e,
    t,
    r,
    St.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const wi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Lr,
  COST_CENTER_SCHEMA_VERSION: $i,
  COST_CENTER_TYPES: St,
  CUSTOM_FIELD_KEY_STATUSES: qr,
  CostCenterStamp: Jn,
  FWMSharedComputerStamp: Vi,
  FlowJoUserStamp: fh,
  PRODUCT_ACCESS_TYPES: $e,
  ProductAccessFeatureStamp: Mi,
  ProductAccessStamp: Bn,
  ProductAccessUserStamp: Mt,
  ProductLicenseStamp: Li,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ee,
  SHARED_COMPUTER_STATUSES: Fr,
  SeqGeqUserStamp: Ah,
  SharedComputerStamp: Xn,
  UsersLicenseStamp: bi,
  WORLD_WIDE: Hn,
  createCostCenter: Fi,
  createCostCenterFromJson: $q,
  createIndividualCostCenter: Mq,
  createInstitutionalCostCenter: bq,
  createProductAccess: Uq,
  createProductAccessFeature: Nq,
  createProductUser: Iq,
  createSharedComputer: gq,
  findFirstProduct: vq,
  findProduct: Oq,
  getIndividualCostCenterName: hh,
  isUserMemberOfCostCenter: Pq,
  isUserMemberOfUserProductAccess: Rq,
  iterateProducts: yq,
  productUserStamp: qi
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: bt } = U, Ch = 1, Dh = 256, ph = 5, Th = 253, gh = 1, Ih = 36, Uh = 100, Nh = 5e3, Gi = 100, yh = 20, Oh = {
  envoy: "Envoy",
  cloud: "Cloud",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo",
  infinicytRuo: "InfinicytRuo",
  infinicytIvd: "InfinicytIvd",
  // CE-IVD
  infinicytUsIvd: "InfinicytUsIvd",
  // US-IVD
  infinicytEa: "InfinicytEa",
  infinicytIuo: "InfinicytIuo",
  facsWorkflowManager: "FacsWorkflowManager",
  bdrc: "Bdrc"
}, vh = Array.from(Object.values(Oh)), Ph = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < ph || t.length > Th)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), Rh = Ph.emailDomain(), ji = s.any().valid(...vh).required(), xi = s.any().valid(Hn).required(), $h = s.any().valid($i).required(), Mh = s.array().items(Rh).unique().max(Uh).required(), bh = P.nameString().min(Ch).max(Dh).required(), Vq = P.nameString().min(gh).max(Ih).required(), Lq = Object.keys(St).map((e) => St[e]), Vh = s.string().valid(...Lq).required(), Lh = s.array().items(I).max(Nh).unique().required(), qh = s.array().items(I).unique().required(), ki = s.array().items(I).max(yh).unique().required(), Fh = Array.from(
  Object.values(An)
), wh = s.any().valid(...Fh).required(), Gh = s.alternatives().try(
  T,
  // boolean
  E.nonStringNumber(),
  // number
  s.string().max(256),
  // string
  h
  // date
), jh = s.object().keys({
  id: u,
  productFeatureId: u,
  name: s.string().min(1).max(256).required(),
  value: Gh,
  valueType: wh,
  enabled: T,
  createdAt: D,
  updatedAt: A,
  version: g
}), xh = s.extend((e) => ({
  base: e.object(),
  type: "productFeatures",
  messages: {
    idCheck: "mismatching key-id to object-id",
    productFeaturesNameDuplicateCheck: "duplicate feature name detected in product features"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("productFeatures.idCheck") : t;
      }
    },
    productFeaturesNameDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.name) && (o = !0), n.push(i.name);
        }), o ? r.error("productFeatures.productFeaturesNameDuplicateCheck") : t;
      }
    }
  }
})), Hi = xh.productFeatures().pattern(bt, [jh]).idCheck().productFeaturesNameDuplicateCheck().required(), Wn = h.required(), Yn = s.alternatives().try(null, h).required(), Bi = E.nonStringNumber().min(0).integer().required(), Xi = E.nonStringNumber().min(1).integer().required(), kh = E.nonStringNumber().min(1).integer().required(), Hh = E.nonStringNumber().min(0).integer().required(), Bh = E.nonStringNumber().min(1).integer().required(), Xh = E.nonStringNumber().min(1).integer().required(), Ji = E.nonStringNumber().min(0).integer().required(), qq = Object.keys(Lr).map((e) => Lr[e]), Wi = s.string().valid(...qq).required(), Jh = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === qr.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), Wh = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), Fq = Object.keys(qr).map(
  (e) => qr[e]
), Yh = s.string().valid(...Fq).required(), zh = E.nonStringNumber().min(0).integer().required(), Kh = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  required: T,
  status: Yh,
  createdAt: D,
  updatedAt: A,
  orderIndex: zh
}), Zh = s.alternatives().try("", s.string().max(256)).required(), Qh = s.object().keys({
  id: u,
  keyId: u,
  value: Zh,
  createdAt: D,
  updatedAt: A
}), eC = Wh.objects().pattern(bt, Qh).idCheck().required(), Yi = Jh.customFieldKey().pattern(bt, Kh).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), wq = Object.keys($e).map(
  (e) => $e[e]
), zi = s.string().valid(...wq).required(), Ki = E.nonStringNumber().min(0).integer().required(), Zi = s.alternatives().try(null, s.string().uri()).required(), tC = s.alternatives().try(null, h).required(), rC = s.alternatives().try(null, h).required(), nC = s.alternatives().try(null, h).required(), Gq = {
  userId: u,
  suspended: T,
  startDate: rC,
  endDate: tC,
  lastUsed: nC,
  customFieldValues: eC
}, jq = Object.keys(Fr).map(
  (e) => Fr[e]
), oC = s.string().valid(...jq).required(), sC = s.string().valid(Ee.hwa).required(), aC = s.string().valid(Ee.fingerprint).required(), iC = s.string().valid(Ee.fwmEncryptedFingerprint).required(), cC = s.string().min(1).required(), uC = _e.hardwareAddress().required(), dC = Ma.fingerprint().required(), lC = s.object({
  type: sC,
  value: uC
}), mC = s.object().keys({
  type: aC,
  value: dC
}), SC = s.object().keys({
  type: iC,
  value: cC
}), EC = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), _C = s.extend((e) => ({
  base: e.array(),
  type: "sharedComputersIdentifiers",
  messages: {
    duplicateTypes: "Shared computer identifiers array may only have one of each identifier type",
    noMixingFWM: "Shared computer identifiers array may not mix FWM and non-FWM identifiers",
    nonEmpty: "Shared computer identifiers array must not be empty"
  },
  rules: {
    duplicateTypeCheck: {
      validate(t, r) {
        let n = !1;
        return t.forEach((o) => {
          const { type: a } = o;
          t.filter((i) => i.type === a).length > 1 && (n = !0);
        }), n ? r.error("duplicateTypes") : t;
      }
    },
    noMixingFWMCheck: {
      validate(t, r) {
        const n = t.some(
          (a) => a.type === Ee.fwmEncryptedFingerprint
        ), o = t.some(
          (a) => a.type !== Ee.fwmEncryptedFingerprint
        );
        return n && o ? r.error("noMixingFWM") : t;
      }
    },
    nonEmptyCheck: {
      validate(t, r) {
        return t.length === 0 ? r.error("nonEmpty") : t;
      }
    }
  }
})), AC = _C.sharedComputersIdentifiers().duplicateTypeCheck().nonEmptyCheck().noMixingFWMCheck().items(
  s.alternatives().try(
    lC,
    mC,
    SC
  )
), Qi = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  identifiers: AC,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: Wn,
  endDate: Yn,
  contactLabel: s.alternatives().try(null, s.string().min(1).max(256)),
  status: oC
}), fC = E.nonStringNumber().min(0).integer().required(), hC = E.nonStringNumber().min(0).integer().required(), CC = Qi.append({
  endDate: h.required(),
  docManage: T.required(),
  autoReview: T.required(),
  numClients: fC,
  numConnections: hC,
  licenseNumber: E.nonStringNumber().min(gi).required(),
  hardwareIdentifier: s.string().min(1).required(),
  renewalId: I.required(),
  issueDateUtc: h.required(),
  thresholdDays: E.nonStringNumber().min(0).max(Ti).integer().required()
}), ec = EC.sharedComputers().pattern(bt, [Qi, CC]).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), DC = s.object().keys({
  ...Gq,
  maxBoundDevices: kh,
  maxAnnualDeviceDeactivations: Hh,
  maxSimultaenousSessions: Bh,
  offlineDurationDays: Xh
}), pC = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), TC = pC.objects().pattern(bt, DC).idCheck().startDateCheck().required(), gC = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), xq = gC.product().keys({
  activityState: Wi,
  admins: ki,
  createdAt: D,
  endDate: Yn,
  id: u,
  owner: u,
  startDate: Wn,
  type: zi,
  updatedAt: A,
  version: g,
  features: Hi
}), kq = xq.keys({
  annualChanges: Bi,
  maxActiveUsers: Xi,
  users: TC,
  logLevel: Ki,
  loggingUrl: Zi,
  customFieldKeys: Yi,
  sharedComputers: ec,
  maxSharedComputers: Ji,
  authorizedDevicesOverride: T
}), IC = kq.keys({
  name: ji,
  region: xi
}).dateCheck(), UC = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), NC = UC.products().items(IC).max(Gi).idCheck().required(), tc = s.object().keys({
  id: u,
  name: bh,
  owner: u,
  users: Lh,
  admins: qh,
  countryCode: R,
  type: Vh,
  whitelistDomains: Mh,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: $h,
  productAccess: NC
});
function Hq(e) {
  return !tc.validate(e).error;
}
const C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Wi,
  AnnualChangesSchema: Bi,
  CostCenterAdminsSchema: qh,
  CostCenterObjectSchema: tc,
  CostCenterTypesSchema: Vh,
  CostCenterUsersSchema: Lh,
  CustomFieldKeyOrderSchema: zh,
  CustomFieldKeySchema: Kh,
  CustomFieldValueRecordSchema: Qh,
  CustomFieldValueSchema: Zh,
  DOMAIN_MAX_LENGTH: Th,
  DOMAIN_MIN_LENGTH: ph,
  EmailDomainValidation: Ph,
  EmailDomainValidationSchema: Rh,
  EndDateSchema: Yn,
  FWMEncryptedFingerprintSchema: cC,
  FWMEncryptedSharedComputerFingerprintIdentifierSchema: SC,
  FacsWorkflowSharedComputerSchema: CC,
  FingerprintSchema: dC,
  HardwareAddressSchema: uC,
  LogLevelSchema: Ki,
  LoggingUrlSchema: Zi,
  MAX_COST_CENTER_PRODUCTS: Gi,
  MAX_COST_CENTER_USERS: Nh,
  MAX_PRODUCT_ACCESS_ADMINS: yh,
  MAX_WHITELIST_EMAIL_DOMAINS: Uh,
  MaxActiveUsersSchema: Xi,
  MaxAnnualDeviceDeactivationsSchema: Hh,
  MaxBoundDevicesSchema: kh,
  MaxClientsSchema: fC,
  MaxConnectionsSchema: hC,
  MaxSimultaenousSessionsSchema: Bh,
  NAME_MAX_LENGTH: Dh,
  NAME_MIN_LENGTH: Ch,
  NameValidationSchema: bh,
  OfflineDurationDaysSchema: Xh,
  PRODUCT_NAMES: Oh,
  PRODUCT_NAMES_LIST: vh,
  ProductAccessAdminsSchema: ki,
  ProductAccessCustomFieldKeysSchema: Yi,
  ProductAccessCustomFieldStatusSchema: Yh,
  ProductAccessCustomKeyValidator: Jh,
  ProductAccessFeatureTypeSchema: wh,
  ProductAccessFeatureValueSchema: Gh,
  ProductAccessFeatureValueTypesList: Fh,
  ProductAccessSchema: NC,
  ProductAccessSchemaValidator: UC,
  ProductAccessTypesSchema: zi,
  ProductAccessUserEndDate: tC,
  ProductAccessUserLastUsedDate: nC,
  ProductAccessUserStartDate: rC,
  ProductAccessUsersProductSchema: TC,
  ProductAccessUsersValidator: pC,
  ProductBaseValidator: gC,
  ProductFeatureSchema: jh,
  ProductFeaturesSchema: Hi,
  ProductFeaturesSchemaValidator: xh,
  ProductNameSchema: ji,
  ProductRegionSchema: xi,
  ProductSchema: IC,
  ProductUserSchema: DC,
  REGION_MAX_LENGTH: Ih,
  REGION_MIN_LENGTH: gh,
  RegionValidationSchema: Vq,
  SchemaVersionSchema: $h,
  SharedComputerFWMIdentifierTypeSchema: iC,
  SharedComputerFingerprintIdentifierSchema: mC,
  SharedComputerFingerprintIdentifierTypeSchema: aC,
  SharedComputerHWAIdentifierSchema: lC,
  SharedComputerHWAIdentifierTypeSchema: sC,
  SharedComputerIdentifiersSchema: AC,
  SharedComputerIdentifiersSchemaValidator: _C,
  SharedComputerSchema: Qi,
  SharedComputerSchemaValidator: EC,
  SharedComputerStatusSchema: oC,
  SharedComputersMaxSchema: Ji,
  SharedComputersSchema: ec,
  StartDateSchema: Wn,
  UserLicenseCustomFieldValuesSchema: eC,
  UserLicenseCustomValueValidator: Wh,
  WhilelistDomainsSchema: Mh,
  isUserValid: Hq
}, Symbol.toStringTag, { value: "Module" })), Bq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: wi,
  CostCenterValidators: C
}, Symbol.toStringTag, { value: "Module" })), Vt = "14", {
  COST_CENTER_TYPES: x,
  ACTIVITY_STATES: se,
  CUSTOM_FIELD_KEY_STATUSES: rc,
  SHARED_COMPUTER_STATUSES: ve,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ge,
  PRODUCT_ACCESS_TYPES: k,
  WORLD_WIDE: nc
} = wi, oc = l({}).compose(Bn), sc = l({}).compose(Mi), ac = l({}).compose(bi), ic = l({}).compose(Xn), cc = l({}).compose(Vi), uc = l({}).compose(Li), je = l({
  refs: {
    archivedDate: null
    // null means not archived
  }
}).compose(Mt), zn = l({}).compose(qi).compose(je), dc = l({}).compose(Ah).compose(je), lc = l({}).compose(fh, je), Lt = l({}).compose(Jn).compose(
  l({
    init: ({ instance: e }) => {
      e.schemaVersion = Vt;
    }
  })
), {
  createSharedComputer: mc,
  createProductAccess: Sc,
  createProductAccessFeature: Ec,
  iterateProducts: _c,
  findProduct: Ac,
  findFirstProduct: fc,
  isUserMemberOfCostCenter: hc,
  isUserMemberOfUserProductAccess: Cc,
  getIndividualCostCenterName: Kn
} = wi;
function Dc(e, t, r, n) {
  return zn({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function pc(e) {
  return Lt(e);
}
function qt(e, t, r, n, o, a, i) {
  return Lt({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function Tc(e, t, r) {
  return qt(
    Kn(t),
    e,
    t,
    x.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function gc(e, t, r, n, o) {
  return qt(
    e,
    t,
    r,
    x.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const Xq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: se,
  COST_CENTER_SCHEMA_VERSION: Vt,
  COST_CENTER_TYPES: x,
  CUSTOM_FIELD_KEY_STATUSES: rc,
  CostCenterStamp: Lt,
  FWMSharedComputerStamp: cc,
  FlowJoUserStamp: lc,
  PRODUCT_ACCESS_TYPES: k,
  ProductAccessFeatureStamp: sc,
  ProductAccessStamp: oc,
  ProductAccessUserStamp: je,
  ProductLicenseStamp: uc,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ge,
  SHARED_COMPUTER_STATUSES: ve,
  SeqGeqUserStamp: dc,
  SharedComputerStamp: ic,
  UsersLicenseStamp: ac,
  WORLD_WIDE: nc,
  createCostCenter: qt,
  createCostCenterFromJson: pc,
  createIndividualCostCenter: Tc,
  createInstitutionalCostCenter: gc,
  createProductAccess: Sc,
  createProductAccessFeature: Ec,
  createProductUser: Dc,
  createSharedComputer: mc,
  findFirstProduct: fc,
  findProduct: Ac,
  getIndividualCostCenterName: Kn,
  isUserMemberOfCostCenter: hc,
  isUserMemberOfUserProductAccess: Cc,
  iterateProducts: _c,
  productUserStamp: zn
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Jq } = U, { NAME_MIN_LENGTH: Ic } = C, { NAME_MAX_LENGTH: Uc } = C, { DOMAIN_MIN_LENGTH: Nc } = C, { DOMAIN_MAX_LENGTH: yc } = C, { REGION_MIN_LENGTH: Oc } = C, { REGION_MAX_LENGTH: vc } = C, { MAX_WHITELIST_EMAIL_DOMAINS: Pc } = C, { MAX_COST_CENTER_USERS: Rc } = C, { MAX_COST_CENTER_PRODUCTS: $c } = C, { MAX_PRODUCT_ACCESS_ADMINS: Mc } = C, { PRODUCT_NAMES: bc } = C, { PRODUCT_NAMES_LIST: Zn } = C, { EmailDomainValidation: Vc } = C, { EmailDomainValidationSchema: Lc } = C, { ProductNameSchema: qc } = C, { ProductRegionSchema: Fc } = C, Qn = s.any().valid(Vt).required(), { WhilelistDomainsSchema: wc } = C, { NameValidationSchema: xe } = C, { RegionValidationSchema: Gc } = C, { CostCenterTypesSchema: jc } = C, { CostCenterUsersSchema: xc } = C, { CostCenterAdminsSchema: kc } = C, { ProductAccessAdminsSchema: Hc } = C, { ProductAccessFeatureValueTypesList: Bc } = C, { ProductAccessFeatureTypeSchema: Xc } = C, { ProductAccessFeatureValueSchema: Jc } = C, { ProductFeatureSchema: Wc } = C, { ProductFeaturesSchemaValidator: Yc } = C, { ProductFeaturesSchema: zc } = C, { StartDateSchema: Kc } = C, { EndDateSchema: Zc } = C, { AnnualChangesSchema: Qc } = C, { MaxActiveUsersSchema: eu } = C, { MaxBoundDevicesSchema: eo } = C, { MaxAnnualDeviceDeactivationsSchema: to } = C, { MaxSimultaenousSessionsSchema: ro } = C, { OfflineDurationDaysSchema: no } = C, { SharedComputersMaxSchema: tu } = C, { ActivityStatesSchema: ru } = C, { ProductAccessCustomKeyValidator: nu } = C, { UserLicenseCustomValueValidator: ou } = C, { ProductAccessCustomFieldStatusSchema: su } = C, { CustomFieldKeyOrderSchema: au } = C, { CustomFieldKeySchema: iu } = C, { CustomFieldValueSchema: cu } = C, { CustomFieldValueRecordSchema: uu } = C, { UserLicenseCustomFieldValuesSchema: oo } = C, { ProductAccessCustomFieldKeysSchema: du } = C, { ProductAccessTypesSchema: lu } = C, { LogLevelSchema: mu } = C, { LoggingUrlSchema: Su } = C, { ProductAccessUserEndDate: so } = C, { ProductAccessUserStartDate: ao } = C, { ProductAccessUserLastUsedDate: io } = C, co = s.alternatives().try(null, h).required(), Wq = {
  userId: u,
  suspended: T,
  startDate: ao,
  endDate: so,
  lastUsed: io,
  customFieldValues: oo,
  archivedDate: co
  // New in v14
}, { SharedComputerStatusSchema: Eu } = C, { SharedComputerHWAIdentifierTypeSchema: _u } = C, { SharedComputerFingerprintIdentifierTypeSchema: Au } = C, { SharedComputerFWMIdentifierTypeSchema: fu } = C, { FWMEncryptedFingerprintSchema: hu } = C, { HardwareAddressSchema: Cu } = C, { FingerprintSchema: Du } = C, { SharedComputerHWAIdentifierSchema: pu } = C, { SharedComputerFingerprintIdentifierSchema: Tu } = C, { FWMEncryptedSharedComputerFingerprintIdentifierSchema: gu } = C, { SharedComputerSchemaValidator: Iu } = C, { SharedComputerIdentifiersSchemaValidator: Uu } = C, { SharedComputerIdentifiersSchema: Nu } = C, { SharedComputerSchema: yu } = C, { MaxClientsSchema: Ou } = C, { MaxConnectionsSchema: vu } = C, { FacsWorkflowSharedComputerSchema: Pu } = C, { SharedComputersSchema: Ru } = C, uo = s.object().keys({
  ...Wq,
  maxBoundDevices: eo,
  maxAnnualDeviceDeactivations: to,
  maxSimultaenousSessions: ro,
  offlineDurationDays: no
}), lo = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    "objects.idMismatch": "incorrect user id",
    "objects.overlappingActiveDates": "endDate exists before startDate",
    "objects.archivedDateBeforeStartDate": "archivedDate must be after user startDate",
    "objects.archivedDateMissingEndDate": "endDate must be non-null when user is archived",
    "objects.archivedDateAfterEndDate": "endDate must be at or before archivedDate when user is archived"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    },
    archivedDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n];
            if (o.archivedDate) {
              const a = new Date(o.archivedDate).valueOf(), i = new Date(o.startDate).valueOf();
              if (a <= i)
                return r.error("objects.archivedDateBeforeStartDate");
              if (!o.endDate)
                return r.error("objects.archivedDateMissingEndDate");
              if (new Date(o.endDate).valueOf() > a)
                return r.error("objects.archivedDateAfterEndDate");
            }
          }
          return t;
        }
      }
    }
  }
})), mo = lo.objects().pattern(Jq, uo).idCheck().startDateCheck().archivedDateCheck().required(), { ProductBaseValidator: So } = C, Yq = So.product().keys({
  activityState: Wi,
  admins: ki,
  createdAt: D,
  endDate: Yn,
  id: u,
  owner: u,
  startDate: Wn,
  type: zi,
  updatedAt: A,
  version: g,
  features: Hi
}), zq = Yq.keys({
  annualChanges: Bi,
  maxActiveUsers: Xi,
  users: mo,
  // v14: Use v14's schema with archivedDate
  logLevel: Ki,
  loggingUrl: Zi,
  customFieldKeys: Yi,
  sharedComputers: ec,
  maxSharedComputers: Ji,
  authorizedDevicesOverride: T
}), Eo = zq.keys({
  name: ji,
  region: xi
}).dateCheck(), { ProductAccessSchemaValidator: _o } = C, Ao = _o.products().items(Eo).max(Gi).idCheck().required(), $u = tc.keys({
  schemaVersion: Qn,
  productAccess: Ao
  // v14: Use v14's ProductAccessSchema with archivedDate
}), { isUserValid: Mu } = C, Kq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: ru,
  AnnualChangesSchema: Qc,
  CostCenterAdminsSchema: kc,
  CostCenterObjectSchema: $u,
  CostCenterTypesSchema: jc,
  CostCenterUsersSchema: xc,
  CustomFieldKeyOrderSchema: au,
  CustomFieldKeySchema: iu,
  CustomFieldValueRecordSchema: uu,
  CustomFieldValueSchema: cu,
  DOMAIN_MAX_LENGTH: yc,
  DOMAIN_MIN_LENGTH: Nc,
  EmailDomainValidation: Vc,
  EmailDomainValidationSchema: Lc,
  EndDateSchema: Zc,
  FWMEncryptedFingerprintSchema: hu,
  FWMEncryptedSharedComputerFingerprintIdentifierSchema: gu,
  FacsWorkflowSharedComputerSchema: Pu,
  FingerprintSchema: Du,
  HardwareAddressSchema: Cu,
  LogLevelSchema: mu,
  LoggingUrlSchema: Su,
  MAX_COST_CENTER_PRODUCTS: $c,
  MAX_COST_CENTER_USERS: Rc,
  MAX_PRODUCT_ACCESS_ADMINS: Mc,
  MAX_WHITELIST_EMAIL_DOMAINS: Pc,
  MaxActiveUsersSchema: eu,
  MaxAnnualDeviceDeactivationsSchema: to,
  MaxBoundDevicesSchema: eo,
  MaxClientsSchema: Ou,
  MaxConnectionsSchema: vu,
  MaxSimultaenousSessionsSchema: ro,
  NAME_MAX_LENGTH: Uc,
  NAME_MIN_LENGTH: Ic,
  NameValidationSchema: xe,
  OfflineDurationDaysSchema: no,
  PRODUCT_NAMES: bc,
  PRODUCT_NAMES_LIST: Zn,
  ProductAccessAdminsSchema: Hc,
  ProductAccessCustomFieldKeysSchema: du,
  ProductAccessCustomFieldStatusSchema: su,
  ProductAccessCustomKeyValidator: nu,
  ProductAccessFeatureTypeSchema: Xc,
  ProductAccessFeatureValueSchema: Jc,
  ProductAccessFeatureValueTypesList: Bc,
  ProductAccessSchema: Ao,
  ProductAccessSchemaValidator: _o,
  ProductAccessTypesSchema: lu,
  ProductAccessUserArchivedDate: co,
  ProductAccessUserEndDate: so,
  ProductAccessUserLastUsedDate: io,
  ProductAccessUserStartDate: ao,
  ProductAccessUsersProductSchema: mo,
  ProductAccessUsersValidator: lo,
  ProductBaseValidator: So,
  ProductFeatureSchema: Wc,
  ProductFeaturesSchema: zc,
  ProductFeaturesSchemaValidator: Yc,
  ProductNameSchema: qc,
  ProductRegionSchema: Fc,
  ProductSchema: Eo,
  ProductUserSchema: uo,
  REGION_MAX_LENGTH: vc,
  REGION_MIN_LENGTH: Oc,
  RegionValidationSchema: Gc,
  SchemaVersionSchema: Qn,
  SharedComputerFWMIdentifierTypeSchema: fu,
  SharedComputerFingerprintIdentifierSchema: Tu,
  SharedComputerFingerprintIdentifierTypeSchema: Au,
  SharedComputerHWAIdentifierSchema: pu,
  SharedComputerHWAIdentifierTypeSchema: _u,
  SharedComputerIdentifiersSchema: Nu,
  SharedComputerIdentifiersSchemaValidator: Uu,
  SharedComputerSchema: yu,
  SharedComputerSchemaValidator: Iu,
  SharedComputerStatusSchema: Eu,
  SharedComputersMaxSchema: tu,
  SharedComputersSchema: Ru,
  StartDateSchema: Kc,
  UserLicenseCustomFieldValuesSchema: oo,
  UserLicenseCustomValueValidator: ou,
  WhilelistDomainsSchema: wc,
  isUserValid: Mu
}, Symbol.toStringTag, { value: "Module" })), Zq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: Xq,
  CostCenterValidators: Kq
}, Symbol.toStringTag, { value: "Module" })), { newUUID: yC, currentTime: OC } = U, bu = "2", Et = {
  individual: "individual",
  institutional: "institutional"
}, wr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, ae = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, Vu = "world wide", Ft = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = yC()), e.type || (e.type = ae.trial);
    const t = OC();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = wr.active);
  }
}), vC = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {});
  }
}).compose(Ft), PC = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(Ft), RC = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = Vu;
  }
}).compose(Ft, vC), $C = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    monthlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(Ft, PC), MC = l({
  refs: {
    userId: null,
    endDate: null,
    maxBoundDevices: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
});
function Qq(e, t = null) {
  return MC({ userId: e, endDate: t });
}
function eF(e, t, r, n = ae.release, o = []) {
  return RC({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o
  });
}
function tF(e, t, r, n, o, a, i = ae.release, c = []) {
  return $C({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    monthlyDlGb: a,
    admins: c,
    type: i
  });
}
function Lu(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function rF(e, t, r = ae.release) {
  return Lu(e, _.envoy, t, r);
}
function nF(e, t = ae.release) {
  return Lu(e, _.seqGeq, Vu, t);
}
const qu = l({
  refs: {
    id: null,
    version: null,
    name: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = yC());
    const t = OC();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = bu;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function oF(e) {
  const t = { ...e, objects: {} };
  return qu(t);
}
function Fu(e, t, r, n) {
  return qu({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n
  });
}
function sF(e, t, r) {
  return Fu(e, t, r, Et.individual);
}
function aF(e, t, r) {
  return Fu(e, t, r, Et.institutional);
}
const iF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: wr,
  COST_CENTER_SCHEMA_VERSION: bu,
  COST_CENTER_TYPES: Et,
  CostCenterStamp: qu,
  EnvoyLicenseStamp: $C,
  GroupsLicenseStamp: PC,
  PRODUCT_ACCESS_TYPES: ae,
  ProductAccessStamp: Ft,
  ProductAccessUserStamp: MC,
  SeqGeqLicenseStamp: RC,
  UsersLicenseStamp: vC,
  WORLD_WIDE: Vu,
  createCostCenter: Fu,
  createCostCenterFromJson: oF,
  createEnvoyProductAccess: tF,
  createIndividualCostCenter: sF,
  createInstitutionalCostCenter: aF,
  createProductAccessUser: Qq,
  createSeqGeqProductAccess: eF,
  findEnvoyProduct: rF,
  findProduct: Lu,
  findSeqGeqProduct: nF
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: cF } = U, bC = 1, VC = 256, LC = 5, qC = 253, FC = 1, wC = 36, GC = 30, jC = 5e3, xC = 400, kC = 100, HC = 20, wu = {
  envoy: "Envoy",
  seqGeq: "SeqGeq"
}, uF = s.extend((e) => ({
  base: e.string(),
  type: "string",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  rules: {
    nameString: {
      validate(t, r) {
        return t.match(/[\^\/:\*\?<>\\\|]/) ? r.error(f.INVALID_CHARS_SYMBOLS) : t.match(/[\r\n\f]/) ? r.error(f.NEW_LINE) : t.match(/[\t\b]/) ? r.error(f.TABS) : t.match(/ {2}/) ? r.error(f.CONSECUTIVE_SPACES) : t.match(/^\s|\s$/) ? r.error(f.LEADING_OR_TRAILING_SPACES) : t;
      }
    }
  }
})), BC = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < LC || t.length > qC)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), XC = BC.emailDomain(), JC = s.any().valid(wu.seqGeq).required(), WC = s.any().valid(wu.envoy).required(), YC = s.any().valid(bu).required(), zC = s.array().items(XC).unique().max(GC).required(), KC = P.nameString().min(bC).max(VC).required(), Gu = P.nameString().min(FC).max(wC).required(), dF = Object.keys(Et).map((e) => Et[e]), ZC = s.string().valid(...dF).required(), QC = s.array().items(I).max(jC).unique().required(), ju = s.array().items(I).max(xC).unique().required(), xu = s.array().items(I).max(HC).unique().required(), ku = h.required(), Hu = s.alternatives().try(null, h).required(), eD = E.nonStringNumber().min(0).integer().required(), tD = E.nonStringNumber().min(1).integer().required(), rD = E.nonStringNumber().min(1).integer().required(), nD = E.nonStringNumber().min(1).integer().required(), oD = E.nonStringNumber().min(1).integer().required(), lF = Object.keys(wr).map((e) => wr[e]), Bu = s.string().valid(...lF).required(), mF = Object.keys(ae).map(
  (e) => ae[e]
), Xu = s.string().valid(...mF).required(), sD = E.nonStringNumber().min(0).integer().required(), aD = s.alternatives().try(null, s.string().uri()).required(), iD = s.alternatives().try(null, h).required(), cD = s.object().keys({
  userId: u,
  endDate: iD,
  maxBoundDevices: rD,
  maxSimultaenousSessions: nD,
  offlineDurationDays: oD
}), uD = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    }
  }
})), dD = uD.objects().pattern(cF, cD).idCheck().required(), Ju = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("product.overlappingDates");
        }
        return t;
      }
    }
  }
})), lD = Ju.product().keys({
  id: u,
  name: WC,
  type: Xu,
  owner: u,
  region: Gu,
  groups: ju,
  admins: xu,
  startDate: ku,
  endDate: Hu,
  activityState: Bu,
  diskSpaceGb: v,
  monthlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), mD = Ju.product().keys({
  id: u,
  name: JC,
  type: Xu,
  owner: u,
  annualChanges: eD,
  maxActiveUsers: tD,
  users: dD,
  region: Gu,
  admins: xu,
  startDate: ku,
  endDate: Hu,
  activityState: Bu,
  logLevel: sD,
  loggingUrl: aD,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), SD = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), ED = SD.products().items(lD, mD).max(kC).idCheck().required(), _D = s.object().keys({
  id: u,
  name: KC,
  owner: u,
  users: QC,
  groups: ju,
  type: ZC,
  whitelistDomains: zC,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: YC,
  productAccess: ED
});
function SF(e) {
  return !_D.validate(e).error;
}
const EF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Bu,
  AnnualChangesSchema: eD,
  CostCenterGroupsSchema: ju,
  CostCenterObjectSchema: _D,
  CostCenterTypesSchema: ZC,
  CostCenterUsersSchema: QC,
  DOMAIN_MAX_LENGTH: qC,
  DOMAIN_MIN_LENGTH: LC,
  EmailDomainValidation: BC,
  EmailDomainValidationSchema: XC,
  EndDateSchema: Hu,
  EnvoyNameSchema: WC,
  EnvoyProductSchema: lD,
  LogLevelSchema: sD,
  LoggingUrlSchema: aD,
  MAX_COST_CENTER_GROUPS: xC,
  MAX_COST_CENTER_PRODUCTS: kC,
  MAX_COST_CENTER_USERS: jC,
  MAX_PRODUCT_ACCESS_ADMINS: HC,
  MAX_WHITELIST_EMAIL_DOMAINS: GC,
  MaxActiveUsersSchema: tD,
  MaxBoundDevicesSchema: rD,
  MaxSimultaenousSessionsSchema: nD,
  NAME_MAX_LENGTH: VC,
  NAME_MIN_LENGTH: bC,
  NameString: uF,
  NameValidationSchema: KC,
  OfflineDurationDaysSchema: oD,
  PRODUCT_NAMES: wu,
  ProductAccessAdminsSchema: xu,
  ProductAccessSchema: ED,
  ProductAccessSchemaValidator: SD,
  ProductAccessTypesSchema: Xu,
  ProductAccessUserEndDate: iD,
  ProductAccessUserSchema: cD,
  ProductAccessUsersSchema: dD,
  ProductAccessUsersValidator: uD,
  ProductBaseValidator: Ju,
  REGION_MAX_LENGTH: wC,
  REGION_MIN_LENGTH: FC,
  RegionValidationSchema: Gu,
  SchemaVersionSchema: YC,
  SeqGeqNameSchema: JC,
  SeqGeqSchema: mD,
  StartDateSchema: ku,
  WhilelistDomainsSchema: zC,
  isUserValid: SF
}, Symbol.toStringTag, { value: "Module" })), _F = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: iF,
  CostCenterValidators: EF
}, Symbol.toStringTag, { value: "Module" })), { newUUID: AD, currentTime: fD } = U, Wu = "3", _t = {
  individual: "individual",
  institutional: "institutional"
}, Gr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, ie = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, fo = "world wide", wt = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = AD()), e.type || (e.type = ie.trial);
    const t = fD();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Gr.active);
  }
}), hD = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {});
  }
}).compose(wt), CD = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(wt), DD = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = fo;
  }
}).compose(wt, hD), pD = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    monthlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(wt, CD), TD = l({
  refs: {
    userId: null,
    endDate: null,
    maxBoundDevices: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
});
function AF(e, t = null) {
  return TD({ userId: e, endDate: t });
}
function fF(e, t, r, n = ie.release, o = []) {
  return DD({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o
  });
}
function hF(e, t, r, n, o, a, i = ie.release, c = []) {
  return pD({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    monthlyDlGb: a,
    admins: c,
    type: i
  });
}
function CF(e, t) {
  e.productAccess.forEach(t);
}
function Yu(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function DF(e, t, r = ie.release) {
  return Yu(e, _.envoy, t, r);
}
function pF(e, t = ie.release) {
  return Yu(e, _.seqGeq, fo, t);
}
function TF(e, t) {
  return e.users.indexOf(t) > -1;
}
function gF(e, t) {
  if (!e || !e.productAccess)
    return null;
  for (const r of e.productAccess)
    if (r.groups && r.groups.indexOf(t) >= 0)
      return r.id;
  return null;
}
const zu = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = AD());
    const t = fD();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = Wu;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function IF(e) {
  return zu(e);
}
function Ku(e, t, r, n, o) {
  return zu({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o
  });
}
function UF(e, t, r, n) {
  return Ku(e, t, r, _t.individual, n);
}
function NF(e, t, r, n) {
  return Ku(
    e,
    t,
    r,
    _t.institutional,
    n
  );
}
const yF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Gr,
  COST_CENTER_SCHEMA_VERSION: Wu,
  COST_CENTER_TYPES: _t,
  CostCenterStamp: zu,
  EnvoyLicenseStamp: pD,
  GroupsLicenseStamp: CD,
  PRODUCT_ACCESS_TYPES: ie,
  ProductAccessStamp: wt,
  ProductAccessUserStamp: TD,
  SeqGeqLicenseStamp: DD,
  UsersLicenseStamp: hD,
  WORLD_WIDE: fo,
  createCostCenter: Ku,
  createCostCenterFromJson: IF,
  createEnvoyProductAccess: hF,
  createIndividualCostCenter: UF,
  createInstitutionalCostCenter: NF,
  createProductAccessUser: AF,
  createSeqGeqProductAccess: fF,
  findEnvoyProduct: DF,
  findProduct: Yu,
  findSeqGeqProduct: pF,
  isUserMemberOfCostCenter: TF,
  iterateProducts: CF,
  productAccessIdForGroup: gF
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: OF } = U, gD = 1, ID = 256, UD = 5, ND = 253, yD = 1, OD = 36, vD = 30, PD = 5e3, RD = 400, $D = 100, MD = 20, Zu = {
  envoy: "Envoy",
  seqGeq: "SeqGeq"
}, Qu = s.extend((e) => ({
  base: e.string(),
  type: "string",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  rules: {
    nameString: {
      validate(t, r) {
        return t.match(/[\^\/:\*\?<>\\\|]/) ? r.error(f.INVALID_CHARS_SYMBOLS) : t.match(/[\r\n\f]/) ? r.error(f.NEW_LINE) : t.match(/[\t\b]/) ? r.error(f.TABS) : t.match(/ {2}/) ? r.error(f.CONSECUTIVE_SPACES) : t.match(/^\s|\s$/) ? r.error(f.LEADING_OR_TRAILING_SPACES) : t;
      }
    }
  }
})), bD = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < UD || t.length > ND)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), VD = bD.emailDomain(), LD = s.any().valid(Zu.seqGeq).required(), qD = s.any().valid(Zu.envoy).required(), FD = s.any().valid(fo).required(), wD = s.any().valid(Wu).required(), GD = s.array().items(VD).unique().max(vD).required(), jD = Qu.string().nameString().min(gD).max(ID).required(), vF = Qu.string().nameString().min(yD).max(OD).required(), PF = Object.keys(_t).map((e) => _t[e]), xD = s.string().valid(...PF).required(), kD = s.array().items(I).max(PD).unique().required(), ed = s.array().items(I).max(RD).unique().required(), td = s.array().items(I).max(MD).unique().required(), rd = h.required(), nd = s.alternatives().try(null, h).required(), HD = E.nonStringNumber().min(0).integer().required(), BD = E.nonStringNumber().min(1).integer().required(), XD = E.nonStringNumber().min(1).integer().required(), JD = E.nonStringNumber().min(1).integer().required(), WD = E.nonStringNumber().min(1).integer().required(), RF = Object.keys(Gr).map((e) => Gr[e]), od = s.string().valid(...RF).required(), $F = Object.keys(ie).map(
  (e) => ie[e]
), sd = s.string().valid(...$F).required(), YD = E.nonStringNumber().min(0).integer().required(), zD = s.alternatives().try(null, s.string().uri()).required(), KD = s.alternatives().try(null, h).required(), ZD = s.object().keys({
  userId: u,
  endDate: KD,
  maxBoundDevices: XD,
  maxSimultaenousSessions: JD,
  offlineDurationDays: WD
}), QD = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    }
  }
})), ep = QD.objects().pattern(OF, ZD).idCheck().required(), ad = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), tp = ad.product().keys({
  id: u,
  name: qD,
  type: sd,
  owner: u,
  region: ne,
  groups: ed,
  admins: td,
  startDate: rd,
  endDate: nd,
  activityState: od,
  diskSpaceGb: v,
  monthlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), rp = ad.product().keys({
  id: u,
  name: LD,
  type: sd,
  owner: u,
  annualChanges: HD,
  maxActiveUsers: BD,
  users: ep,
  region: FD,
  admins: td,
  startDate: rd,
  endDate: nd,
  activityState: od,
  logLevel: YD,
  loggingUrl: zD,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), np = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), op = np.products().items(tp, rp).max($D).idCheck().required(), sp = s.object().keys({
  id: u,
  name: jD,
  owner: u,
  users: kD,
  groups: ed,
  countryCode: R,
  type: xD,
  whitelistDomains: GD,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: wD,
  productAccess: op
});
function MF(e) {
  return !sp.validate(e).error;
}
const bF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: od,
  AnnualChangesSchema: HD,
  CostCenterGroupsSchema: ed,
  CostCenterObjectSchema: sp,
  CostCenterTypesSchema: xD,
  CostCenterUsersSchema: kD,
  DOMAIN_MAX_LENGTH: ND,
  DOMAIN_MIN_LENGTH: UD,
  EmailDomainValidation: bD,
  EmailDomainValidationSchema: VD,
  EndDateSchema: nd,
  EnvoyNameSchema: qD,
  EnvoyProductSchema: tp,
  LogLevelSchema: YD,
  LoggingUrlSchema: zD,
  MAX_COST_CENTER_GROUPS: RD,
  MAX_COST_CENTER_PRODUCTS: $D,
  MAX_COST_CENTER_USERS: PD,
  MAX_PRODUCT_ACCESS_ADMINS: MD,
  MAX_WHITELIST_EMAIL_DOMAINS: vD,
  MaxActiveUsersSchema: BD,
  MaxBoundDevicesSchema: XD,
  MaxSimultaenousSessionsSchema: JD,
  NAME_MAX_LENGTH: ID,
  NAME_MIN_LENGTH: gD,
  NameString: Qu,
  NameValidationSchema: jD,
  OfflineDurationDaysSchema: WD,
  PRODUCT_NAMES: Zu,
  ProductAccessAdminsSchema: td,
  ProductAccessSchema: op,
  ProductAccessSchemaValidator: np,
  ProductAccessTypesSchema: sd,
  ProductAccessUserEndDate: KD,
  ProductAccessUserSchema: ZD,
  ProductAccessUsersSchema: ep,
  ProductAccessUsersValidator: QD,
  ProductBaseValidator: ad,
  REGION_MAX_LENGTH: OD,
  REGION_MIN_LENGTH: yD,
  RegionValidationSchema: vF,
  SchemaVersionSchema: wD,
  SeqGeqNameSchema: LD,
  SeqGeqRegionSchema: FD,
  SeqGeqSchema: rp,
  StartDateSchema: rd,
  WhilelistDomainsSchema: GD,
  isUserValid: MF
}, Symbol.toStringTag, { value: "Module" })), VF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: yF,
  CostCenterValidators: bF
}, Symbol.toStringTag, { value: "Module" })), { newUUID: ap, currentTime: id } = U, cd = "4", At = {
  individual: "individual",
  institutional: "institutional"
}, jr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, B = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, he = "world wide", ke = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ap()), e.type || (e.type = B.trial);
    const t = id();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = jr.active);
  }
}), ud = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1);
  }
}).compose(ke), ip = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(ke), cp = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = he;
  }
}).compose(ke, ud), up = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = he;
  }
}).compose(ke, ud), dp = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(ke, ip), ho = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null
  },
  init: ({ instance: e }) => {
    const t = id();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null);
  }
}), lp = l({
  refs: {
    maxBoundDevices: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(ho), mp = l({
  refs: {
    maxBoundDevices: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(ho), Sp = l({
  refs: {}
}).compose(ho);
function LF(e, t, r, n) {
  return lp({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function qF(e, t, r, n) {
  return mp({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function FF(e, t, r, n) {
  return Sp({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function wF(e, t, r, n = B.release, o = [], a) {
  return cp({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function GF(e, t, r, n = B.release, o = [], a) {
  return up({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function jF(e, t, r, n, o, a, i = B.release, c = []) {
  return dp({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function xF(e, t) {
  e.productAccess.forEach(t);
}
function Co(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function Do(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function kF(e, t, r = B.release) {
  return Co(e, _.envoy, t, r);
}
function HF(e, t = B.release) {
  return Co(e, _.seqGeq, he, t);
}
function BF(e, t = B.release) {
  return Co(e, _.flowJo, he, t);
}
function XF(e) {
  return Do(e, _.envoy);
}
function JF(e) {
  return Do(e, _.seqGeq);
}
function WF(e) {
  return Do(e, _.flowJo);
}
function YF(e, t) {
  return e.users.indexOf(t) > -1;
}
function zF(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const dd = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ap());
    const t = id();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = cd;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function KF(e) {
  return dd(e);
}
function ld(e, t, r, n, o) {
  return dd({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o
  });
}
function ZF(e, t, r, n) {
  return ld(e, t, r, At.individual, n);
}
function QF(e, t, r, n) {
  return ld(
    e,
    t,
    r,
    At.institutional,
    n
  );
}
const ew = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: jr,
  COST_CENTER_SCHEMA_VERSION: cd,
  COST_CENTER_TYPES: At,
  CostCenterStamp: dd,
  EnvoyLicenseStamp: dp,
  EnvoyUserStamp: Sp,
  FlowJoLicenseStamp: up,
  FlowJoUserStamp: mp,
  GroupsLicenseStamp: ip,
  PRODUCT_ACCESS_TYPES: B,
  ProductAccessStamp: ke,
  ProductAccessUserStamp: ho,
  SeqGeqLicenseStamp: cp,
  SeqGeqUserStamp: lp,
  UsersLicenseStamp: ud,
  WORLD_WIDE: he,
  createCostCenter: ld,
  createCostCenterFromJson: KF,
  createEnvoyProductAccess: jF,
  createEnvoyUser: FF,
  createFlowJoProductAccess: GF,
  createFlowJoUser: qF,
  createIndividualCostCenter: ZF,
  createInstitutionalCostCenter: QF,
  createSeqGeqProductAccess: wF,
  createSeqGeqUser: LF,
  findEnvoyProduct: kF,
  findFirstEnvoyProduct: XF,
  findFirstFlowJoProduct: WF,
  findFirstProduct: Do,
  findFirstSeqGeqProduct: JF,
  findFlowJoProduct: BF,
  findProduct: Co,
  findSeqGeqProduct: HF,
  isUserMemberOfCostCenter: YF,
  isUserMemberOfUserProductAccess: zF,
  iterateProducts: xF
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: md } = U, Ep = 1, _p = 256, Ap = 5, fp = 253, hp = 1, Cp = 36, Dp = 30, pp = 5e3, Tp = 400, gp = 100, Ip = 20, po = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, Sd = s.extend((e) => ({
  base: e.string(),
  type: "string",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  rules: {
    nameString: {
      validate(t, r) {
        return t.match(/[\^\/:\*\?<>\\\|]/) ? r.error(f.INVALID_CHARS_SYMBOLS) : t.match(/[\r\n\f]/) ? r.error(f.NEW_LINE) : t.match(/[\t\b]/) ? r.error(f.TABS) : t.match(/ {2}/) ? r.error(f.CONSECUTIVE_SPACES) : t.match(/^\s|\s$/) ? r.error(f.LEADING_OR_TRAILING_SPACES) : t;
      }
    }
  }
})), Up = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < Ap || t.length > fp)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), Np = Up.emailDomain(), yp = s.any().valid(po.seqGeq).required(), Op = s.any().valid(po.flowJo).required(), vp = s.any().valid(po.envoy).required(), Pp = s.any().valid(he).required(), Rp = s.any().valid(he).required(), $p = s.any().valid(cd).required(), Mp = s.array().items(Np).unique().max(Dp).required(), bp = Sd.string().nameString().min(Ep).max(_p).required(), tw = Sd.string().nameString().min(hp).max(Cp).required(), rw = Object.keys(At).map((e) => At[e]), Vp = s.string().valid(...rw).required(), Lp = s.array().items(I).max(pp).unique().required(), Ed = s.array().items(I).max(Tp).unique().required(), To = s.array().items(I).max(Ip).unique().required(), go = h.required(), Io = s.alternatives().try(null, h).required(), _d = E.nonStringNumber().min(0).integer().required(), Ad = E.nonStringNumber().min(1).integer().required(), fd = E.nonStringNumber().min(1).integer().required(), hd = E.nonStringNumber().min(1).integer().required(), Cd = E.nonStringNumber().min(1).integer().required(), nw = Object.keys(jr).map((e) => jr[e]), Uo = s.string().valid(...nw).required(), ow = Object.keys(B).map(
  (e) => B[e]
), No = s.string().valid(...ow).required(), Dd = E.nonStringNumber().min(0).integer().required(), pd = s.alternatives().try(null, s.string().uri()).required(), qp = s.alternatives().try(null, h).required(), Fp = s.alternatives().try(null, h).required(), wp = s.alternatives().try(null, h).required(), Td = {
  userId: u,
  suspended: T,
  startDate: Fp,
  endDate: qp,
  lastUsed: wp
}, Gp = s.object().keys({
  ...Td,
  maxBoundDevices: fd,
  maxSimultaenousSessions: hd,
  offlineDurationDays: Cd
}), jp = s.object().keys({
  ...Td,
  maxBoundDevices: fd,
  maxSimultaenousSessions: hd,
  offlineDurationDays: Cd
}), xp = s.object().keys({
  ...Td
  // no difference for now, new attributes go here
}), yo = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), kp = yo.objects().pattern(md, Gp).idCheck().startDateCheck().required(), Hp = yo.objects().pattern(md, jp).idCheck().startDateCheck().required(), sw = yo.objects().pattern(md, xp).idCheck().required(), Oo = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), Bp = Oo.product().keys({
  id: u,
  name: vp,
  type: No,
  owner: u,
  region: ne,
  groups: Ed,
  admins: To,
  startDate: go,
  endDate: Io,
  activityState: Uo,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), Xp = Oo.product().keys({
  id: u,
  name: yp,
  type: No,
  owner: u,
  annualChanges: _d,
  maxActiveUsers: Ad,
  users: kp,
  region: Pp,
  admins: To,
  startDate: go,
  endDate: Io,
  activityState: Uo,
  logLevel: Dd,
  loggingUrl: pd,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), Jp = Oo.product().keys({
  id: u,
  name: Op,
  type: No,
  owner: u,
  annualChanges: _d,
  maxActiveUsers: Ad,
  users: Hp,
  region: Rp,
  admins: To,
  startDate: go,
  endDate: Io,
  activityState: Uo,
  logLevel: Dd,
  loggingUrl: pd,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), Wp = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), Yp = Wp.products().items(Bp, Xp, Jp).max(gp).idCheck().required(), zp = s.object().keys({
  id: u,
  name: bp,
  owner: u,
  users: Lp,
  groups: Ed,
  countryCode: R,
  type: Vp,
  whitelistDomains: Mp,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: $p,
  productAccess: Yp
});
function aw(e) {
  return !zp.validate(e).error;
}
const iw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Uo,
  AnnualChangesSchema: _d,
  CostCenterGroupsSchema: Ed,
  CostCenterObjectSchema: zp,
  CostCenterTypesSchema: Vp,
  CostCenterUsersSchema: Lp,
  DOMAIN_MAX_LENGTH: fp,
  DOMAIN_MIN_LENGTH: Ap,
  EmailDomainValidation: Up,
  EmailDomainValidationSchema: Np,
  EndDateSchema: Io,
  EnvoyNameSchema: vp,
  EnvoyProductSchema: Bp,
  EnvoyUserSchema: xp,
  FlowJoNameSchema: Op,
  FlowJoRegionSchema: Rp,
  FlowJoSchema: Jp,
  FlowJoUserSchema: jp,
  LogLevelSchema: Dd,
  LoggingUrlSchema: pd,
  MAX_COST_CENTER_GROUPS: Tp,
  MAX_COST_CENTER_PRODUCTS: gp,
  MAX_COST_CENTER_USERS: pp,
  MAX_PRODUCT_ACCESS_ADMINS: Ip,
  MAX_WHITELIST_EMAIL_DOMAINS: Dp,
  MaxActiveUsersSchema: Ad,
  MaxBoundDevicesSchema: fd,
  MaxSimultaenousSessionsSchema: hd,
  NAME_MAX_LENGTH: _p,
  NAME_MIN_LENGTH: Ep,
  NameString: Sd,
  NameValidationSchema: bp,
  OfflineDurationDaysSchema: Cd,
  PRODUCT_NAMES: po,
  ProductAccessAdminsSchema: To,
  ProductAccessSchema: Yp,
  ProductAccessSchemaValidator: Wp,
  ProductAccessTypesSchema: No,
  ProductAccessUserEndDate: qp,
  ProductAccessUserLastUsedDate: wp,
  ProductAccessUserStartDate: Fp,
  ProductAccessUsersEnvoySchema: sw,
  ProductAccessUsersFlowJoSchema: Hp,
  ProductAccessUsersSeqGeqSchema: kp,
  ProductAccessUsersValidator: yo,
  ProductBaseValidator: Oo,
  REGION_MAX_LENGTH: Cp,
  REGION_MIN_LENGTH: hp,
  RegionValidationSchema: tw,
  SchemaVersionSchema: $p,
  SeqGeqNameSchema: yp,
  SeqGeqRegionSchema: Pp,
  SeqGeqSchema: Xp,
  SeqGeqUserSchema: Gp,
  StartDateSchema: go,
  WhilelistDomainsSchema: Mp,
  isUserValid: aw
}, Symbol.toStringTag, { value: "Module" })), cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: ew,
  CostCenterValidators: iw
}, Symbol.toStringTag, { value: "Module" })), { newUUID: Kp, currentTime: gd } = U, Id = "5", ft = {
  individual: "individual",
  institutional: "institutional"
}, xr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, X = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, Ce = "world wide", He = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Kp()), e.type || (e.type = X.trial);
    const t = gd();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = xr.active);
  }
}), Ud = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1);
  }
}).compose(He), Zp = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(He), Qp = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = Ce;
  }
}).compose(He, Ud), eT = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = Ce;
  }
}).compose(He, Ud), tT = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(He, Zp), vo = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null
  },
  init: ({ instance: e }) => {
    const t = gd();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null);
  }
}), rT = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(vo), nT = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(vo), oT = l({
  refs: {}
}).compose(vo);
function uw(e, t, r, n) {
  return rT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function dw(e, t, r, n) {
  return nT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function lw(e, t, r, n) {
  return oT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function mw(e, t, r, n = X.release, o = [], a) {
  return Qp({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function Sw(e, t, r, n = X.release, o = [], a) {
  return eT({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function Ew(e, t, r, n, o, a, i = X.release, c = []) {
  return tT({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function _w(e, t) {
  e.productAccess.forEach(t);
}
function Po(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function Ro(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function Aw(e, t, r = X.release) {
  return Po(e, _.envoy, t, r);
}
function fw(e, t = X.release) {
  return Po(e, _.seqGeq, Ce, t);
}
function hw(e, t = X.release) {
  return Po(e, _.flowJo, Ce, t);
}
function Cw(e) {
  return Ro(e, _.envoy);
}
function Dw(e) {
  return Ro(e, _.seqGeq);
}
function pw(e) {
  return Ro(e, _.flowJo);
}
function Tw(e, t) {
  return e.users.indexOf(t) > -1;
}
function gw(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const Nd = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Kp());
    const t = gd();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = Id;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function Iw(e) {
  return Nd(e);
}
function yd(e, t, r, n, o) {
  return Nd({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o
  });
}
function sT(e) {
  return `${e} Individual Cost Center`;
}
function Uw(e, t, r) {
  return yd(
    sT(t),
    e,
    t,
    ft.individual,
    r
  );
}
function Nw(e, t, r, n) {
  return yd(
    e,
    t,
    r,
    ft.institutional,
    n
  );
}
const yw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: xr,
  COST_CENTER_SCHEMA_VERSION: Id,
  COST_CENTER_TYPES: ft,
  CostCenterStamp: Nd,
  EnvoyLicenseStamp: tT,
  EnvoyUserStamp: oT,
  FlowJoLicenseStamp: eT,
  FlowJoUserStamp: nT,
  GroupsLicenseStamp: Zp,
  PRODUCT_ACCESS_TYPES: X,
  ProductAccessStamp: He,
  ProductAccessUserStamp: vo,
  SeqGeqLicenseStamp: Qp,
  SeqGeqUserStamp: rT,
  UsersLicenseStamp: Ud,
  WORLD_WIDE: Ce,
  createCostCenter: yd,
  createCostCenterFromJson: Iw,
  createEnvoyProductAccess: Ew,
  createEnvoyUser: lw,
  createFlowJoProductAccess: Sw,
  createFlowJoUser: dw,
  createIndividualCostCenter: Uw,
  createInstitutionalCostCenter: Nw,
  createSeqGeqProductAccess: mw,
  createSeqGeqUser: uw,
  findEnvoyProduct: Aw,
  findFirstEnvoyProduct: Cw,
  findFirstFlowJoProduct: pw,
  findFirstProduct: Ro,
  findFirstSeqGeqProduct: Dw,
  findFlowJoProduct: hw,
  findProduct: Po,
  findSeqGeqProduct: fw,
  getIndividualCostCenterName: sT,
  isUserMemberOfCostCenter: Tw,
  isUserMemberOfUserProductAccess: gw,
  iterateProducts: _w
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Od } = U, aT = 1, iT = 256, cT = 5, uT = 253, dT = 1, lT = 36, mT = 30, ST = 5e3, ET = 400, _T = 100, AT = 20, $o = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, vd = s.extend((e) => ({
  base: e.string(),
  type: "string",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  rules: {
    nameString: {
      validate(t, r) {
        return t.match(/[\^\/:\*\?<>\\\|]/) ? r.error(f.INVALID_CHARS_SYMBOLS) : t.match(/[\r\n\f]/) ? r.error(f.NEW_LINE) : t.match(/[\t\b]/) ? r.error(f.TABS) : t.match(/ {2}/) ? r.error(f.CONSECUTIVE_SPACES) : t.match(/^\s|\s$/) ? r.error(f.LEADING_OR_TRAILING_SPACES) : t;
      }
    }
  }
})), fT = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < cT || t.length > uT)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), hT = fT.emailDomain(), CT = s.any().valid($o.seqGeq).required(), DT = s.any().valid($o.flowJo).required(), pT = s.any().valid($o.envoy).required(), TT = s.any().valid(Ce).required(), gT = s.any().valid(Ce).required(), IT = s.any().valid(Id).required(), UT = s.array().items(hT).unique().max(mT).required(), NT = vd.string().nameString().min(aT).max(iT).required(), Ow = vd.string().nameString().min(dT).max(lT).required(), vw = Object.keys(ft).map((e) => ft[e]), yT = s.string().valid(...vw).required(), OT = s.array().items(I).max(ST).unique().required(), Pd = s.array().items(I).max(ET).unique().required(), Mo = s.array().items(I).max(AT).unique().required(), bo = h.required(), Vo = s.alternatives().try(null, h).required(), Rd = E.nonStringNumber().min(0).integer().required(), $d = E.nonStringNumber().min(1).integer().required(), Md = E.nonStringNumber().min(1).integer().required(), bd = E.nonStringNumber().min(1).integer().required(), Vd = E.nonStringNumber().min(1).integer().required(), Ld = E.nonStringNumber().min(1).integer().required(), Pw = Object.keys(xr).map((e) => xr[e]), Lo = s.string().valid(...Pw).required(), Rw = Object.keys(X).map(
  (e) => X[e]
), qo = s.string().valid(...Rw).required(), qd = E.nonStringNumber().min(0).integer().required(), Fd = s.alternatives().try(null, s.string().uri()).required(), vT = s.alternatives().try(null, h).required(), PT = s.alternatives().try(null, h).required(), RT = s.alternatives().try(null, h).required(), wd = {
  userId: u,
  suspended: T,
  startDate: PT,
  endDate: vT,
  lastUsed: RT
}, $T = s.object().keys({
  ...wd,
  maxBoundDevices: Md,
  maxAnnualDeviceDeactivations: bd,
  maxSimultaenousSessions: Vd,
  offlineDurationDays: Ld
}), MT = s.object().keys({
  ...wd,
  maxBoundDevices: Md,
  maxAnnualDeviceDeactivations: bd,
  maxSimultaenousSessions: Vd,
  offlineDurationDays: Ld
}), bT = s.object().keys({
  ...wd
  // no difference for now, new attributes go here
}), Fo = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), VT = Fo.objects().pattern(Od, $T).idCheck().startDateCheck().required(), LT = Fo.objects().pattern(Od, MT).idCheck().startDateCheck().required(), $w = Fo.objects().pattern(Od, bT).idCheck().required(), wo = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), qT = wo.product().keys({
  id: u,
  name: pT,
  type: qo,
  owner: u,
  region: ne,
  groups: Pd,
  admins: Mo,
  startDate: bo,
  endDate: Vo,
  activityState: Lo,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), FT = wo.product().keys({
  id: u,
  name: CT,
  type: qo,
  owner: u,
  annualChanges: Rd,
  maxActiveUsers: $d,
  users: VT,
  region: TT,
  admins: Mo,
  startDate: bo,
  endDate: Vo,
  activityState: Lo,
  logLevel: qd,
  loggingUrl: Fd,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), wT = wo.product().keys({
  id: u,
  name: DT,
  type: qo,
  owner: u,
  annualChanges: Rd,
  maxActiveUsers: $d,
  users: LT,
  region: gT,
  admins: Mo,
  startDate: bo,
  endDate: Vo,
  activityState: Lo,
  logLevel: qd,
  loggingUrl: Fd,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), GT = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), jT = GT.products().items(qT, FT, wT).max(_T).idCheck().required(), xT = s.object().keys({
  id: u,
  name: NT,
  owner: u,
  users: OT,
  groups: Pd,
  countryCode: R,
  type: yT,
  whitelistDomains: UT,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: IT,
  productAccess: jT
});
function Mw(e) {
  return !xT.validate(e).error;
}
const bw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Lo,
  AnnualChangesSchema: Rd,
  CostCenterGroupsSchema: Pd,
  CostCenterObjectSchema: xT,
  CostCenterTypesSchema: yT,
  CostCenterUsersSchema: OT,
  DOMAIN_MAX_LENGTH: uT,
  DOMAIN_MIN_LENGTH: cT,
  EmailDomainValidation: fT,
  EmailDomainValidationSchema: hT,
  EndDateSchema: Vo,
  EnvoyNameSchema: pT,
  EnvoyProductSchema: qT,
  EnvoyUserSchema: bT,
  FlowJoNameSchema: DT,
  FlowJoRegionSchema: gT,
  FlowJoSchema: wT,
  FlowJoUserSchema: MT,
  LogLevelSchema: qd,
  LoggingUrlSchema: Fd,
  MAX_COST_CENTER_GROUPS: ET,
  MAX_COST_CENTER_PRODUCTS: _T,
  MAX_COST_CENTER_USERS: ST,
  MAX_PRODUCT_ACCESS_ADMINS: AT,
  MAX_WHITELIST_EMAIL_DOMAINS: mT,
  MaxActiveUsersSchema: $d,
  MaxAnnualDeviceDeactivationsSchema: bd,
  MaxBoundDevicesSchema: Md,
  MaxSimultaenousSessionsSchema: Vd,
  NAME_MAX_LENGTH: iT,
  NAME_MIN_LENGTH: aT,
  NameString: vd,
  NameValidationSchema: NT,
  OfflineDurationDaysSchema: Ld,
  PRODUCT_NAMES: $o,
  ProductAccessAdminsSchema: Mo,
  ProductAccessSchema: jT,
  ProductAccessSchemaValidator: GT,
  ProductAccessTypesSchema: qo,
  ProductAccessUserEndDate: vT,
  ProductAccessUserLastUsedDate: RT,
  ProductAccessUserStartDate: PT,
  ProductAccessUsersEnvoySchema: $w,
  ProductAccessUsersFlowJoSchema: LT,
  ProductAccessUsersSeqGeqSchema: VT,
  ProductAccessUsersValidator: Fo,
  ProductBaseValidator: wo,
  REGION_MAX_LENGTH: lT,
  REGION_MIN_LENGTH: dT,
  RegionValidationSchema: Ow,
  SchemaVersionSchema: IT,
  SeqGeqNameSchema: CT,
  SeqGeqRegionSchema: TT,
  SeqGeqSchema: FT,
  SeqGeqUserSchema: $T,
  StartDateSchema: bo,
  WhilelistDomainsSchema: UT,
  isUserValid: Mw
}, Symbol.toStringTag, { value: "Module" })), Vw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: yw,
  CostCenterValidators: bw
}, Symbol.toStringTag, { value: "Module" })), { newUUID: kT, currentTime: Gd } = U, jd = "6", ht = {
  individual: "individual",
  institutional: "institutional"
}, kr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Hr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, J = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, De = "world wide", Be = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = kT()), e.type || (e.type = J.trial);
    const t = Gd();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = kr.active);
  }
}), xd = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {});
  }
}).compose(Be), HT = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(Be), BT = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = De;
  }
}).compose(Be, xd), XT = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = De;
  }
}).compose(Be, xd), JT = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(Be, HT), Go = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = Gd();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), WT = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Go), YT = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Go), zT = l({
  refs: {}
}).compose(Go);
function Lw(e, t, r, n) {
  return WT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function qw(e, t, r, n) {
  return YT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function Fw(e, t, r, n) {
  return zT({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function ww(e, t, r, n = J.release, o = [], a) {
  return BT({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function Gw(e, t, r, n = J.release, o = [], a) {
  return XT({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a
  });
}
function jw(e, t, r, n, o, a, i = J.release, c = []) {
  return JT({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function xw(e, t) {
  e.productAccess.forEach(t);
}
function jo(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function xo(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function kw(e, t, r = J.release) {
  return jo(e, _.envoy, t, r);
}
function Hw(e, t = J.release) {
  return jo(e, _.seqGeq, De, t);
}
function Bw(e, t = J.release) {
  return jo(e, _.flowJo, De, t);
}
function Xw(e) {
  return xo(e, _.envoy);
}
function Jw(e) {
  return xo(e, _.seqGeq);
}
function Ww(e) {
  return xo(e, _.flowJo);
}
function Yw(e, t) {
  return e.users.indexOf(t) > -1;
}
function zw(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const kd = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = kT());
    const t = Gd();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = jd;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function Kw(e) {
  return kd(e);
}
function Hd(e, t, r, n, o) {
  return kd({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o
  });
}
function KT(e) {
  return `${e} Individual Cost Center`;
}
function Zw(e, t, r) {
  return Hd(
    KT(t),
    e,
    t,
    ht.individual,
    r
  );
}
function Qw(e, t, r, n) {
  return Hd(
    e,
    t,
    r,
    ht.institutional,
    n
  );
}
const eG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: kr,
  COST_CENTER_SCHEMA_VERSION: jd,
  COST_CENTER_TYPES: ht,
  CUSTOM_FIELD_KEY_STATUSES: Hr,
  CostCenterStamp: kd,
  EnvoyLicenseStamp: JT,
  EnvoyUserStamp: zT,
  FlowJoLicenseStamp: XT,
  FlowJoUserStamp: YT,
  GroupsLicenseStamp: HT,
  PRODUCT_ACCESS_TYPES: J,
  ProductAccessStamp: Be,
  ProductAccessUserStamp: Go,
  SeqGeqLicenseStamp: BT,
  SeqGeqUserStamp: WT,
  UsersLicenseStamp: xd,
  WORLD_WIDE: De,
  createCostCenter: Hd,
  createCostCenterFromJson: Kw,
  createEnvoyProductAccess: jw,
  createEnvoyUser: Fw,
  createFlowJoProductAccess: Gw,
  createFlowJoUser: qw,
  createIndividualCostCenter: Zw,
  createInstitutionalCostCenter: Qw,
  createSeqGeqProductAccess: ww,
  createSeqGeqUser: Lw,
  findEnvoyProduct: kw,
  findFirstEnvoyProduct: Xw,
  findFirstFlowJoProduct: Ww,
  findFirstProduct: xo,
  findFirstSeqGeqProduct: Jw,
  findFlowJoProduct: Bw,
  findProduct: jo,
  findSeqGeqProduct: Hw,
  getIndividualCostCenterName: KT,
  isUserMemberOfCostCenter: Yw,
  isUserMemberOfUserProductAccess: zw,
  iterateProducts: xw
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Gt } = U, ZT = 1, QT = 256, eg = 5, tg = 253, rg = 1, ng = 36, og = 30, sg = 5e3, ag = 400, ig = 100, cg = 20, ko = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, Bd = s.extend((e) => ({
  base: e.string(),
  type: "string",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  rules: {
    nameString: {
      validate(t, r) {
        return t.match(/[\^\/:\*\?<>\\\|]/) ? r.error(f.INVALID_CHARS_SYMBOLS) : t.match(/[\r\n\f]/) ? r.error(f.NEW_LINE) : t.match(/[\t\b]/) ? r.error(f.TABS) : t.match(/ {2}/) ? r.error(f.CONSECUTIVE_SPACES) : t.match(/^\s|\s$/) ? r.error(f.LEADING_OR_TRAILING_SPACES) : t;
      }
    }
  }
})), ug = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < eg || t.length > tg)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), dg = ug.emailDomain(), lg = s.any().valid(ko.seqGeq).required(), mg = s.any().valid(ko.flowJo).required(), Sg = s.any().valid(ko.envoy).required(), Eg = s.any().valid(De).required(), _g = s.any().valid(De).required(), Ag = s.any().valid(jd).required(), fg = s.array().items(dg).unique().max(og).required(), Xd = Bd.string().nameString().min(ZT).max(QT).required(), tG = Bd.string().nameString().min(rg).max(ng).required(), rG = Object.keys(ht).map((e) => ht[e]), hg = s.string().valid(...rG).required(), Cg = s.array().items(I).max(sg).unique().required(), Jd = s.array().items(I).max(ag).unique().required(), Ho = s.array().items(I).max(cg).unique().required(), Bo = h.required(), Xo = s.alternatives().try(null, h).required(), Wd = E.nonStringNumber().min(0).integer().required(), Yd = E.nonStringNumber().min(1).integer().required(), zd = E.nonStringNumber().min(1).integer().required(), Kd = E.nonStringNumber().min(1).integer().required(), Zd = E.nonStringNumber().min(1).integer().required(), Qd = E.nonStringNumber().min(1).integer().required(), nG = Object.keys(kr).map((e) => kr[e]), Jo = s.string().valid(...nG).required(), Dg = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Hr.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        if (Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o)
          return r.error("objects.customFieldOrderDuplicateCheck");
      }
    }
  }
})), pg = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), oG = Object.keys(Hr).map(
  (e) => Hr[e]
), Tg = s.string().valid(...oG).required(), gg = E.nonStringNumber().min(0).integer().required(), Ig = s.object().keys({
  id: u,
  label: Xd,
  required: T,
  status: Tg,
  createdAt: D,
  updatedAt: A,
  orderIndex: gg
}), Ug = s.alternatives().try("", s.string().max(256)).required(), Ng = s.object().keys({
  id: u,
  keyId: u,
  value: Ug,
  createdAt: D,
  updatedAt: A
}), yg = pg.objects().pattern(Gt, Ng).idCheck().required(), el = Dg.customFieldKey().pattern(Gt, Ig).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), sG = Object.keys(J).map(
  (e) => J[e]
), Wo = s.string().valid(...sG).required(), tl = E.nonStringNumber().min(0).integer().required(), rl = s.alternatives().try(null, s.string().uri()).required(), Og = s.alternatives().try(null, h).required(), vg = s.alternatives().try(null, h).required(), Pg = s.alternatives().try(null, h).required(), nl = {
  userId: u,
  suspended: T,
  startDate: vg,
  endDate: Og,
  lastUsed: Pg,
  customFieldValues: yg
}, Rg = s.object().keys({
  ...nl,
  maxBoundDevices: zd,
  maxAnnualDeviceDeactivations: Kd,
  maxSimultaenousSessions: Zd,
  offlineDurationDays: Qd
}), $g = s.object().keys({
  ...nl,
  maxBoundDevices: zd,
  maxAnnualDeviceDeactivations: Kd,
  maxSimultaenousSessions: Zd,
  offlineDurationDays: Qd
}), Mg = s.object().keys({
  ...nl
  // no difference for now, new attributes go here
}), Yo = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), bg = Yo.objects().pattern(Gt, Rg).idCheck().startDateCheck().required(), Vg = Yo.objects().pattern(Gt, $g).idCheck().startDateCheck().required(), aG = Yo.objects().pattern(Gt, Mg).idCheck().required(), zo = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), Lg = zo.product().keys({
  id: u,
  name: Sg,
  type: Wo,
  owner: u,
  region: ne,
  groups: Jd,
  admins: Ho,
  startDate: Bo,
  endDate: Xo,
  activityState: Jo,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), qg = zo.product().keys({
  id: u,
  name: lg,
  type: Wo,
  owner: u,
  annualChanges: Wd,
  maxActiveUsers: Yd,
  users: bg,
  region: Eg,
  admins: Ho,
  startDate: Bo,
  endDate: Xo,
  activityState: Jo,
  logLevel: tl,
  loggingUrl: rl,
  customFieldKeys: el,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), Fg = zo.product().keys({
  id: u,
  name: mg,
  type: Wo,
  owner: u,
  annualChanges: Wd,
  maxActiveUsers: Yd,
  users: Vg,
  region: _g,
  admins: Ho,
  startDate: Bo,
  endDate: Xo,
  activityState: Jo,
  logLevel: tl,
  loggingUrl: rl,
  customFieldKeys: el,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), wg = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), Gg = wg.products().items(Lg, qg, Fg).max(ig).idCheck().required(), jg = s.object().keys({
  id: u,
  name: Xd,
  owner: u,
  users: Cg,
  groups: Jd,
  countryCode: R,
  type: hg,
  whitelistDomains: fg,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: Ag,
  productAccess: Gg
});
function iG(e) {
  return !jg.validate(e).error;
}
const cG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Jo,
  AnnualChangesSchema: Wd,
  CostCenterGroupsSchema: Jd,
  CostCenterObjectSchema: jg,
  CostCenterTypesSchema: hg,
  CostCenterUsersSchema: Cg,
  CustomFieldKeyOrderSchema: gg,
  CustomFieldKeySchema: Ig,
  CustomFieldValueRecordSchema: Ng,
  CustomFieldValueSchema: Ug,
  DOMAIN_MAX_LENGTH: tg,
  DOMAIN_MIN_LENGTH: eg,
  EmailDomainValidation: ug,
  EmailDomainValidationSchema: dg,
  EndDateSchema: Xo,
  EnvoyNameSchema: Sg,
  EnvoyProductSchema: Lg,
  EnvoyUserSchema: Mg,
  FlowJoNameSchema: mg,
  FlowJoRegionSchema: _g,
  FlowJoSchema: Fg,
  FlowJoUserSchema: $g,
  LogLevelSchema: tl,
  LoggingUrlSchema: rl,
  MAX_COST_CENTER_GROUPS: ag,
  MAX_COST_CENTER_PRODUCTS: ig,
  MAX_COST_CENTER_USERS: sg,
  MAX_PRODUCT_ACCESS_ADMINS: cg,
  MAX_WHITELIST_EMAIL_DOMAINS: og,
  MaxActiveUsersSchema: Yd,
  MaxAnnualDeviceDeactivationsSchema: Kd,
  MaxBoundDevicesSchema: zd,
  MaxSimultaenousSessionsSchema: Zd,
  NAME_MAX_LENGTH: QT,
  NAME_MIN_LENGTH: ZT,
  NameString: Bd,
  NameValidationSchema: Xd,
  OfflineDurationDaysSchema: Qd,
  PRODUCT_NAMES: ko,
  ProductAccessAdminsSchema: Ho,
  ProductAccessCustomFieldKeysSchema: el,
  ProductAccessCustomFieldStatusSchema: Tg,
  ProductAccessCustomKeyValidator: Dg,
  ProductAccessSchema: Gg,
  ProductAccessSchemaValidator: wg,
  ProductAccessTypesSchema: Wo,
  ProductAccessUserEndDate: Og,
  ProductAccessUserLastUsedDate: Pg,
  ProductAccessUserStartDate: vg,
  ProductAccessUsersEnvoySchema: aG,
  ProductAccessUsersFlowJoSchema: Vg,
  ProductAccessUsersSeqGeqSchema: bg,
  ProductAccessUsersValidator: Yo,
  ProductBaseValidator: zo,
  REGION_MAX_LENGTH: ng,
  REGION_MIN_LENGTH: rg,
  RegionValidationSchema: tG,
  SchemaVersionSchema: Ag,
  SeqGeqNameSchema: lg,
  SeqGeqRegionSchema: Eg,
  SeqGeqSchema: qg,
  SeqGeqUserSchema: Rg,
  StartDateSchema: Bo,
  UserLicenseCustomFieldValuesSchema: yg,
  UserLicenseCustomValueValidator: pg,
  WhilelistDomainsSchema: fg,
  isUserValid: iG
}, Symbol.toStringTag, { value: "Module" })), uG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: eG,
  CostCenterValidators: cG
}, Symbol.toStringTag, { value: "Module" })), { newUUID: ol, currentTime: Ko } = U, sl = "7", Ct = {
  individual: "individual",
  institutional: "institutional"
}, Br = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Xr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, Jr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, Ea = {
  hwa: "hwa"
}, W = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, pe = "world wide", Xe = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ol()), e.type || (e.type = W.trial);
    const t = Ko();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Br.active);
  }
}), al = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {});
  }
}).compose(Xe), xg = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ol()), e.status || (e.status = Jr.active);
    const t = Ko();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), kg = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(Xe), Hg = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = pe;
  }
}).compose(Xe, al), Bg = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = pe;
  }
}).compose(Xe, al), Xg = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(Xe, kg), Zo = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = Ko();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), Jg = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Zo), Wg = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(Zo), Yg = l({
  refs: {}
}).compose(Zo);
function dG(e, t, r, n, o, a, i, c, m, d, p) {
  return xg({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function lG(e, t, r, n) {
  return Jg({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function mG(e, t, r, n) {
  return Wg({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function SG(e, t, r, n) {
  return Yg({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function EG(e, t, r, n = W.release, o = [], a, i = 0, c = {}) {
  return Hg({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function _G(e, t, r, n = W.release, o = [], a, i = 0, c = {}) {
  return Bg({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function AG(e, t, r, n, o, a, i = W.release, c = []) {
  return Xg({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function fG(e, t) {
  e.productAccess.forEach(t);
}
function Qo(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function es(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function hG(e, t, r = W.release) {
  return Qo(e, _.envoy, t, r);
}
function CG(e, t = W.release) {
  return Qo(e, _.seqGeq, pe, t);
}
function DG(e, t = W.release) {
  return Qo(e, _.flowJo, pe, t);
}
function pG(e) {
  return es(e, _.envoy);
}
function TG(e) {
  return es(e, _.seqGeq);
}
function gG(e) {
  return es(e, _.flowJo);
}
function IG(e, t) {
  return e.users.indexOf(t) > -1;
}
function UG(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const il = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ol());
    const t = Ko();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = sl;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function NG(e) {
  return il(e);
}
function cl(e, t, r, n, o) {
  return il({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o
  });
}
function zg(e) {
  return `${e} Individual Cost Center`;
}
function yG(e, t, r) {
  return cl(
    zg(t),
    e,
    t,
    Ct.individual,
    r
  );
}
function OG(e, t, r, n) {
  return cl(
    e,
    t,
    r,
    Ct.institutional,
    n
  );
}
const vG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Br,
  COST_CENTER_SCHEMA_VERSION: sl,
  COST_CENTER_TYPES: Ct,
  CUSTOM_FIELD_KEY_STATUSES: Xr,
  CostCenterStamp: il,
  EnvoyLicenseStamp: Xg,
  EnvoyUserStamp: Yg,
  FlowJoLicenseStamp: Bg,
  FlowJoUserStamp: Wg,
  GroupsLicenseStamp: kg,
  PRODUCT_ACCESS_TYPES: W,
  ProductAccessStamp: Xe,
  ProductAccessUserStamp: Zo,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ea,
  SHARED_COMPUTER_STATUSES: Jr,
  SeqGeqLicenseStamp: Hg,
  SeqGeqUserStamp: Jg,
  SharedComputerStamp: xg,
  UsersLicenseStamp: al,
  WORLD_WIDE: pe,
  createCostCenter: cl,
  createCostCenterFromJson: NG,
  createEnvoyProductAccess: AG,
  createEnvoyUser: SG,
  createFlowJoProductAccess: _G,
  createFlowJoUser: mG,
  createIndividualCostCenter: yG,
  createInstitutionalCostCenter: OG,
  createSeqGeqProductAccess: EG,
  createSeqGeqUser: lG,
  createSharedComputer: dG,
  findEnvoyProduct: hG,
  findFirstEnvoyProduct: pG,
  findFirstFlowJoProduct: gG,
  findFirstProduct: es,
  findFirstSeqGeqProduct: TG,
  findFlowJoProduct: DG,
  findProduct: Qo,
  findSeqGeqProduct: CG,
  getIndividualCostCenterName: zg,
  isUserMemberOfCostCenter: IG,
  isUserMemberOfUserProductAccess: UG,
  iterateProducts: fG
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Je } = U, Kg = 1, Zg = 256, Qg = 5, eI = 253, tI = 1, rI = 36, nI = 30, oI = 5e3, sI = 400, aI = 100, iI = 20, ts = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, cI = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < Qg || t.length > eI)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), uI = cI.emailDomain(), dI = s.any().valid(ts.seqGeq).required(), lI = s.any().valid(ts.flowJo).required(), mI = s.any().valid(ts.envoy).required(), SI = s.any().valid(pe).required(), EI = s.any().valid(pe).required(), _I = s.any().valid(sl).required(), AI = s.array().items(uI).unique().max(nI).required(), ul = P.nameString().min(Kg).max(Zg).required(), PG = P.nameString().min(tI).max(rI).required(), RG = Object.keys(Ct).map((e) => Ct[e]), fI = s.string().valid(...RG).required(), hI = s.array().items(I).max(oI).unique().required(), dl = s.array().items(I).max(sI).unique().required(), rs = s.array().items(I).max(iI).unique().required(), jt = h.required(), xt = s.alternatives().try(null, h).required(), ll = E.nonStringNumber().min(0).integer().required(), ml = E.nonStringNumber().min(1).integer().required(), Sl = E.nonStringNumber().min(1).integer().required(), El = E.nonStringNumber().min(1).integer().required(), _l = E.nonStringNumber().min(1).integer().required(), Al = E.nonStringNumber().min(1).integer().required(), fl = E.nonStringNumber().min(0).integer().required(), $G = Object.keys(Br).map((e) => Br[e]), ns = s.string().valid(...$G).required(), CI = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Xr.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), DI = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), MG = Object.keys(Xr).map(
  (e) => Xr[e]
), pI = s.string().valid(...MG).required(), TI = E.nonStringNumber().min(0).integer().required(), gI = s.object().keys({
  id: u,
  label: ul,
  required: T,
  status: pI,
  createdAt: D,
  updatedAt: A,
  orderIndex: TI
}), II = s.alternatives().try("", s.string().max(256)).required(), UI = s.object().keys({
  id: u,
  keyId: u,
  value: II,
  createdAt: D,
  updatedAt: A
}), NI = DI.objects().pattern(Je, UI).idCheck().required(), hl = CI.customFieldKey().pattern(Je, gI).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), bG = Object.keys(W).map(
  (e) => W[e]
), os = s.string().valid(...bG).required(), Cl = E.nonStringNumber().min(0).integer().required(), Dl = s.alternatives().try(null, s.string().uri()).required(), yI = s.alternatives().try(null, h).required(), OI = s.alternatives().try(null, h).required(), vI = s.alternatives().try(null, h).required(), pl = {
  userId: u,
  suspended: T,
  startDate: OI,
  endDate: yI,
  lastUsed: vI,
  customFieldValues: NI
}, VG = Object.keys(Jr).map(
  (e) => Jr[e]
), PI = s.string().valid(...VG).required(), LG = Object.keys(Ea).map(
  (e) => Ea[e]
), RI = s.string().valid(...LG).required(), $I = _e.hardwareAddress().required(), MI = s.object().keys({
  type: RI,
  value: $I
}), bI = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), VI = s.alternatives().try(MI).required(), LI = s.object().keys({
  id: u,
  label: Ir.min(1).max(256).required(),
  identifier: VI,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: jt,
  endDate: xt,
  contactLabel: s.alternatives().try(null, Ir.min(1).max(256)),
  status: PI
}), Tl = bI.sharedComputers().pattern(Je, LI).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), qI = s.object().keys({
  ...pl,
  maxBoundDevices: Sl,
  maxAnnualDeviceDeactivations: El,
  maxSimultaenousSessions: _l,
  offlineDurationDays: Al
}), FI = s.object().keys({
  ...pl,
  maxBoundDevices: Sl,
  maxAnnualDeviceDeactivations: El,
  maxSimultaenousSessions: _l,
  offlineDurationDays: Al
}), wI = s.object().keys({
  ...pl
  // no difference for now, new attributes go here
}), ss = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), GI = ss.objects().pattern(Je, qI).idCheck().startDateCheck().required(), jI = ss.objects().pattern(Je, FI).idCheck().startDateCheck().required(), qG = ss.objects().pattern(Je, wI).idCheck().required(), as = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), xI = as.product().keys({
  id: u,
  name: mI,
  type: os,
  owner: u,
  region: ne,
  groups: dl,
  admins: rs,
  startDate: jt,
  endDate: xt,
  activityState: ns,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), kI = as.product().keys({
  id: u,
  name: dI,
  type: os,
  owner: u,
  annualChanges: ll,
  maxActiveUsers: ml,
  users: GI,
  region: SI,
  admins: rs,
  startDate: jt,
  endDate: xt,
  activityState: ns,
  logLevel: Cl,
  loggingUrl: Dl,
  customFieldKeys: hl,
  sharedComputers: Tl,
  maxSharedComputers: fl,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), HI = as.product().keys({
  id: u,
  name: lI,
  type: os,
  owner: u,
  annualChanges: ll,
  maxActiveUsers: ml,
  users: jI,
  region: EI,
  admins: rs,
  startDate: jt,
  endDate: xt,
  activityState: ns,
  logLevel: Cl,
  loggingUrl: Dl,
  customFieldKeys: hl,
  sharedComputers: Tl,
  maxSharedComputers: fl,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), BI = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("products.duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), XI = BI.products().items(xI, kI, HI).max(aI).idCheck().required(), JI = s.object().keys({
  id: u,
  name: ul,
  owner: u,
  users: hI,
  groups: dl,
  countryCode: R,
  type: fI,
  whitelistDomains: AI,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: _I,
  productAccess: XI
});
function FG(e) {
  return !JI.validate(e).error;
}
const wG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: ns,
  AnnualChangesSchema: ll,
  CostCenterGroupsSchema: dl,
  CostCenterObjectSchema: JI,
  CostCenterTypesSchema: fI,
  CostCenterUsersSchema: hI,
  CustomFieldKeyOrderSchema: TI,
  CustomFieldKeySchema: gI,
  CustomFieldValueRecordSchema: UI,
  CustomFieldValueSchema: II,
  DOMAIN_MAX_LENGTH: eI,
  DOMAIN_MIN_LENGTH: Qg,
  EmailDomainValidation: cI,
  EmailDomainValidationSchema: uI,
  EndDateSchema: xt,
  EnvoyNameSchema: mI,
  EnvoyProductSchema: xI,
  EnvoyUserSchema: wI,
  FlowJoNameSchema: lI,
  FlowJoRegionSchema: EI,
  FlowJoSchema: HI,
  FlowJoUserSchema: FI,
  HardwareAddressSchema: $I,
  LogLevelSchema: Cl,
  LoggingUrlSchema: Dl,
  MAX_COST_CENTER_GROUPS: sI,
  MAX_COST_CENTER_PRODUCTS: aI,
  MAX_COST_CENTER_USERS: oI,
  MAX_PRODUCT_ACCESS_ADMINS: iI,
  MAX_WHITELIST_EMAIL_DOMAINS: nI,
  MaxActiveUsersSchema: ml,
  MaxAnnualDeviceDeactivationsSchema: El,
  MaxBoundDevicesSchema: Sl,
  MaxSimultaenousSessionsSchema: _l,
  NAME_MAX_LENGTH: Zg,
  NAME_MIN_LENGTH: Kg,
  NameValidationSchema: ul,
  OfflineDurationDaysSchema: Al,
  PRODUCT_NAMES: ts,
  ProductAccessAdminsSchema: rs,
  ProductAccessCustomFieldKeysSchema: hl,
  ProductAccessCustomFieldStatusSchema: pI,
  ProductAccessCustomKeyValidator: CI,
  ProductAccessSchema: XI,
  ProductAccessSchemaValidator: BI,
  ProductAccessTypesSchema: os,
  ProductAccessUserEndDate: yI,
  ProductAccessUserLastUsedDate: vI,
  ProductAccessUserStartDate: OI,
  ProductAccessUsersEnvoySchema: qG,
  ProductAccessUsersFlowJoSchema: jI,
  ProductAccessUsersSeqGeqSchema: GI,
  ProductAccessUsersValidator: ss,
  ProductBaseValidator: as,
  REGION_MAX_LENGTH: rI,
  REGION_MIN_LENGTH: tI,
  RegionValidationSchema: PG,
  SchemaVersionSchema: _I,
  SeqGeqNameSchema: dI,
  SeqGeqRegionSchema: SI,
  SeqGeqSchema: kI,
  SeqGeqUserSchema: qI,
  SharedComputerHWAIdentifierSchema: MI,
  SharedComputerIdentifierSchema: VI,
  SharedComputerIdentifierTypeSchema: RI,
  SharedComputerSchema: LI,
  SharedComputerSchemaValidator: bI,
  SharedComputerStatusSchema: PI,
  SharedComputersMaxSchema: fl,
  SharedComputersSchema: Tl,
  StartDateSchema: jt,
  UserLicenseCustomFieldValuesSchema: NI,
  UserLicenseCustomValueValidator: DI,
  WhilelistDomainsSchema: AI,
  isUserValid: FG
}, Symbol.toStringTag, { value: "Module" })), GG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: vG,
  CostCenterValidators: wG
}, Symbol.toStringTag, { value: "Module" })), { newUUID: gl, currentTime: is } = U, Il = "8", Dt = {
  individual: "individual",
  institutional: "institutional"
}, Wr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Yr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, zr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, _a = {
  hwa: "hwa"
}, Y = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, Te = "world wide", We = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = gl()), e.type || (e.type = Y.trial);
    const t = is();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Wr.active);
  }
}), Ul = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {});
  }
}).compose(We), WI = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = gl()), e.status || (e.status = zr.active);
    const t = is();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), YI = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(We), zI = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = Te;
  }
}).compose(We, Ul), KI = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = Te;
  }
}).compose(We, Ul), ZI = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(We, YI), cs = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = is();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), QI = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(cs), eU = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(cs), tU = l({
  refs: {}
}).compose(cs);
function jG(e, t, r, n, o, a, i, c, m, d, p) {
  return WI({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function xG(e, t, r, n) {
  return QI({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function kG(e, t, r, n) {
  return eU({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function HG(e, t, r, n) {
  return tU({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function BG(e, t, r, n = Y.release, o = [], a, i = 0, c = {}) {
  return zI({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function XG(e, t, r, n = Y.release, o = [], a, i = 0, c = {}) {
  return KI({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function JG(e, t, r, n, o, a, i = Y.release, c = []) {
  return ZI({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function WG(e, t) {
  e.productAccess.forEach(t);
}
function us(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function ds(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function YG(e, t, r = Y.release) {
  return us(e, _.envoy, t, r);
}
function zG(e, t = Y.release) {
  return us(e, _.seqGeq, Te, t);
}
function KG(e, t = Y.release) {
  return us(e, _.flowJo, Te, t);
}
function ZG(e) {
  return ds(e, _.envoy);
}
function QG(e) {
  return ds(e, _.seqGeq);
}
function e1(e) {
  return ds(e, _.flowJo);
}
function t1(e, t) {
  return e.users.indexOf(t) > -1;
}
function r1(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const Nl = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = gl());
    const t = is();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = Il;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function n1(e) {
  return Nl(e);
}
function yl(e, t, r, n, o, a) {
  return Nl({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a
  });
}
function rU(e) {
  return `${e} Individual Cost Center`;
}
function o1(e, t, r) {
  return yl(
    rU(t),
    e,
    t,
    Dt.individual,
    r
  );
}
function s1(e, t, r, n) {
  return yl(
    e,
    t,
    r,
    Dt.institutional,
    n
  );
}
const a1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Wr,
  COST_CENTER_SCHEMA_VERSION: Il,
  COST_CENTER_TYPES: Dt,
  CUSTOM_FIELD_KEY_STATUSES: Yr,
  CostCenterStamp: Nl,
  EnvoyLicenseStamp: ZI,
  EnvoyUserStamp: tU,
  FlowJoLicenseStamp: KI,
  FlowJoUserStamp: eU,
  GroupsLicenseStamp: YI,
  PRODUCT_ACCESS_TYPES: Y,
  ProductAccessStamp: We,
  ProductAccessUserStamp: cs,
  SHARED_COMPUTER_IDENTIFIER_TYPES: _a,
  SHARED_COMPUTER_STATUSES: zr,
  SeqGeqLicenseStamp: zI,
  SeqGeqUserStamp: QI,
  SharedComputerStamp: WI,
  UsersLicenseStamp: Ul,
  WORLD_WIDE: Te,
  createCostCenter: yl,
  createCostCenterFromJson: n1,
  createEnvoyProductAccess: JG,
  createEnvoyUser: HG,
  createFlowJoProductAccess: XG,
  createFlowJoUser: kG,
  createIndividualCostCenter: o1,
  createInstitutionalCostCenter: s1,
  createSeqGeqProductAccess: BG,
  createSeqGeqUser: xG,
  createSharedComputer: jG,
  findEnvoyProduct: YG,
  findFirstEnvoyProduct: ZG,
  findFirstFlowJoProduct: e1,
  findFirstProduct: ds,
  findFirstSeqGeqProduct: QG,
  findFlowJoProduct: KG,
  findProduct: us,
  findSeqGeqProduct: zG,
  getIndividualCostCenterName: rU,
  isUserMemberOfCostCenter: t1,
  isUserMemberOfUserProductAccess: r1,
  iterateProducts: WG
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Ye } = U, nU = 1, oU = 256, sU = 5, aU = 253, iU = 1, cU = 36, uU = 30, dU = 5e3, lU = 400, mU = 100, SU = 20, ls = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, EU = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: "emailDomainString"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailDomainString") };
    if (t.length < sU || t.length > aU)
      return { value: t, errors: r.error("string.emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("string.emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailDomainString") };
        m = d;
      }
  }
})), _U = EU.emailDomain(), AU = s.any().valid(ls.seqGeq).required(), fU = s.any().valid(ls.flowJo).required(), hU = s.any().valid(ls.envoy).required(), CU = s.any().valid(Te).required(), DU = s.any().valid(Te).required(), pU = s.any().valid(Il).required(), TU = s.array().items(_U).unique().max(uU).required(), Ol = P.nameString().min(nU).max(oU).required(), i1 = P.nameString().min(iU).max(cU).required(), c1 = Object.keys(Dt).map((e) => Dt[e]), gU = s.string().valid(...c1).required(), IU = s.array().items(I).max(dU).unique().required(), vl = s.array().items(I).max(lU).unique().required(), ms = s.array().items(I).max(SU).unique().required(), kt = h.required(), Ht = s.alternatives().try(null, h).required(), Pl = E.nonStringNumber().min(0).integer().required(), Rl = E.nonStringNumber().min(1).integer().required(), $l = E.nonStringNumber().min(1).integer().required(), Ml = E.nonStringNumber().min(1).integer().required(), bl = E.nonStringNumber().min(1).integer().required(), Vl = E.nonStringNumber().min(1).integer().required(), Ll = E.nonStringNumber().min(0).integer().required(), u1 = Object.keys(Wr).map((e) => Wr[e]), Ss = s.string().valid(...u1).required(), UU = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: "incorrect user id",
    maxFieldCountCheck: "exceeds maximum number of custom fields allowed",
    customFieldOrderDuplicateCheck: "not allowed to have duplicate order indexes"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Yr.active && (n += 1);
        }), n > 10 ? r.error(`objects.maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("objects.customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), NU = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("objects.idMismatch") : t;
      }
    }
  }
})), d1 = Object.keys(Yr).map(
  (e) => Yr[e]
), yU = s.string().valid(...d1).required(), OU = E.nonStringNumber().min(0).integer().required(), vU = s.object().keys({
  id: u,
  label: Ol,
  required: T,
  status: yU,
  createdAt: D,
  updatedAt: A,
  orderIndex: OU
}), PU = s.alternatives().try("", s.string().max(256)).required(), RU = s.object().keys({
  id: u,
  keyId: u,
  value: PU,
  createdAt: D,
  updatedAt: A
}), $U = NU.objects().pattern(Ye, RU).idCheck().required(), ql = UU.customFieldKey().pattern(Ye, vU).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), l1 = Object.keys(Y).map(
  (e) => Y[e]
), Es = s.string().valid(...l1).required(), Fl = E.nonStringNumber().min(0).integer().required(), wl = s.alternatives().try(null, s.string().uri()).required(), MU = s.alternatives().try(null, h).required(), bU = s.alternatives().try(null, h).required(), VU = s.alternatives().try(null, h).required(), Gl = {
  userId: u,
  suspended: T,
  startDate: bU,
  endDate: MU,
  lastUsed: VU,
  customFieldValues: $U
}, m1 = Object.keys(zr).map(
  (e) => zr[e]
), LU = s.string().valid(...m1).required(), S1 = Object.keys(_a).map(
  (e) => _a[e]
), qU = s.string().valid(...S1).required(), FU = _e.hardwareAddress().required(), wU = s.object().keys({
  type: qU,
  value: FU
}), GU = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: "incorrect user id",
    sharedComputerDuplicateLabelCheck: "duplicate label detected in shared computers",
    sharedComputerOverlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("sharedComputers.idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputers.sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), jU = s.alternatives().try(wU).required(), xU = s.object().keys({
  id: u,
  label: Ir.min(1).max(256).required(),
  identifier: jU,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: kt,
  endDate: Ht,
  contactLabel: s.alternatives().try(null, Ir.min(1).max(256)),
  status: LU
}), jl = GU.sharedComputers().pattern(Ye, xU).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), kU = s.object().keys({
  ...Gl,
  maxBoundDevices: $l,
  maxAnnualDeviceDeactivations: Ml,
  maxSimultaenousSessions: bl,
  offlineDurationDays: Vl
}), HU = s.object().keys({
  ...Gl,
  maxBoundDevices: $l,
  maxAnnualDeviceDeactivations: Ml,
  maxSimultaenousSessions: bl,
  offlineDurationDays: Vl
}), BU = s.object().keys({
  ...Gl
  // no difference for now, new attributes go here
}), _s = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: "incorrect user id",
    overlappingActiveDates: "endDate exists before startDate"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("objects.idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("objects.overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), XU = _s.objects().pattern(Ye, kU).idCheck().startDateCheck().required(), JU = _s.objects().pattern(Ye, HU).idCheck().startDateCheck().required(), E1 = _s.objects().pattern(Ye, BU).idCheck().required(), As = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: "overlappingDates"
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("objects.overlappingDates");
        }
        return t;
      }
    }
  }
})), WU = As.product().keys({
  id: u,
  name: hU,
  type: Es,
  owner: u,
  region: ne,
  groups: vl,
  admins: ms,
  startDate: kt,
  endDate: Ht,
  activityState: Ss,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), YU = As.product().keys({
  id: u,
  name: AU,
  type: Es,
  owner: u,
  annualChanges: Pl,
  maxActiveUsers: Rl,
  users: XU,
  region: CU,
  admins: ms,
  startDate: kt,
  endDate: Ht,
  activityState: Ss,
  logLevel: Fl,
  loggingUrl: wl,
  customFieldKeys: ql,
  sharedComputers: jl,
  maxSharedComputers: Ll,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), zU = As.product().keys({
  id: u,
  name: fU,
  type: Es,
  owner: u,
  annualChanges: Pl,
  maxActiveUsers: Rl,
  users: JU,
  region: DU,
  admins: ms,
  startDate: kt,
  endDate: Ht,
  activityState: Ss,
  logLevel: Fl,
  loggingUrl: wl,
  customFieldKeys: ql,
  sharedComputers: jl,
  maxSharedComputers: Ll,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), KU = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: "duplicate product"
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), ZU = KU.products().items(WU, YU, zU).max(mU).idCheck().required(), QU = s.object().keys({
  id: u,
  name: Ol,
  owner: u,
  users: IU,
  groups: vl,
  countryCode: R,
  type: gU,
  whitelistDomains: TU,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: pU,
  productAccess: ZU
});
function _1(e) {
  return !QU.validate(e).error;
}
const A1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: Ss,
  AnnualChangesSchema: Pl,
  CostCenterGroupsSchema: vl,
  CostCenterObjectSchema: QU,
  CostCenterTypesSchema: gU,
  CostCenterUsersSchema: IU,
  CustomFieldKeyOrderSchema: OU,
  CustomFieldKeySchema: vU,
  CustomFieldValueRecordSchema: RU,
  CustomFieldValueSchema: PU,
  DOMAIN_MAX_LENGTH: aU,
  DOMAIN_MIN_LENGTH: sU,
  EmailDomainValidation: EU,
  EmailDomainValidationSchema: _U,
  EndDateSchema: Ht,
  EnvoyNameSchema: hU,
  EnvoyProductSchema: WU,
  EnvoyUserSchema: BU,
  FlowJoNameSchema: fU,
  FlowJoRegionSchema: DU,
  FlowJoSchema: zU,
  FlowJoUserSchema: HU,
  HardwareAddressSchema: FU,
  LogLevelSchema: Fl,
  LoggingUrlSchema: wl,
  MAX_COST_CENTER_GROUPS: lU,
  MAX_COST_CENTER_PRODUCTS: mU,
  MAX_COST_CENTER_USERS: dU,
  MAX_PRODUCT_ACCESS_ADMINS: SU,
  MAX_WHITELIST_EMAIL_DOMAINS: uU,
  MaxActiveUsersSchema: Rl,
  MaxAnnualDeviceDeactivationsSchema: Ml,
  MaxBoundDevicesSchema: $l,
  MaxSimultaenousSessionsSchema: bl,
  NAME_MAX_LENGTH: oU,
  NAME_MIN_LENGTH: nU,
  NameValidationSchema: Ol,
  OfflineDurationDaysSchema: Vl,
  PRODUCT_NAMES: ls,
  ProductAccessAdminsSchema: ms,
  ProductAccessCustomFieldKeysSchema: ql,
  ProductAccessCustomFieldStatusSchema: yU,
  ProductAccessCustomKeyValidator: UU,
  ProductAccessSchema: ZU,
  ProductAccessSchemaValidator: KU,
  ProductAccessTypesSchema: Es,
  ProductAccessUserEndDate: MU,
  ProductAccessUserLastUsedDate: VU,
  ProductAccessUserStartDate: bU,
  ProductAccessUsersEnvoySchema: E1,
  ProductAccessUsersFlowJoSchema: JU,
  ProductAccessUsersSeqGeqSchema: XU,
  ProductAccessUsersValidator: _s,
  ProductBaseValidator: As,
  REGION_MAX_LENGTH: cU,
  REGION_MIN_LENGTH: iU,
  RegionValidationSchema: i1,
  SchemaVersionSchema: pU,
  SeqGeqNameSchema: AU,
  SeqGeqRegionSchema: CU,
  SeqGeqSchema: YU,
  SeqGeqUserSchema: kU,
  SharedComputerHWAIdentifierSchema: wU,
  SharedComputerIdentifierSchema: jU,
  SharedComputerIdentifierTypeSchema: qU,
  SharedComputerSchema: xU,
  SharedComputerSchemaValidator: GU,
  SharedComputerStatusSchema: LU,
  SharedComputersMaxSchema: Ll,
  SharedComputersSchema: jl,
  StartDateSchema: kt,
  UserLicenseCustomFieldValuesSchema: $U,
  UserLicenseCustomValueValidator: NU,
  WhilelistDomainsSchema: TU,
  isUserValid: _1
}, Symbol.toStringTag, { value: "Module" })), f1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: a1,
  CostCenterValidators: A1
}, Symbol.toStringTag, { value: "Module" })), { newUUID: xl, currentTime: fs } = U, kl = "9", pt = {
  individual: "individual",
  institutional: "institutional"
}, Kr = {
  active: "active",
  cancelled: "cancelled",
  suspended: "suspended"
}, Zr = {
  active: "active",
  inactive: "inactive",
  archived: "archived"
}, Qr = {
  active: "active",
  inactive: "inactive",
  deleted: "deleted"
}, Aa = {
  hwa: "hwa"
}, z = {
  beta: "Beta",
  release: "Release",
  trial: "Trial"
}, ge = "world wide", ze = l({
  refs: {
    id: null,
    type: null,
    owner: null,
    admins: null,
    region: null,
    startDate: null,
    endDate: null,
    version: null,
    activityState: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = xl()), e.type || (e.type = z.trial);
    const t = fs();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.version || (e.version = 1), e.admins || (e.admins = []), e.activityState || (e.activityState = Kr.active);
  }
}), Hl = l({
  refs: {
    users: null,
    annualChanges: 0,
    maxActiveUsers: 1,
    customFieldKeys: null,
    sharedComputers: null,
    maxSharedComputers: 0
  },
  init: ({ instance: e }) => {
    e.users || (e.users = {}), e.maxActiveUsers || (e.maxActiveUsers = 1), e.customFieldKeys || (e.customFieldKeys = {}), e.sharedComputers || (e.sharedComputers = {});
  }
}).compose(ze), eN = l({
  refs: {
    id: null,
    label: null,
    identifier: null,
    createdAt: null,
    updatedAt: null,
    createdBy: null,
    updatedBy: null,
    lastUsedAt: null,
    // WARNING optimized to only record the first time this was last used for the same user
    lastUsedBy: null,
    startDate: null,
    endDate: null,
    contactLabel: null,
    status: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = xl()), e.status || (e.status = Qr.active);
    const t = fs();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.contactLabel || (e.contactLabel = null);
  }
}), tN = l({
  refs: {
    groups: null
  },
  init: ({ instance: e }) => {
    e.groups || (e.groups = []);
  }
}).compose(ze), rN = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.seqGeq, e.region = ge;
  }
}).compose(ze, Hl), nN = l({
  refs: {
    name: null,
    region: null,
    logLevel: 0,
    loggingUrl: null
  },
  init: ({ instance: e }) => {
    e.name = _.flowJo, e.region = ge;
  }
}).compose(ze, Hl), oN = l({
  refs: {
    name: null,
    diskSpaceGb: null,
    yearlyDlGb: null
  },
  init: ({ instance: e }) => {
    e.name = _.envoy;
  }
}).compose(ze, tN), hs = l({
  refs: {
    userId: null,
    suspended: null,
    lastUsed: null,
    startDate: null,
    endDate: null,
    customFieldValues: null
  },
  init: ({ instance: e }) => {
    const t = fs();
    (e.suspended === void 0 || e.suspended === null) && (e.suspended = !1), e.startDate || (e.startDate = t), e.endDate || (e.endDate = null), e.customFieldValues || (e.customFieldValues = {});
  }
}), sN = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(hs), aN = l({
  refs: {
    maxBoundDevices: 4,
    maxAnnualDeviceDeactivations: 4,
    maxSimultaenousSessions: 1,
    offlineDurationDays: 1
  }
}).compose(hs), iN = l({
  refs: {}
}).compose(hs);
function h1(e, t, r, n, o, a, i, c, m, d, p) {
  return eN({
    id: e,
    label: t,
    identifier: r,
    createdAt: n,
    updatedAt: o,
    createdBy: a,
    updatedBy: i,
    status: c,
    startDate: m,
    endDate: d,
    contactLabel: p
  });
}
function C1(e, t, r, n) {
  return sN({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function D1(e, t, r, n) {
  return aN({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function p1(e, t, r, n) {
  return iN({
    userId: e,
    suspended: t,
    startDate: r,
    endDate: n
  });
}
function T1(e, t, r, n = z.release, o = [], a, i = 0, c = {}) {
  return rN({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function g1(e, t, r, n = z.release, o = [], a, i = 0, c = {}) {
  return nN({
    owner: e,
    startDate: t,
    endDate: r,
    type: n,
    admins: o,
    maxActiveUsers: a,
    maxSharedComputers: i,
    sharedComputers: c
  });
}
function I1(e, t, r, n, o, a, i = z.release, c = []) {
  return oN({
    owner: e,
    region: t,
    startDate: r,
    endDate: n,
    diskSpaceGb: o,
    yearlyDlGb: a,
    admins: c,
    type: i
  });
}
function U1(e, t) {
  e.productAccess.forEach(t);
}
function Cs(e, t, r, n) {
  return e.productAccess.find(
    (o) => o.name === t && o.type === n && o.region === r
  );
}
function Ds(e, t) {
  return e.productAccess.find((r) => r.name === t);
}
function N1(e, t, r = z.release) {
  return Cs(e, _.envoy, t, r);
}
function y1(e, t = z.release) {
  return Cs(e, _.seqGeq, ge, t);
}
function O1(e, t = z.release) {
  return Cs(e, _.flowJo, ge, t);
}
function v1(e) {
  return Ds(e, _.envoy);
}
function P1(e) {
  return Ds(e, _.seqGeq);
}
function R1(e) {
  return Ds(e, _.flowJo);
}
function $1(e, t) {
  return e.users.indexOf(t) > -1;
}
function M1(e, t, r) {
  const n = e.productAccess.find((o) => o.id === t);
  return n && n.users ? n.users[r] !== void 0 : !1;
}
const Bl = l({
  refs: {
    id: null,
    version: null,
    name: null,
    countryCode: null,
    productAccess: null,
    whitelistDomains: null,
    whitelistIgnore: null,
    owner: null,
    admins: null,
    type: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = xl());
    const t = fs();
    e.createdAt || (e.createdAt = t), e.updatedAt || (e.updatedAt = t), e.version || (e.version = 1), e.whitelistDomains || (e.whitelistDomains = []), e.whitelistIgnore || (e.whitelistIgnore = !1), e.users || (e.users = []), e.admins || (e.admins = []), e.productAccess || (e.productAccess = []), e.groups || (e.groups = []), e.schemaVersion = kl;
  },
  methods: {
    // TODO WRITE TESTS
    getProductAccessByNameTypeRegion(e, t, r) {
      return this.productAccess.find((n) => {
        if (n.name === e && n.type === t && n.region === r)
          return n;
      });
    }
  }
});
function b1(e) {
  return Bl(e);
}
function Xl(e, t, r, n, o, a, i) {
  return Bl({
    name: e,
    whitelistDomains: t,
    owner: r,
    type: n,
    countryCode: o,
    whitelistIgnore: a,
    admins: i
  });
}
function cN(e) {
  return `${e} Individual Cost Center`;
}
function V1(e, t, r) {
  return Xl(
    cN(t),
    e,
    t,
    pt.individual,
    r,
    !1,
    // whitelist ignore
    []
    // coadmins
  );
}
function L1(e, t, r, n, o) {
  return Xl(
    e,
    t,
    r,
    pt.institutional,
    n,
    !1,
    // whitelist ignore
    o
  );
}
const q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: Kr,
  COST_CENTER_SCHEMA_VERSION: kl,
  COST_CENTER_TYPES: pt,
  CUSTOM_FIELD_KEY_STATUSES: Zr,
  CostCenterStamp: Bl,
  EnvoyLicenseStamp: oN,
  EnvoyUserStamp: iN,
  FlowJoLicenseStamp: nN,
  FlowJoUserStamp: aN,
  GroupsLicenseStamp: tN,
  PRODUCT_ACCESS_TYPES: z,
  ProductAccessStamp: ze,
  ProductAccessUserStamp: hs,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Aa,
  SHARED_COMPUTER_STATUSES: Qr,
  SeqGeqLicenseStamp: rN,
  SeqGeqUserStamp: sN,
  SharedComputerStamp: eN,
  UsersLicenseStamp: Hl,
  WORLD_WIDE: ge,
  createCostCenter: Xl,
  createCostCenterFromJson: b1,
  createEnvoyProductAccess: I1,
  createEnvoyUser: p1,
  createFlowJoProductAccess: g1,
  createFlowJoUser: D1,
  createIndividualCostCenter: V1,
  createInstitutionalCostCenter: L1,
  createSeqGeqProductAccess: T1,
  createSeqGeqUser: C1,
  createSharedComputer: h1,
  findEnvoyProduct: N1,
  findFirstEnvoyProduct: v1,
  findFirstFlowJoProduct: R1,
  findFirstProduct: Ds,
  findFirstSeqGeqProduct: P1,
  findFlowJoProduct: O1,
  findProduct: Cs,
  findSeqGeqProduct: y1,
  getIndividualCostCenterName: cN,
  isUserMemberOfCostCenter: $1,
  isUserMemberOfUserProductAccess: M1,
  iterateProducts: U1
}, Symbol.toStringTag, { value: "Module" })), { UUID_REGEX: Ke } = U, uN = 1, dN = 256, lN = 5, mN = 253, SN = 1, EN = 36, _N = 30, AN = 5e3, fN = 400, hN = 100, CN = 20, ps = {
  envoy: "Envoy",
  seqGeq: "SeqGeq",
  flowJo: "FlowJo"
}, DN = s.extend((e) => ({
  base: e.string(),
  type: "emailDomain",
  messages: {
    emailDomainString: f.INVALID_EMAIL
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("emailDomainString") };
    if (t.length < lN || t.length > mN)
      return { value: t, errors: r.error("emailDomainString") };
    const n = t.indexOf("@");
    if (n !== 0)
      return { value: t, errors: r.error("emailDomainString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("emailDomainString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("emailDomainString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("emailDomainString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("emailDomainString") };
        m = d;
      }
  }
})), pN = DN.emailDomain(), TN = s.any().valid(ps.seqGeq).required(), gN = s.any().valid(ps.flowJo).required(), IN = s.any().valid(ps.envoy).required(), UN = s.any().valid(ge).required(), NN = s.any().valid(ge).required(), yN = s.any().valid(kl).required(), ON = s.array().items(pN).unique().max(_N).required(), vN = P.nameString().min(uN).max(dN).required(), F1 = P.nameString().min(SN).max(EN).required(), w1 = Object.keys(pt).map((e) => pt[e]), PN = s.string().valid(...w1).required(), RN = s.array().items(I).max(AN).unique().required(), $N = s.array().items(I).unique().required(), Jl = s.array().items(I).max(fN).unique().required(), Ts = s.array().items(I).max(CN).unique().required(), Bt = h.required(), Xt = s.alternatives().try(null, h).required(), Wl = E.nonStringNumber().min(0).integer().required(), Yl = E.nonStringNumber().min(1).integer().required(), zl = E.nonStringNumber().min(1).integer().required(), Kl = E.nonStringNumber().min(1).integer().required(), Zl = E.nonStringNumber().min(1).integer().required(), Ql = E.nonStringNumber().min(1).integer().required(), em = E.nonStringNumber().min(0).integer().required(), G1 = Object.keys(Kr).map((e) => Kr[e]), gs = s.string().valid(...G1).required(), MN = s.extend((e) => ({
  base: e.object(),
  type: "customFieldKey",
  messages: {
    idMismatch: f.USER_ID,
    maxFieldCountCheck: f.MAX_CUSTOM_FIELDS,
    customFieldOrderDuplicateCheck: f.DUPLICATE_INDEX
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("idMismatch") : t;
      }
    },
    maxFieldCountCheck: {
      validate(t, r) {
        let n = 0;
        return Object.keys(t).forEach((o) => {
          t[o].status === Zr.active && (n += 1);
        }), n > 10 ? r.error(`maxFieldCountCheck ${{ v: n }}`) : t;
      }
    },
    customFieldOrderDuplicateCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.orderIndex) && (o = !0), n.push(i.orderIndex);
        }), o ? r.error("customFieldOrderDuplicateCheck") : t;
      }
    }
  }
})), bN = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: f.USER_ID
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("idMismatch") : t;
      }
    }
  }
})), j1 = Object.keys(Zr).map(
  (e) => Zr[e]
), VN = s.string().valid(...j1).required(), LN = E.nonStringNumber().min(0).integer().required(), qN = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  required: T,
  status: VN,
  createdAt: D,
  updatedAt: A,
  orderIndex: LN
}), FN = s.alternatives().try("", s.string().max(256)).required(), wN = s.object().keys({
  id: u,
  keyId: u,
  value: FN,
  createdAt: D,
  updatedAt: A
}), GN = bN.objects().pattern(Ke, wN).idCheck().required(), tm = MN.customFieldKey().pattern(Ke, qN).idCheck().maxFieldCountCheck().customFieldOrderDuplicateCheck().required(), x1 = Object.keys(z).map(
  (e) => z[e]
), Is = s.string().valid(...x1).required(), rm = E.nonStringNumber().min(0).integer().required(), nm = s.alternatives().try(null, s.string().uri()).required(), jN = s.alternatives().try(null, h).required(), xN = s.alternatives().try(null, h).required(), kN = s.alternatives().try(null, h).required(), om = {
  userId: u,
  suspended: T,
  startDate: xN,
  endDate: jN,
  lastUsed: kN,
  customFieldValues: GN
}, k1 = Object.keys(Qr).map(
  (e) => Qr[e]
), HN = s.string().valid(...k1).required(), H1 = Object.keys(Aa).map(
  (e) => Aa[e]
), BN = s.string().valid(...H1).required(), XN = _e.hardwareAddress().required(), JN = s.object().keys({
  type: BN,
  value: XN
}), WN = s.extend((e) => ({
  base: e.object(),
  type: "sharedComputers",
  messages: {
    idMismatch: f.USER_ID,
    sharedComputerDuplicateLabelCheck: f.DUPLICATE_SHARED_COMPUTER_LABEL,
    sharedComputerOverlappingActiveDates: f.START_DATE_BEFORE_END_DATE
  },
  rules: {
    idCheck: {
      validate(t, r) {
        let n = !1;
        return Object.keys(t).forEach((o) => {
          t[o].id !== o && (n = !0);
        }), n ? r.error("idMismatch") : t;
      }
    },
    sharedComputerDuplicateLabelCheck: {
      validate(t, r) {
        const n = [];
        let o = !1;
        return Object.keys(t).forEach((a) => {
          const i = t[a];
          n.includes(i.label) && (o = !0), n.push(i.label);
        }), o ? r.error("sharedComputerDuplicateLabelCheck") : t;
      }
    },
    sharedComputerOverlappingActiveDates: {
      validate(t, r) {
        if (t)
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("overlappingActiveDates");
          }
        return t;
      }
    }
  }
})), YN = s.alternatives().try(JN).required(), zN = s.object().keys({
  id: u,
  label: s.string().min(1).max(256).required(),
  identifier: YN,
  createdAt: D,
  updatedAt: A,
  createdBy: u,
  updatedBy: u,
  lastUsedAt: A,
  lastUsedBy: s.alternatives().try(null, u).required(),
  startDate: Bt,
  endDate: Xt,
  contactLabel: s.alternatives().try(null, s.string().min(1).max(256)),
  status: HN
}), sm = WN.sharedComputers().pattern(Ke, zN).idCheck().sharedComputerDuplicateLabelCheck().sharedComputerOverlappingActiveDates().required(), KN = s.object().keys({
  ...om,
  maxBoundDevices: zl,
  maxAnnualDeviceDeactivations: Kl,
  maxSimultaenousSessions: Zl,
  offlineDurationDays: Ql
}), ZN = s.object().keys({
  ...om,
  maxBoundDevices: zl,
  maxAnnualDeviceDeactivations: Kl,
  maxSimultaenousSessions: Zl,
  offlineDurationDays: Ql
}), QN = s.object().keys({
  ...om
  // no difference for now, new attributes go here
}), Us = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    idMismatch: f.USER_ID,
    overlappingActiveDates: f.START_DATE_BEFORE_END_DATE
  },
  rules: {
    idCheck: {
      validate(t, r) {
        for (const n in t)
          if (t[n].userId !== n)
            return r.error("idMismatch");
        return t;
      }
    },
    startDateCheck: {
      validate(t, r) {
        if (t) {
          for (const n in t) {
            const o = t[n], a = new Date(o.startDate).valueOf(), i = new Date(o.endDate).valueOf();
            if (i && i < a)
              return r.error("overlappingActiveDates");
          }
          return t;
        }
      }
    }
  }
})), ey = Us.objects().pattern(Ke, KN).idCheck().startDateCheck().required(), ty = Us.objects().pattern(Ke, ZN).idCheck().startDateCheck().required(), B1 = Us.objects().pattern(Ke, QN).idCheck().required(), Ns = s.extend((e) => ({
  base: e.object(),
  type: "product",
  messages: {
    overlappingDates: f.START_DATE_BEFORE_END_DATE
  },
  rules: {
    dateCheck: {
      validate(t, r) {
        if (t.endDate) {
          const n = new Date(t.startDate).valueOf();
          if (new Date(t.endDate).valueOf() < n)
            return r.error("overlappingDates");
        }
        return t;
      }
    }
  }
})), ry = Ns.product().keys({
  id: u,
  name: IN,
  type: Is,
  owner: u,
  region: ne,
  groups: Jl,
  admins: Ts,
  startDate: Bt,
  endDate: Xt,
  activityState: gs,
  diskSpaceGb: v,
  yearlyDlGb: v,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), ny = Ns.product().keys({
  id: u,
  name: TN,
  type: Is,
  owner: u,
  annualChanges: Wl,
  maxActiveUsers: Yl,
  users: ey,
  region: UN,
  admins: Ts,
  startDate: Bt,
  endDate: Xt,
  activityState: gs,
  logLevel: rm,
  loggingUrl: nm,
  customFieldKeys: tm,
  sharedComputers: sm,
  maxSharedComputers: em,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), oy = Ns.product().keys({
  id: u,
  name: gN,
  type: Is,
  owner: u,
  annualChanges: Wl,
  maxActiveUsers: Yl,
  users: ty,
  region: NN,
  admins: Ts,
  startDate: Bt,
  endDate: Xt,
  activityState: gs,
  logLevel: rm,
  loggingUrl: nm,
  customFieldKeys: tm,
  sharedComputers: sm,
  maxSharedComputers: em,
  version: g,
  createdAt: D,
  updatedAt: A
}).dateCheck(), sy = s.extend((e) => ({
  base: e.array(),
  type: "products",
  messages: {
    duplicateProduct: f.DUPLICATE_PRODUCT
  },
  rules: {
    idCheck: {
      validate(t, r) {
        const n = {};
        for (const o of t) {
          const a = `${o.name}	${o.type}	${o.region}`;
          if (n[a])
            return r.error("duplicateProduct");
          n[a] = !0;
        }
        return t;
      }
    }
  }
})), ay = sy.products().items(ry, ny, oy).max(hN).idCheck().required(), iy = s.object().keys({
  id: u,
  name: vN,
  owner: u,
  users: RN,
  admins: $N,
  groups: Jl,
  countryCode: R,
  type: PN,
  whitelistDomains: ON,
  whitelistIgnore: T,
  version: g,
  createdAt: D,
  updatedAt: A,
  schemaVersion: yN,
  productAccess: ay
});
function X1(e) {
  return !iy.validate(e).error;
}
const J1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActivityStatesSchema: gs,
  AnnualChangesSchema: Wl,
  CostCenterAdminsSchema: $N,
  CostCenterGroupsSchema: Jl,
  CostCenterObjectSchema: iy,
  CostCenterTypesSchema: PN,
  CostCenterUsersSchema: RN,
  CustomFieldKeyOrderSchema: LN,
  CustomFieldKeySchema: qN,
  CustomFieldValueRecordSchema: wN,
  CustomFieldValueSchema: FN,
  DOMAIN_MAX_LENGTH: mN,
  DOMAIN_MIN_LENGTH: lN,
  EmailDomainValidation: DN,
  EmailDomainValidationSchema: pN,
  EndDateSchema: Xt,
  EnvoyNameSchema: IN,
  EnvoyProductSchema: ry,
  EnvoyUserSchema: QN,
  FlowJoNameSchema: gN,
  FlowJoRegionSchema: NN,
  FlowJoSchema: oy,
  FlowJoUserSchema: ZN,
  HardwareAddressSchema: XN,
  LogLevelSchema: rm,
  LoggingUrlSchema: nm,
  MAX_COST_CENTER_GROUPS: fN,
  MAX_COST_CENTER_PRODUCTS: hN,
  MAX_COST_CENTER_USERS: AN,
  MAX_PRODUCT_ACCESS_ADMINS: CN,
  MAX_WHITELIST_EMAIL_DOMAINS: _N,
  MaxActiveUsersSchema: Yl,
  MaxAnnualDeviceDeactivationsSchema: Kl,
  MaxBoundDevicesSchema: zl,
  MaxSimultaenousSessionsSchema: Zl,
  NAME_MAX_LENGTH: dN,
  NAME_MIN_LENGTH: uN,
  NameValidationSchema: vN,
  OfflineDurationDaysSchema: Ql,
  PRODUCT_NAMES: ps,
  ProductAccessAdminsSchema: Ts,
  ProductAccessCustomFieldKeysSchema: tm,
  ProductAccessCustomFieldStatusSchema: VN,
  ProductAccessCustomKeyValidator: MN,
  ProductAccessSchema: ay,
  ProductAccessSchemaValidator: sy,
  ProductAccessTypesSchema: Is,
  ProductAccessUserEndDate: jN,
  ProductAccessUserLastUsedDate: kN,
  ProductAccessUserStartDate: xN,
  ProductAccessUsersEnvoySchema: B1,
  ProductAccessUsersFlowJoSchema: ty,
  ProductAccessUsersSeqGeqSchema: ey,
  ProductAccessUsersValidator: Us,
  ProductBaseValidator: Ns,
  REGION_MAX_LENGTH: EN,
  REGION_MIN_LENGTH: SN,
  RegionValidationSchema: F1,
  SchemaVersionSchema: yN,
  SeqGeqNameSchema: TN,
  SeqGeqRegionSchema: UN,
  SeqGeqSchema: ny,
  SeqGeqUserSchema: KN,
  SharedComputerHWAIdentifierSchema: JN,
  SharedComputerIdentifierSchema: YN,
  SharedComputerIdentifierTypeSchema: BN,
  SharedComputerSchema: zN,
  SharedComputerSchemaValidator: WN,
  SharedComputerStatusSchema: HN,
  SharedComputersMaxSchema: em,
  SharedComputersSchema: sm,
  StartDateSchema: Bt,
  UserLicenseCustomFieldValuesSchema: GN,
  UserLicenseCustomValueValidator: bN,
  WhilelistDomainsSchema: ON,
  isUserValid: X1
}, Symbol.toStringTag, { value: "Module" })), W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CostCenter: q1,
  CostCenterValidators: J1
}, Symbol.toStringTag, { value: "Module" })), en = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14"
], ys = en[en.length - 1], Ie = {
  1: xV,
  2: _F,
  3: VF,
  4: cw,
  5: Vw,
  6: uG,
  7: GG,
  8: f1,
  9: W1,
  10: DL,
  11: WL,
  12: Tq,
  13: Bq,
  14: Zq
}, am = Ie[ys], { CostCenter: ee, CostCenterValidators: cy } = am, Y1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: se,
  ActivityStatesSchema: ru,
  AnnualChangesSchema: Qc,
  COST_CENTER_SCHEMA_VERSION: Vt,
  COST_CENTER_TYPES: x,
  CURRENT_SCHEMA_VERSION: ys,
  CUSTOM_FIELD_KEY_STATUSES: rc,
  CostCenter: ee,
  CostCenterAdminsSchema: kc,
  CostCenterObjectSchema: $u,
  CostCenterStamp: Lt,
  CostCenterTypesSchema: jc,
  CostCenterUsersSchema: xc,
  CostCenterValidators: cy,
  CustomFieldKeyOrderSchema: au,
  CustomFieldKeySchema: iu,
  CustomFieldValueRecordSchema: uu,
  CustomFieldValueSchema: cu,
  DOMAIN_MAX_LENGTH: yc,
  DOMAIN_MIN_LENGTH: Nc,
  EmailDomainValidation: Vc,
  EmailDomainValidationSchema: Lc,
  EndDateSchema: Zc,
  FWMEncryptedFingerprintSchema: hu,
  FWMEncryptedSharedComputerFingerprintIdentifierSchema: gu,
  FWMSharedComputerStamp: cc,
  FacsWorkflowSharedComputerSchema: Pu,
  FingerprintSchema: Du,
  FlowJoUserStamp: lc,
  HardwareAddressSchema: Cu,
  KNOWN_VERSIONS: en,
  LogLevelSchema: mu,
  LoggingUrlSchema: Su,
  MAX_COST_CENTER_PRODUCTS: $c,
  MAX_COST_CENTER_USERS: Rc,
  MAX_PRODUCT_ACCESS_ADMINS: Mc,
  MAX_WHITELIST_EMAIL_DOMAINS: Pc,
  MaxActiveUsersSchema: eu,
  MaxAnnualDeviceDeactivationsSchema: to,
  MaxBoundDevicesSchema: eo,
  MaxClientsSchema: Ou,
  MaxConnectionsSchema: vu,
  MaxSimultaenousSessionsSchema: ro,
  NAME_MAX_LENGTH: Uc,
  NAME_MIN_LENGTH: Ic,
  NameValidationSchema: xe,
  OfflineDurationDaysSchema: no,
  PRODUCT_ACCESS_TYPES: k,
  PRODUCT_NAMES: bc,
  PRODUCT_NAMES_LIST: Zn,
  ProductAccessAdminsSchema: Hc,
  ProductAccessCustomFieldKeysSchema: du,
  ProductAccessCustomFieldStatusSchema: su,
  ProductAccessCustomKeyValidator: nu,
  ProductAccessFeatureStamp: sc,
  ProductAccessFeatureTypeSchema: Xc,
  ProductAccessFeatureValueSchema: Jc,
  ProductAccessFeatureValueTypesList: Bc,
  ProductAccessSchema: Ao,
  ProductAccessSchemaValidator: _o,
  ProductAccessStamp: oc,
  ProductAccessTypesSchema: lu,
  ProductAccessUserArchivedDate: co,
  ProductAccessUserEndDate: so,
  ProductAccessUserLastUsedDate: io,
  ProductAccessUserStamp: je,
  ProductAccessUserStartDate: ao,
  ProductAccessUsersProductSchema: mo,
  ProductAccessUsersValidator: lo,
  ProductBaseValidator: So,
  ProductFeatureSchema: Wc,
  ProductFeaturesSchema: zc,
  ProductFeaturesSchemaValidator: Yc,
  ProductLicenseStamp: uc,
  ProductNameSchema: qc,
  ProductRegionSchema: Fc,
  ProductSchema: Eo,
  ProductUserSchema: uo,
  REGION_MAX_LENGTH: vc,
  REGION_MIN_LENGTH: Oc,
  RegionValidationSchema: Gc,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ge,
  SHARED_COMPUTER_STATUSES: ve,
  SchemaVersionSchema: Qn,
  SeqGeqUserStamp: dc,
  SharedComputerFWMIdentifierTypeSchema: fu,
  SharedComputerFingerprintIdentifierSchema: Tu,
  SharedComputerFingerprintIdentifierTypeSchema: Au,
  SharedComputerHWAIdentifierSchema: pu,
  SharedComputerHWAIdentifierTypeSchema: _u,
  SharedComputerIdentifiersSchema: Nu,
  SharedComputerIdentifiersSchemaValidator: Uu,
  SharedComputerSchema: yu,
  SharedComputerSchemaValidator: Iu,
  SharedComputerStamp: ic,
  SharedComputerStatusSchema: Eu,
  SharedComputersMaxSchema: tu,
  SharedComputersSchema: Ru,
  StartDateSchema: Kc,
  UserLicenseCustomFieldValuesSchema: oo,
  UserLicenseCustomValueValidator: ou,
  UsersLicenseStamp: ac,
  WORLD_WIDE: nc,
  WhilelistDomainsSchema: wc,
  costCenterSchemas: Ie,
  createCostCenter: qt,
  createCostCenterFromJson: pc,
  createIndividualCostCenter: Tc,
  createInstitutionalCostCenter: gc,
  createProductAccess: Sc,
  createProductAccessFeature: Ec,
  createProductUser: Dc,
  createSharedComputer: mc,
  currentCostCenterSchema: am,
  findFirstProduct: fc,
  findProduct: Ac,
  getIndividualCostCenterName: Kn,
  isUserMemberOfCostCenter: hc,
  isUserMemberOfUserProductAccess: Cc,
  isUserValid: Mu,
  iterateProducts: _c,
  productUserStamp: zn
}, Symbol.toStringTag, { value: "Module" })), Zm = new yM.Chance(), Pe = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/, z1 = /^d-[a-f0-9]{32}$/, K1 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, Z = "v1";
function ce() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function Z1(e = 1) {
  return new Date(Date.now() + e * 1e3).toISOString();
}
function uy(e) {
  return Buffer.from(e, "utf-8").toString("base64");
}
function dy(e) {
  if (e < 1) throw new Error("must pass a number greater than 1");
  return uy(cS.randomBytes(e));
}
function Q1(e) {
  if (!e) throw new Error("must pass a Base64 string");
  if (!/^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/.test(e)) throw new Error("must pass a Base64 string");
  return Buffer.from(e, "base64").toString("utf-8");
}
function ej(e) {
  return dy(e);
}
function tj() {
  return (/* @__PURE__ */ new Date()).valueOf();
}
function F() {
  return ya();
}
function tn(e) {
  return !(!e || typeof e != "string" || !e.match(Pe));
}
function ly(e) {
  if (!tn(e))
    throw new Error(`Invalid uuid: ${e}`);
  return e;
}
function my(e) {
  try {
    ly(e);
  } catch (t) {
    throw console.error(t), new Na(e);
  }
  return e;
}
function S() {
  return F();
}
function Os(e, t = null) {
  return new Promise((r, n) => {
    let o;
    e.protocol === "https:" ? o = lS : o = dS;
    const a = o.request(e, (i) => {
      let c = "";
      i.setEncoding !== void 0 && i.setEncoding("utf8"), i.on("data", (m) => {
        c += m;
      }), i.on("end", () => {
        r(c);
      });
    });
    a.on("error", (i) => {
      n(i.message);
    });
    try {
      t !== null && a.write(t), a.end();
    } catch (i) {
      n(i);
    }
  });
}
function rj(e, t = {}, r = !0) {
  const n = new Ta(e);
  let { port: o } = n;
  o ? o = parseInt(o, 10) : n.protocol === "https:" ? o = 443 : o = 80;
  let a;
  return !r || r === "true" ? a = {
    protocol: n.protocol,
    host: n.hostname,
    port: o,
    path: n.pathname + n.query,
    method: "GET",
    headers: t
  } : a = {
    protocol: n.protocol,
    host: n.hostname,
    port: o,
    path: n.pathname + n.query,
    method: "GET",
    rejectUnauthorized: !1,
    headers: t
  }, Os(a);
}
function nj(e, t = {}) {
  const r = new Ta(e);
  let { port: n } = r;
  n ? n = parseInt(n, 10) : r.protocol === "https:" ? n = 443 : n = 80;
  const o = {
    protocol: r.protocol,
    host: r.hostname,
    port: n,
    path: r.pathname + r.query,
    method: "POST",
    headers: t
  };
  return Os(o);
}
function oj(e, t, r = {}, n = !0) {
  try {
    const o = new Ta(e);
    let { port: a } = o;
    a ? a = parseInt(a, 10) : o.protocol === "https:" ? a = 443 : a = 80;
    const i = JSON.stringify(t);
    r = {
      "Content-Type": "application/json;charset=UTF-8",
      "Content-Length": i.length,
      ...r
    };
    const m = {
      protocol: o.protocol,
      host: o.hostname,
      port: a,
      path: o.pathname + o.query,
      method: "PUT",
      headers: r,
      rejectUnauthorized: n
    };
    return Os(m, i);
  } catch (o) {
    console.log("sendjsonerror: ", { error: o });
  }
}
function sj({
  id: e,
  owner: t,
  // @ts-expect-error Property does not exist on destructured empty object
  // @ts-expect-error Property does not exist on destructured empty object
  users: r,
  whitelistDomains: n,
  includeSeqGeq: o,
  includeFlowJo: a
} = {}) {
  t || (t = F()), r || (r = [F(), F(), F(), F()]), o === void 0 && (o = !0), a === void 0 && (a = !0);
  const i = ce(), c = `${Zm.first()} ${Zm.last()} ${F()}`;
  n || (n = ["@flowjo.com"]);
  const m = null, d = "US", p = "EU", N = 2e3, M = 120, q = ee.createInstitutionalCostCenter(
    c,
    n,
    t,
    // @ts-expect-error Optional parameter
    "US"
  );
  e && (q.id = e), q.users = r;
  let G;
  o && (G = ee.createProductAccess(
    O.seqGeq,
    t,
    i,
    null,
    ee.PRODUCT_ACCESS_TYPES.release,
    null,
    6
  ), G.users = {}, r.forEach((j) => {
    const Oe = ee.createProductUser(j);
    G.users[j] = Oe;
  }), q.productAccess.push(G));
  let b;
  return a && (b = ee.createProductAccess(
    O.flowJo,
    t,
    i,
    null,
    ee.PRODUCT_ACCESS_TYPES.release,
    null,
    6
  ), b.users = {}, r.forEach((j) => {
    const Oe = ee.createProductUser(j);
    b.users[j] = Oe;
  }), q.productAccess.push(b)), {
    owner: t,
    users: r,
    startDate: i,
    endDate: m,
    costCenterName: c,
    whitelistDomains: n,
    region1: d,
    region2: p,
    diskSpaceGb: N,
    yearlyDlGb: M,
    costCenter: q,
    seqGeq: G,
    flowJo: b
  };
}
const Sy = (e = "") => e.replace(/^\?/, "").split("&").filter(Boolean).reduce((t, r) => {
  const [n, o] = r.split(/=(.+)/);
  return Object.assign(t, {
    [n]: o
  });
}, {}), Ey = (e = {}) => {
  const t = Object.keys(e).map((r) => `${r}=${e[r]}`).join("&");
  return t ? `?${t}` : "";
}, _y = () => Sy(window.location.search), aj = (e = {}, t = !1) => {
  const r = { ..._y(), ...e }, n = Ey(r);
  t ? window.history.pushState(null, "", n) : window.history.replaceState(null, "", n);
}, ij = (e, t) => OM.isEmpty(e) ? {} : Object.keys(e).reduce((r, n) => (r[t(n)] = e[n], r), {});
function cj(e, t) {
  const r = Math.floor(t);
  if (!e || e.length === 0 || !(r >= 1)) return [];
  const n = [];
  for (let o = 0; o < e.length; o += r)
    n.push(e.slice(o, o + r));
  return n;
}
const uj = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/, NX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  API_VERSION: Z,
  DATE_TIME_REGEX: K1,
  SEMVER_REGEX: uj,
  SENDGRID_TRANSACTIONAL_REGEX: z1,
  UUID_REGEX: Pe,
  chunk: cj,
  currentTime: ce,
  fromBase64: Q1,
  futureTime: Z1,
  generatePasswordResetCode: ej,
  getCurrentEpochTimeUtc: tj,
  getCurrentQueryParams: _y,
  getJson: rj,
  httpOperationAsync: Os,
  isValidUUID: tn,
  newRequestId: S,
  newUUID: F,
  oneOfEachInstitutionalCostCenter: sj,
  parseQueryParamsFromString: Sy,
  parseQueryParamsToString: Ey,
  postJson: nj,
  randomStringAsBase64: dy,
  sendJson: oj,
  toBase64: uy,
  transformKeys: ij,
  updateQueryParams: aj,
  validateUUID: ly,
  validateUserId: my
}, Symbol.toStringTag, { value: "Module" })), Ay = `/api/admin/${Z}`;
function dj() {
  return Ay;
}
function vs() {
  return `${Ay}/actions`;
}
function fy() {
  return `${vs()}/scripts`;
}
function hy() {
  return `${vs()}/client`;
}
function Cy() {
  return `${vs()}/all-users`;
}
function lj(e) {
  return e + fy();
}
function mj(e) {
  return e + hy();
}
function Sj(e) {
  return e + Cy();
}
const yX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  adminAllUsersPath: Cy,
  adminAllUsersUrl: Sj,
  adminBasePath: dj,
  adminClientPath: hy,
  adminClientUrl: mj,
  adminPath: vs,
  adminScriptsPath: fy,
  adminScriptsUrl: lj
}, Symbol.toStringTag, { value: "Module" })), ue = `/api/auth/${Z}`, Ej = "/password/generate-reset-code", _j = "/password/reset-forgotten-password", Aj = "/password/change-password", fj = "/auth-token/generate", hj = "/auth-token/get-user";
function Dy() {
  return ue;
}
function Cj(e) {
  return e + Dy();
}
function py() {
  return `${ue}/login`;
}
function Ty() {
  return `${ue}/client/config`;
}
function Dj(e) {
  return e + Ty();
}
function pj(e) {
  return e + py();
}
function gy() {
  return ue + Ej;
}
function Tj(e) {
  return e + gy();
}
function Iy() {
  return ue + _j;
}
function gj(e) {
  return e + Iy();
}
function Uy() {
  return ue + Aj;
}
function Ij(e) {
  return e + Uy();
}
function Ny() {
  return ue + fj;
}
function Uj(e) {
  return e + Ny();
}
function yy() {
  return ue + hj;
}
function Nj(e) {
  return e + yy();
}
const OX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authBasePath: Dy,
  authBaseUrl: Cj,
  changePasswordPath: Uy,
  changePasswordUrl: Ij,
  clientConfigPath: Ty,
  clientConfigUrl: Dj,
  generateResetCodePath: gy,
  generateResetCodeUrl: Tj,
  generateUserAuthTokenPath: Ny,
  generateUserAuthTokenUrl: Uj,
  getUserByAuthTokenPath: yy,
  getUserByAuthTokenUrl: Nj,
  loginPath: py,
  loginUrl: pj,
  resetForgottenPasswordPath: Iy,
  resetForgottenPasswordUrl: gj
}, Symbol.toStringTag, { value: "Module" })), { newUUID: yj, currentTime: Oj } = U, Ze = "1", K = "default", Ps = ka.slice().concat([K]), te = {
  eula: "eula",
  privacyPolicy: "privacyPolicy"
}, Jt = [];
Object.keys(te).forEach((e) => {
  Jt.push(te[e]);
});
function Wt(e) {
  return e === null ? null : $M(new Date(e), "yyyyMMddHHmmss");
}
const Qe = l({
  refs: {
    id: null,
    text: null,
    productName: null,
    productType: null,
    productVersion: null,
    agreementVersion: null,
    ccCountry: null,
    region: null,
    type: null,
    createdAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = yj()), e.createdAt || (e.createdAt = Oj()), e.agreementVersion || (e.agreementVersion = Wt(/* @__PURE__ */ new Date())), e.schemaVersion = Ze;
  }
});
function Rs(e) {
  const t = { ...e, objects: {} };
  return Qe(t);
}
function $s(e, t, r, n, o, a, i, c) {
  return Qe({
    text: e,
    productName: t,
    productType: r,
    productVersion: n,
    agreementVersion: o,
    ccCountry: a,
    region: i,
    type: c
  });
}
const im = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  REGIONAL_DEFAULT: K,
  TYPES: te,
  TYPE_VALUES: Jt,
  USER_AGREEMENT_PRODUCT_TYPES: Ps,
  USER_AGREEMENT_SCHEMA_VERSION: Ze,
  UserAgreementStamp: Qe,
  convertDateToAgreementVersion: Wt,
  createUserAgreement: $s,
  createUserAgreementFromJson: Rs
}, Symbol.toStringTag, { value: "Module" })), { COST_CENTER_TYPES: Oy, ACTIVITY_STATES: vj, findProduct: Ms } = Y1;
let cm = console;
function Pj(e) {
  cm = e;
}
function Rj() {
  return cm;
}
const um = {
  SUBJECT: "sub",
  AUDIENCE: "aud",
  EXPIRATION: "exp",
  ISSUER: "iss",
  NOT_BEFORE: "nbf",
  ISSUED_AT: "iat",
  JWT_ID: "jti"
}, vy = {
  LATEST_EULA_ACCEPTED_AT: "eula",
  SUPER_ADMIN: "sudo"
};
function Py(e) {
  return e != null;
}
function bs(e, t) {
  if (Py(e)) {
    const r = e.split(".");
    return JSON.parse(RM.decode(r[1]))[t];
  }
  return null;
}
function $j(e) {
  return bs(e, vy.SUPER_ADMIN);
}
function Mj(e) {
  return bs(e, um.SUBJECT);
}
function bj(e) {
  return bs(e, um.JWT_ID);
}
function Vj() {
  return {
    productName: O.cloud,
    productAccessType: Mn.release,
    productVersion: "1.0",
    // this means 'latest' and doesn't change for the portal product
    ccCountry: K,
    region: K,
    agreementType: te.eula
  };
}
function Lj(e, t, r = !1) {
  const n = {};
  for (const o of Object.keys(t)) {
    const a = t[o];
    (a.owner === e || a.admins.includes(e)) && (r || a.type === Oy.institutional) && Object.assign(n, {
      [o]: t[o]
    });
  }
  return n;
}
function Ry(e, t) {
  let r;
  for (const n of Object.keys(e.emails))
    t.toLowerCase() === n.toLowerCase() && (r = e.emails[n]);
  return r ? r.verified : !1;
}
function qj(e) {
  return Ry(e, e.primaryEmail);
}
const $y = (e, t, r) => {
  if (e === void 0 || t === void 0 || r === void 0)
    return !1;
  const n = (/* @__PURE__ */ new Date()).toISOString();
  return e === !0 ? !1 : r === null && e === !1 ? !0 : !(r !== null && n.valueOf() > r.valueOf() || n.valueOf() < t.valueOf());
}, rn = (e, t, r) => {
  if (e === void 0 || t === void 0 || r === void 0)
    return !1;
  const n = (/* @__PURE__ */ new Date()).toISOString();
  return e === ve.inactive || e === ve.deleted || e === null ? !1 : r === null && e === ve.active ? !0 : !(r !== null && n.valueOf() > r.valueOf() || n.valueOf() < t.valueOf());
}, Fj = (e, t, r, n, o, a) => {
  const i = rn(n, a, o), c = rn(e, r, t);
  let m = 0;
  return !c && i ? m = 1 : c && !i && (m = -1), m;
};
function wj(e) {
  return !!(e && new Date(e).valueOf() <= new Date(ce()).valueOf());
}
const Gj = (e) => {
  let t = 0;
  return e && Object.keys(e).forEach((r) => {
    const { suspended: n, startDate: o, endDate: a } = e[r];
    $y(n, o, a) && (t += 1);
  }), t;
}, jj = (e) => {
  let t = 0;
  return e && Object.keys(e).forEach((r) => {
    const n = e[r], { startDate: o, endDate: a, status: i } = n;
    rn(i, o, a) && (t += 1);
  }), t;
}, My = (e, t, r) => {
  const n = e - t;
  return Number.isNaN(n) || Number.isNaN(r) ? NaN : n < 0 || n > 0 && n <= r ? n : n > r ? r : 0;
}, Tr = (e) => Number.isInteger(e) && e >= 0;
function Vs(e, t) {
  if (!Tr(t))
    throw new Error("Invalid pendingInvitesCount input for getSeatUsageForProductAccess");
  if (!e || typeof e != "object")
    throw new Error("Invalid license input for getSeatUsageForProductAccess");
  const { users: r, maxActiveUsers: n, sharedComputers: o, maxSharedComputers: a } = e;
  (!Tr(n) || !Tr(a)) && cm.error(
    { productAccessId: e.id, productAccessName: e.name, maxActiveUsers: n, maxSharedComputers: a },
    "getSeatUsageForProductAccess: productAccess maxActiveUsers/maxSharedComputers must be non-negative integers - this should not happen and should be fixed at the source"
  );
  const i = Gj(r), c = n, m = jj(o), d = c - (i + m + t);
  return {
    maxSeats: c,
    // re-labeled once Shared Computers were added
    maxShared: a,
    allocatedSeats: i + m + t,
    openSeats: d,
    openSharedSeats: My(a, m, d),
    activeUserSeats: i,
    activeSharedSeats: m,
    pendingUserInvites: t
  };
}
const xj = (e, t) => typeof e == "number" && !Number.isNaN(e) && e >= t;
function kj(e, t, r, n) {
  const o = Ms(t, e, Ut, r);
  return Vs(o, n);
}
function Hj(e, t, r) {
  const n = Ms(e, O.flowJo, Ut, t);
  return Vs(n, r);
}
function Bj(e, t, r) {
  const n = Ms(e, O.seqGeq, Ut, t);
  return Vs(n, r);
}
function Xj(e, t) {
  return !t || t.type === Oy.individual ? !1 : !!(tn(e) && tn(t.owner) && (e === t.owner || t.admins?.includes(e)));
}
function Jj(e, t, r, n, o) {
  const a = Ms(t, r, o, n);
  return a && t && a.users && t.users && a.users[e] !== void 0 && a.users[e].userId === e && t.users.includes(e);
}
const by = (e) => e?.activityState === vj.active;
function Vy(e, t = /* @__PURE__ */ new Date()) {
  const r = new Date(e.startDate);
  return t.valueOf() >= r.valueOf();
}
function Ly(e, t = /* @__PURE__ */ new Date()) {
  if (!e.endDate) return !1;
  const r = new Date(e.endDate);
  return t.valueOf() > r.valueOf();
}
const qy = (e, t = /* @__PURE__ */ new Date()) => e ? by(e) && Vy(e, t) && !Ly(e, t) : !1, Wj = (e, t) => {
  if (e == null || t === void 0 || t === null)
    throw new Error("Date and/or days parameter undefined or null.");
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e))
    throw new Error("Invalid iso date format.");
  if (typeof t != "number")
    throw new Error("Days parameter expected to be a number.");
  const r = new Date(e);
  return r.setDate(r.getDate() + t), r.toISOString();
}, vX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JWT_CUSTOM_CLAIM_NAMES: vy,
  JWT_REGISTERED_CLAIM_NAMES: um,
  getAuthUtilsLogger: Rj,
  getClaimFromJWT: bs,
  getCombinedEulaFilterSettings: Vj,
  getFlowJoSeatUsage: Hj,
  getJTIFromJWT: bj,
  getProductSeatUsage: kj,
  getSeatUsageForProductAccess: Vs,
  getSeqGeqSeatUsage: Bj,
  getSharedSeatNetChange: Fj,
  getUserAdminCostCenters: Lj,
  getUserIdFromJWT: Mj,
  hasAvailableSeats: xj,
  isProductAccessUserMember: Jj,
  isProductActive: by,
  isProductAvailable: qy,
  isProductEnded: Ly,
  isProductStarted: Vy,
  isSeatExpired: wj,
  isSharedSeatActive: rn,
  isSuperAdmin: $j,
  isUserAdmin: Xj,
  isUserEmailVerified: Ry,
  isUserPrimaryEmailVerified: qj,
  isUserSeatActive: $y,
  isValidSeatCount: Tr,
  setAuthUtilsLogger: Pj,
  sharedSeatOpenCount: My,
  timeTravelDaysIso: Wj,
  validateJWT: Py
}, Symbol.toStringTag, { value: "Module" })), Fy = 8, wy = 256, Yj = s.string().min(Fy).max(wy).required(), PX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PASSWORD_MAX_LENGTH: wy,
  PASSWORD_MIN_LENGTH: Fy,
  PasswordSchema: Yj
}, Symbol.toStringTag, { value: "Module" })), { newUUID: zj, currentTime: Qm } = U, dm = "1", lm = l({
  refs: {
    id: null,
    userId: null,
    productAccessId: null,
    name: null,
    identifiers: null,
    createdAt: null,
    updatedAt: null,
    lastUsed: null,
    deactivatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = zj()), e.identifiers || (e.identifiers = {}), e.createdAt || (e.createdAt = Qm()), e.deactivatedAt || (e.deactivatedAt = null), e.lastUsed || (e.lastUsed = null), e.updatedAt || (e.updatedAt = Qm()), e.schemaVersion = dm;
  }
});
function Kj(e) {
  const t = { ...e, objects: {} };
  return lm(t);
}
function Zj(e, t, r, n, o, a, i, c) {
  return lm({
    userId: e,
    productAccessId: t,
    name: r,
    identifiers: n,
    createdAt: o,
    updatedAt: a,
    lastUsed: i,
    deactivatedAt: c
  });
}
const Qj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICE_SCHEMA_VERSION: dm,
  AuthorizedDeviceStamp: lm,
  createAuthorizedDevice: Zj,
  createAuthorizedDeviceFromJson: Kj
}, Symbol.toStringTag, { value: "Module" })), ex = s.number().integer().min(0).required(), Gy = s.any().valid(dm).required(), jy = s.alternatives().try(null, h).required(), xy = s.alternatives().try(null, h).required(), ky = s.array().items(s.string()).unique().required(), Hy = s.object({
  hwas: ky
}), tx = s.object().keys({
  id: u,
  userId: u,
  productAccessId: u,
  name: s.string().required(),
  identifiers: Hy,
  createdAt: D,
  updatedAt: A,
  lastUsed: xy,
  deactivatedAt: jy,
  schemaVersion: Gy
}), rx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthorizedDeviceObjectSchema: tx,
  DeletedAtSchema: jy,
  HardwareAddressesSchema: ky,
  IdentifiersSchema: Hy,
  LastUsedSchema: xy,
  SchemaVersionSchema: Gy,
  TtlSecondsSchema: ex
}, Symbol.toStringTag, { value: "Module" })), nx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthorizedDevice: Qj,
  AuthorizedDeviceValidators: rx
}, Symbol.toStringTag, { value: "Module" })), { newUUID: ox, currentTime: eS } = U, et = "2", tt = {
  HWAS: "hwas",
  FINGERPRINT: "fingerprint"
}, rt = l({
  refs: {
    id: null,
    userId: null,
    productAccessId: null,
    name: null,
    identifiers: null,
    createdAt: null,
    updatedAt: null,
    lastUsed: null,
    deactivatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = ox()), e.identifiers || (e.identifiers = {}), e.createdAt || (e.createdAt = eS()), e.deactivatedAt || (e.deactivatedAt = null), e.lastUsed || (e.lastUsed = null), e.updatedAt || (e.updatedAt = eS()), e.schemaVersion = et;
  }
});
function Ls(e) {
  const t = { ...e, objects: {} };
  return rt(t);
}
function qs(e, t, r, n, o, a, i, c) {
  return rt({
    userId: e,
    productAccessId: t,
    name: r,
    identifiers: n,
    createdAt: o,
    updatedAt: a,
    lastUsed: i,
    deactivatedAt: c
  });
}
const sx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICE_SCHEMA_VERSION: et,
  AuthorizedDeviceStamp: rt,
  IDENTIFIER_TYPES: tt,
  createAuthorizedDevice: qs,
  createAuthorizedDeviceFromJson: Ls
}, Symbol.toStringTag, { value: "Module" })), Fs = s.number().integer().min(0).required(), Yt = s.any().valid(et).required(), zt = s.alternatives().try(null, h).required(), Kt = s.alternatives().try(null, h).required(), Zt = s.array().items(s.string()).unique().required(), Qt = Yb, er = s.object({
  [tt.HWAS]: Zt
}), tr = s.object({
  [tt.FINGERPRINT]: Qt
}), rr = s.alternatives().try(er, tr).required(), ws = s.object().keys({
  id: u,
  userId: u,
  productAccessId: u,
  name: s.string().required(),
  identifiers: rr,
  createdAt: D,
  updatedAt: A,
  lastUsed: Kt,
  deactivatedAt: zt,
  schemaVersion: Yt
}), ax = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthorizedDeviceObjectSchema: ws,
  DeletedAtSchema: zt,
  FingerprintIdentifierSchema: tr,
  FingerprintSchema: Qt,
  HWAIdentifierSchema: er,
  HardwareAddressesSchema: Zt,
  IdentifiersSchema: rr,
  LastUsedSchema: Kt,
  SchemaVersionSchema: Yt,
  TtlSecondsSchema: Fs
}, Symbol.toStringTag, { value: "Module" })), ix = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthorizedDevice: sx,
  AuthorizedDeviceValidators: ax
}, Symbol.toStringTag, { value: "Module" })), Tt = ["1", "2"], nr = Tt[Tt.length - 1], or = {
  1: nx,
  2: ix
}, sr = or[nr], { AuthorizedDevice: mm, AuthorizedDeviceValidators: Sm } = sr, cx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICE_SCHEMA_VERSION: et,
  AuthorizedDevice: mm,
  AuthorizedDeviceObjectSchema: ws,
  AuthorizedDeviceStamp: rt,
  AuthorizedDeviceValidators: Sm,
  CURRENT_SCHEMA_VERSION: nr,
  DeletedAtSchema: zt,
  FingerprintIdentifierSchema: tr,
  FingerprintSchema: Qt,
  HWAIdentifierSchema: er,
  HardwareAddressesSchema: Zt,
  IDENTIFIER_TYPES: tt,
  IdentifiersSchema: rr,
  KNOWN_VERSIONS: Tt,
  LastUsedSchema: Kt,
  SchemaVersionSchema: Yt,
  TtlSecondsSchema: Fs,
  authorizedDeviceSchemas: or,
  createAuthorizedDevice: qs,
  createAuthorizedDeviceFromJson: Ls,
  currentAuthorizedDeviceSchema: sr
}, Symbol.toStringTag, { value: "Module" })), RX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICE_SCHEMA_VERSION: et,
  AuthorizedDevice: mm,
  AuthorizedDeviceObjectSchema: ws,
  AuthorizedDeviceStamp: rt,
  AuthorizedDeviceValidators: Sm,
  CURRENT_SCHEMA_VERSION: nr,
  DeletedAtSchema: zt,
  FingerprintIdentifierSchema: tr,
  FingerprintSchema: Qt,
  HWAIdentifierSchema: er,
  HardwareAddressesSchema: Zt,
  IDENTIFIER_TYPES: tt,
  IdentifiersSchema: rr,
  KNOWN_VERSIONS: Tt,
  LastUsedSchema: Kt,
  SchemaVersionSchema: Yt,
  TtlSecondsSchema: Fs,
  authorizedDeviceSchemas: or,
  createAuthorizedDevice: qs,
  createAuthorizedDeviceFromJson: Ls,
  currentAuthorizedDeviceSchema: sr
}, Symbol.toStringTag, { value: "Module" })), $X = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICE_SCHEMA_VERSION: et,
  AuthorizedDevice: mm,
  AuthorizedDeviceObjectSchema: ws,
  AuthorizedDeviceStamp: rt,
  AuthorizedDeviceValidators: Sm,
  CURRENT_SCHEMA_VERSION: nr,
  DeletedAtSchema: zt,
  FingerprintIdentifierSchema: tr,
  FingerprintSchema: Qt,
  HWAIdentifierSchema: er,
  HardwareAddressesSchema: Zt,
  IDENTIFIER_TYPES: tt,
  IdentifiersSchema: rr,
  KNOWN_VERSIONS: Tt,
  LastUsedSchema: Kt,
  SchemaVersionSchema: Yt,
  TtlSecondsSchema: Fs,
  authorizedDeviceSchemas: or,
  createAuthorizedDevice: qs,
  createAuthorizedDeviceFromJson: Ls,
  currentAuthorizedDeviceSchema: sr
}, Symbol.toStringTag, { value: "Module" })), By = "LOGIN", Xy = "START_CLOUD_WATCHER", Jy = "LOGOUT", Wy = "CREATE_USER", Yy = "SET_USER_KEY_VALUE", ux = "SUBSCRIBE_TO_SITE", dx = "UNSUBSCRIBE_TO_SITE", zy = "SEND_NOTIFICATION", lx = "DELETE_SITE", mx = "DELETE_USER", Ky = "SET_SITE", Zy = "SET_USER", Qy = "USER_PRODUCT_LICENSES", eO = "COST_CENTERS", tO = "USERS", rO = "PRODUCTS", nO = "FIND_USER_BY_PRIMARY_EMAIL", oO = "AUTHORIZED_DEVICES", sO = "AUTHORIZED_DEVICES_REMOVALS_REMAINING", aO = "UPDATE_USER_TRACKING", iO = "USER_UPDATE_FIELD", cO = "USER_UPDATE_FIELDS", uO = "CREATE_NEW_USER", Sx = "CREATE_NEW_USER_SUCCESS", dO = "CONVERT_PHANTOM_USER_TO_USER", lO = "CREATE_NEW_COST_CENTER", Ex = "REGISTER_SEQ_GEQ_TRIAL", mO = "REGISTER_PRODUCT_TRIAL", SO = "GENERATE_PASSWORD_RESET_CODE", EO = "RESET_FORGOTTEN_PASSWORD", _O = "CHANGE_PASSWORD", AO = "GENERATE_USER_AUTH_TOKEN", fO = "GET_USER_BY_AUTH_TOKEN;", hO = "AUTHORIZED_DEVICES_DEACTIVATE", CO = "AUTHORIZED_DEVICE_RENAME", DO = "IMPORT_AUTHORIZED_DEVICE_FROM_FINGERPRINT", pO = "PRODUCT_ADD_USERS", TO = "PRODUCT_SET_USERS_SUSPENDED", gO = "PRODUCT_SET_USERS_END_DATE", IO = "PRODUCT_SET_USERS_ARCHIVED_DATE", UO = "STORE_PRODUCT_SET_USERS_END_DATE_RESULT", NO = "CLEAR_PRODUCT_SET_USERS_END_DATE_RESULT", yO = "STORE_PRODUCT_SET_USERS_ARCHIVED_DATE_RESULT", OO = "CLEAR_PRODUCT_SET_USERS_ARCHIVED_DATE_RESULT", vO = "STORE_SET_USERS_SUSPENDED_RESULT", PO = "CLEAR_SET_USERS_SUSPENDED_RESULT", RO = "USER_AGREEMENT_GET", $O = "USER_AGREEMENT_ACCEPTED_GET", MO = "USER_AGREEMENT_ACCEPTED_SET", bO = "USER_AGREEMENT_STOWE", VO = "USER_HAS_NOT_AGREED_YET", LO = "USER_HAS_AGREED", qO = "EMAIL_VERIFICATION_TOKEN_SEND", FO = "EMAIL_VERIFICATION_TOKEN_RESEND", wO = "EMAIL_VERIFICATION_TOKEN_VERIFY", GO = "EMAIL_VERIFICATION_FETCHING", jO = "EMAIL_VERIFICATION_FAILED", xO = "EMAIL_VERIFICATION_UNVERIFIED", kO = "EMAIL_VERIFICATION_EXPIRED", HO = "EMAIL_VERIFICATION_VERIFIED", BO = "EMAIL_VERIFICATION_CLEAR", XO = "INVITE_USER_PRODUCT_ACCESS", JO = "INVITE_USER_PRODUCT_ACCESS_ACCEPT", WO = "INVITE_USER_PRODUCT_CANCEL_INVITES", YO = "INVITE_USER_PRODUCT_ACCESS_GET_COST_CENTER", zO = "CUSTOM_FIELDS_CREATE_KEYS", KO = "CUSTOM_FIELDS_UPDATE_KEYS", ZO = "CUSTOM_FIELDS_CREATE_OR_UPDATE_VALUES", QO = "ADMIN_CREATE_NEW_USER", ev = "ADMIN_CREATE_NEW_COST_CENTER", tv = "ADMIN_ADD_PRODUCT_TO_COST_CENTER", rv = "ADMIN_ADD_USER_TO_COST_CENTER", nv = "ADMIN_ADD_INDIVIDUAL_PHANTOM_USER_TO_PRODUCT", ov = "ADMIN_ADD_USER_TO_PRODUCT", sv = "ADMIN_SET_PRODUCT_NUM_SESSIONS", av = "ADMIN_EXTEND_PRODUCT_ACCESS", iv = "ADMIN_MODIFY_PRODUCT_ACCESS_START", cv = "ADMIN_SET_PASSWORD", uv = "ADMIN_CREATE_USER_AGREEMENT", dv = "ADMIN_COST_CENTER_DETAILS", lv = "ADMIN_GET_COST_CENTER_INVITES", mv = "ADMIN_GET_ALL_ACTIVE_COST_CENTER_INVITES", Sv = "ADMIN_GET_COST_CENTERS", Ev = "ADMIN_GET_COST_CENTERS_COUNT", _v = "ADMIN_GET_COST_CENTERS_VERBOSE", Av = "ADMIN_GET_COST_CENTERS_PAGINATE_VERBOSE", fv = "ADMIN_GET_COST_CENTERS_BY_USER", hv = "ADMIN_GET_USERS_COUNT", Cv = "ADMIN_GET_USERS_VERBOSE", Dv = "ADMIN_GET_USERS_VERBOSE_PAGINATE", pv = "ADMIN_GET_INDIVIDUAL_LICENSES_VERBOSE", Tv = "ADMIN_GET_INSTITUTIONAL_LICENSES_VERBOSE", gv = "ADMIN_SET_PRODUCT_ACCESS_ACTIVITY_STATE", Iv = "ADMIN_SET_PRODUCT_ACCESS_TYPE", Uv = "ADMIN_SET_PRODUCT_DEVICES_OVERRIDE", Nv = "ADMIN_EXPORT_CSV_FOR_HUBSPOT", yv = "ADMIN_ADD_WHITELIST_DOMAIN", Ov = "ADMIN_SET_WHITELIST_IGNORE", vv = "ADMIN_UPDATE_COST_CENTER_AND_PRODCUT_ACCESS_OWNER", Pv = "ADMIN_UPDATE_COST_CENTER_NAME", Rv = "ADMIN_REMOVE_WHITELIST_DOMAIN", $v = "ADMIN_SET_EMAIL_VERIFICATION_STATE", Mv = "ADMIN_SET_USER_OPT_OUT_DATE", bv = "ADMIN_SET_USER_DELETED", Vv = "ADMIN_GET_USER", Lv = "ADMIN_GET_USERS_BY_IDS", qv = "ADMIN_FIND_USERS_BY_PRIMARY_EMAIL", Fv = "ADMIN_GET_USER_GDPR_DATA", wv = "ADMIN_GET_USERS_LAST_USED_N_SECONDS", Gv = "ADMIN_GET_LICENSE_LAST_USED_FOR_USERS", jv = "ADMIN_SET_PRIMARY_EMAIL", xv = "ADMIN_SET_USER_PHANTOM", kv = "ADMIN_SET_USER_KEY_VALUE", Hv = "ADMIN_SET_USER_AUTH_DEVICES_MAX", Bv = "ADMIN_SET_USER_AUTH_DEVICES_REMOVALS_PER_BILLING_YEAR", Xv = "ADMIN_SET_USER_LICENSE_CUSTOM_FIELD_VALUES", Jv = "ADMIN_SET_PRODUCT_ACCESS_MAX_SHARED_COMPUTERS", Wv = "ADMIN_SET_COADMINS", Yv = "ADMIN_SET_COUNTRYCODE", zv = "ADMIN_GENERATE_PRODUCT_KEYPAIR", Kv = "ADMIN_GET_EXPIRING_LICENSES", Zv = "ADMIN_DELETE_USER_AUTHORIZED_DEVICES", Qv = "USER_ADMIN_SYNC_INITIALIZE", eP = "USER_ADMIN_STORE_COST_CENTER_LIST", tP = "USER_ADMIN_FORCE_UPDATE_COST_CENTER_LIST", rP = "USER_ADMIN_SET_SELECTED_COST_CENTER", nP = "USER_ADMIN_SYNC_UPDATE", oP = "USER_ADMIN_STORE_CURRENT_COST_CENTER", _x = "USER_ADMIN_STORE_CURRENT_INVITES", sP = "USER_ADMIN_STORE_CURRENT_USERS", aP = "USER_ADMIN_STORE_CURRENT_LAST_USED", iP = "USER_ADMIN_STORE_CURRENT_AUTHORIZED_DEVICES", cP = "USER_ADMIN_FORCE_UPDATE", uP = "USER_ADMIN_ADD_SHARED_COMPUTER", dP = "USER_ADMIN_UPDATE_SHARED_COMPUTER", lP = "USER_ADMIN_EXPORT_LICENSE", mP = "USER_ADMIN_GET_ACTIVE_LICENSE", SP = "ADMIN_ELASTICSEARCH_USERS_SEARCH", EP = "ADMIN_ELASTICSEARCH_USERS_MAPPINGS", _P = "ADMIN_ELASTICSEARCH_COST_CENTERS_SEARCH", AP = "ADMIN_ELASTICSEARCH_COST_CENTERS_MAPPINGS", fP = "ADMIN_SET_PRODUCT_SEATS", hP = "ADMIN_ADD_PRODUCT_FEATURE", CP = "ADMIN_GET_PRODUCT_FEATURES", DP = "ADMIN_ADD_FEATURE_TO_PRODUCT_ACCESS", pP = "ADMIN_ADD_FEATURE_TO_PRODUCT_ACCESS_USER", TP = "ADMIN_REMOVE_FEATURE_FROM_PRODUCT_ACCESS_USER", gP = "ADMIN_GET_FEATURES_FOR_PRODUCT_ACCESS", IP = "ADMIN_GET_SEAT_STATE_FOR_PRODUCT_ACCESS", UP = "ADMIN_BATCH_ACTIONS", NP = "ADMIN_GET_PRODUCT_AND_VERSION_LIST", yP = "ADMIN_UPDATE_PRODUCT_WHITELISTED_COUNTRIES", OP = "ADMIN_CREATE_PRODUCT_VERSION", vP = "ADMIN_UPDATE_PRODUCT_ASSETS", PP = "ADMIN_UPDATE_PRODUCT_IS_ACTIVE", RP = "ADMIN_CLEAR_REDIS_CACHE", $P = "EXTENDED_OFFLINE_TOKEN_ADD", MP = "EXPORT_EXTENDED_OFFLINE_TOKEN", bP = "EXTENDED_OFFLINE_TOKEN_GET_FOR_USER_AT_DATE", VP = "EXTENDED_OFFLINE_TOKEN_ID_ARCHIVE", Ax = (e, t, r = S()) => ({
  type: qO,
  requestId: r,
  userId: e,
  emailAddress: t
}), fx = (e, t, r = S()) => ({
  type: FO,
  requestId: r,
  userId: e,
  emailAddress: t
}), hx = (e, t, r, n = S()) => ({
  type: wO,
  requestId: n,
  userId: e,
  emailAddress: t,
  token: r
}), Cx = () => ({ type: GO }), Dx = () => ({ type: jO }), px = (e, t) => ({
  type: xO,
  userId: e,
  emailAddress: t
}), Tx = (e, t) => ({
  type: kO,
  userId: e,
  emailAddress: t
}), gx = () => ({ type: HO }), Ix = () => ({ type: BO }), Ux = (e, t, r, n = S()) => ({
  type: XO,
  emailAddresses: e,
  costCenterId: t,
  productAccessId: r,
  requestId: n
}), Nx = (e, t = S()) => ({
  type: WO,
  inviteIds: e,
  requestId: t
}), yx = (e, t, r = S()) => ({
  type: YO,
  userId: e,
  inviteToken: t,
  requestId: r
}), Ox = (e, t, r = void 0, n = S()) => ({
  type: JO,
  userId: e,
  inviteId: t,
  customFieldValues: r,
  requestId: n
}), vx = (e, t, r, n = S()) => ({
  type: zO,
  costCenterId: e,
  productAccessId: t,
  keys: r,
  requestId: n
}), Px = (e, t, r, n = S()) => ({
  type: KO,
  costCenterId: e,
  productAccessId: t,
  keys: r,
  requestId: n
}), Rx = (e, t, r, n, o = S()) => ({
  type: ZO,
  costCenterId: e,
  productAccessId: t,
  userId: r,
  values: n,
  requestId: o
}), $x = (e, t = S()) => ({
  type: Qy,
  userProductLicenses: e,
  requestId: t
}), Mx = (e, t = S()) => ({
  type: oO,
  authorizedDevices: e,
  requestId: t
}), bx = (e, t = S()) => ({
  type: sO,
  authorizedDeviceRemovalsRemaining: e,
  requestId: t
}), Vx = (e, t, r = S()) => ({
  type: aO,
  userId: e,
  optOutDate: t,
  requestId: r
}), Lx = (e, t, r, n = S()) => ({
  type: iO,
  userId: e,
  key: t,
  value: r,
  requestId: n
}), qx = (e, t, r = S()) => ({
  type: cO,
  userId: e,
  updates: t,
  requestId: r
}), Fx = (e, t = S()) => ({
  type: eO,
  costCenters: e,
  requestId: t
}), wx = (e, t = S()) => ({
  type: tO,
  users: e,
  requestId: t
}), Gx = (e, t = S()) => ({
  type: rO,
  products: e,
  requestId: t
}), jx = (e, t = S()) => ({
  type: nO,
  primaryEmail: e,
  requestId: t
}), xx = (e, t = S()) => ({
  type: Qv,
  adminId: e,
  requestId: t
}), kx = (e, t, r = S()) => ({
  type: eP,
  adminCostCenterList: t,
  requestId: r
}), Hx = (e, t = S()) => ({
  type: rP,
  costCenterObj: e,
  requestId: t
}), Bx = (e, t, r, n, o, a = S()) => ({
  type: tP,
  costCenterId: e,
  productAccessId: t,
  label: r,
  identifier: n,
  status: o,
  requestId: a
}), Xx = (e, t, { label: r, identifiers: n, status: o, startDate: a, endDate: i, contactLabel: c, features: m }, d = F(), p = S()) => ({
  type: uP,
  costCenterId: e,
  productAccessId: t,
  sharedComputerId: d,
  label: r,
  identifiers: n,
  // identifiers is an array of identifier objects { type, value }
  status: o,
  startDate: a,
  endDate: i,
  contactLabel: c,
  features: m,
  requestId: p
}), Jx = (e, t, { label: r, identifiers: n, status: o, startDate: a, endDate: i, contactLabel: c, features: m }, d, p = S()) => ({
  type: dP,
  costCenterId: e,
  productAccessId: t,
  sharedComputerId: d,
  label: r,
  identifiers: n,
  // do not include the identifier for FWM
  status: o,
  startDate: a,
  endDate: i,
  contactLabel: c,
  features: m,
  // hardwareIdentifier and licenseNumber for FWM will be ignored (these are not allowed to change)
  requestId: p
}), Wx = (e, t, r, n = S()) => ({
  type: lP,
  costCenterId: e,
  productAccessId: t,
  sharedComputerId: r,
  requestId: n
}), Yx = (e, t, r, n, o = S()) => ({
  type: mP,
  adminEmail: e,
  productName: t,
  ccType: r,
  licenseType: n,
  requestId: o
}), zx = (e, t, r, n = S()) => ({
  type: nP,
  adminId: e,
  costCenter: t,
  users: r,
  requestId: n
}), Kx = (e, t, r = S()) => ({
  type: oP,
  adminId: e,
  costCenter: t,
  requestId: r
}), Zx = (e, t, r = S()) => ({
  type: sP,
  adminId: e,
  users: t,
  requestId: r
}), Qx = (e, t, r = S()) => ({
  type: aP,
  adminId: e,
  lastUsed: t,
  requestId: r
}), ek = (e, t, r = S()) => ({
  type: iP,
  adminId: e,
  authorizedDevices: t,
  requestId: r
}), tk = (e, t, r = S()) => ({
  type: cP,
  productName: t,
  costCenterId: e,
  requestId: r
}), rk = (e, t = S()) => ({
  type: Wy,
  user: e,
  requestId: t
}), nk = (e, t = S()) => ({
  type: zy,
  notification: e,
  requestId: t
}), ok = (e, t, r = S()) => ({
  type: By,
  email: e,
  password: t,
  requestId: r
}), sk = () => ({
  type: Xy
}), ak = (e = S()) => ({
  type: Jy,
  requestId: e
}), ik = (e, t = S()) => ({
  type: Ky,
  requestId: t,
  site: e
}), ck = (e, t = S()) => ({
  type: Zy,
  requestId: t,
  user: e
}), uk = (e, t, r, n, o, a = S()) => ({
  type: uO,
  requestId: a,
  primaryEmail: e,
  firstname: t,
  lastname: r,
  password: n,
  countryCode: o
}), dk = (e, t = S()) => ({
  ...e,
  type: dO,
  requestId: t
}), LP = (e, t, r, n, o, a, i, c, m, d, p = !0, N = !1, M = S()) => ({
  type: mO,
  company: e,
  degreeGranting: t,
  lab: r,
  phone: n,
  fieldOfResearch: o,
  country: a,
  referralBlurb: i,
  productName: c,
  title: m,
  postalcode: d,
  acceptedDataProcessing: p,
  acceptedMarketing: N,
  requestId: M
}), lk = (e, t, r, n, o, a, i, c = S()) => LP(
  e,
  t,
  r,
  n,
  o,
  a,
  i,
  O.seqGeq,
  void 0,
  // title
  void 0,
  // postalcode
  !0,
  // acceptedDataProcessing
  !1,
  // acceptedMarketing
  c
), mk = (e, t, r, n = Mn.release, o = S()) => ({
  type: pO,
  productName: e,
  userEmails: t,
  costCenterId: r,
  productAccessType: n,
  requestId: o
}), Sk = (e, t, r, n, o, a = S()) => ({
  type: TO,
  productName: e,
  userIds: t,
  costCenterId: r,
  productAccessId: n,
  suspended: o,
  requestId: a
}), Ek = (e, t = S()) => ({
  type: vO,
  suspendUsersResult: e,
  requestId: t
}), _k = (e = S()) => ({
  type: PO,
  suspendUsersResult: "closed",
  requestId: e
}), Ak = (e, t, r, n, o, a = S()) => ({
  type: gO,
  productName: e,
  userIds: t,
  costCenterId: r,
  productAccessId: n,
  endDate: o,
  requestId: a
}), fk = (e, t = S()) => ({
  type: UO,
  productSetUsersEndDateResult: e,
  requestId: t
}), hk = (e = S()) => ({
  type: NO,
  productSetUsersEndDate: "closed",
  requestId: e
}), Ck = (e, t, r, n, o, a = S()) => ({
  type: IO,
  productName: e,
  userIds: t,
  costCenterId: r,
  productAccessId: n,
  archivedDate: o,
  requestId: a
}), Dk = (e, t = S()) => ({
  type: yO,
  productSetUsersArchivedDateResult: e,
  requestId: t
}), pk = (e = S()) => ({
  type: OO,
  productSetUsersArchivedDate: "closed",
  requestId: e
}), Tk = (e, t = S()) => ({
  type: SO,
  email: e,
  requestId: t
}), gk = (e, t, r, n = S()) => ({
  type: EO,
  userId: e,
  resetCode: t,
  newPassword: r,
  requestId: n
}), Ik = (e, t, r, n = S()) => ({
  type: _O,
  userId: e,
  oldPassword: t,
  newPassword: r,
  requestId: n
}), Uk = (e, t, r = S()) => ({
  type: AO,
  userId: e,
  primaryEmail: t,
  requestId: r
}), Nk = (e, t = S()) => ({
  type: fO,
  authToken: e,
  requestId: t
}), yk = (e, t, r = S()) => ({
  type: hO,
  userId: e,
  authorizedDeviceId: t,
  requestId: r
}), Ok = (e, t, r, n = S()) => ({
  type: CO,
  userId: e,
  authorizedDeviceId: t,
  newName: r,
  requestId: n
}), vk = (e, t, r, n, o, a = S()) => ({
  type: lO,
  requestId: a,
  whitelistDomains: r,
  owner: e,
  name: t,
  costCenterType: n,
  countryCode: o
}), Pk = (e, t, r, n, o, a, i, c = S()) => ({
  type: ev,
  requestId: c,
  whitelistDomains: r,
  whitelistIgnore: n,
  owner: e,
  name: t,
  costCenterType: o,
  countryCode: a,
  admins: i
}), Rk = (e, t, r, n, o, a = S()) => ({
  type: QO,
  requestId: a,
  primaryEmail: e,
  firstname: t,
  lastname: r,
  password: n,
  countryCode: o
}), $k = (e, t, r, n, o, a, i, c = 0, m = S(), d = !1) => ({
  type: tv,
  requestId: m,
  productName: e,
  costCenterId: t,
  productAccessType: r,
  owner: n,
  startDate: o,
  endDate: a,
  maxActiveUsers: i,
  maxSharedComputers: c,
  authorizedDevicesOverride: d
}), Mk = (e, t, r = S()) => ({
  type: rv,
  requestId: r,
  costCenterId: e,
  userId: t
}), bk = (e, t, r, n, o, a, i = null, c = S()) => ({
  type: nv,
  requestId: c,
  productName: e,
  productAccessType: t,
  primaryEmail: r,
  costCenterCountryCode: n,
  firstName: o,
  lastName: a,
  endDate: i
}), Vk = (e, t, r, n, o = null, a = S()) => ({
  type: ov,
  productName: e,
  requestId: a,
  costCenterId: t,
  productAccessType: r,
  userId: n,
  endDate: o
}), Lk = (e, t, r, n, o, a = S()) => ({
  type: av,
  requestId: a,
  costCenterId: e,
  productName: t,
  productAccessType: r,
  productRegion: n,
  endDate: o
}), qk = (e, t, r, n, o, a = S()) => ({
  type: iv,
  requestId: a,
  costCenterId: e,
  productName: t,
  productAccessType: r,
  productRegion: n,
  startDate: o
}), Fk = (e, t, r, n, o, a = S()) => ({
  type: sv,
  requestId: a,
  productName: e,
  costCenterId: t,
  productAccessType: r,
  primaryEmail: n,
  numSessions: o
}), wk = (e, t, r, n = S()) => ({
  type: Jv,
  costCenterId: e,
  productAccessId: t,
  maxSharedComputers: r,
  requestId: n
}), Gk = (e, t, r = S()) => ({
  type: Wv,
  costCenterId: e,
  admins: t,
  requestId: r
}), jk = (e, t, r, n = S()) => ({
  type: Kv,
  date: e,
  productNames: t,
  productAccessType: r,
  requestId: n
});
function xk(e, t, r = null) {
  return r || (r = S()), {
    type: Zv,
    userId: e,
    identifiers: t,
    requestId: r
  };
}
const kk = (e, t, r = S()) => ({
  type: cv,
  requestId: r,
  userId: e,
  password: t
}), Hk = (e, t, r, n, o, a, i, c = S()) => ({
  type: uv,
  requestId: c,
  text: e,
  productName: t,
  productType: r,
  productVersion: n,
  ccCountry: o,
  region: a,
  agreementType: i
}), Bk = (e, t, r, n, o, a, i = null, c = S()) => ({
  type: RO,
  requestId: c,
  productName: e,
  productType: t,
  productVersion: r,
  ccCountry: n,
  region: o,
  agreementType: a,
  agreementVersion: i
}), Xk = (e, t, r = S()) => ({
  type: MO,
  requestId: r,
  userId: e,
  agreementId: t
}), Jk = (e, t, r = S()) => ({
  type: $O,
  requestId: r,
  userId: e,
  agreementId: t
}), Wk = (e, t = S()) => ({
  type: dv,
  requestId: t,
  costCenterId: e
}), Yk = (e = S()) => ({
  type: Sv,
  requestId: e
}), zk = (e = S()) => ({
  type: Ev,
  requestId: e
}), Kk = (e = S()) => ({
  type: _v,
  requestId: e
}), Zk = (e, t, r, n = S()) => ({
  type: Av,
  limit: e,
  offset: t,
  ccType: r,
  requestId: n
}), Qk = (e, t = S()) => ({
  type: fv,
  requestId: t,
  userId: e
}), eH = (e = S()) => ({
  type: hv,
  requestId: e
}), tH = (e = S()) => ({
  type: Cv,
  requestId: e
}), rH = (e, t, r = S()) => ({
  type: Dv,
  limit: e,
  offset: t,
  requestId: r
}), nH = (e, t = S()) => ({
  type: pv,
  limit: e,
  requestId: t
}), oH = (e, t = S()) => ({
  type: Tv,
  limit: e,
  requestId: t
}), sH = (e, t = S()) => ({
  type: Vv,
  requestId: t,
  primaryEmail: e
}), aH = (e, t = S()) => ({
  type: Lv,
  requestId: t,
  ids: e
}), iH = (e, t = S()) => ({
  type: qv,
  requestId: t,
  primaryEmailPartial: e
}), cH = (e, t = S()) => ({
  type: lv,
  requestId: t,
  costCenterId: e
}), uH = (e = S()) => ({
  type: mv,
  requestId: e
}), dH = (e, t, r, n = S()) => ({
  type: gv,
  requestId: n,
  costCenterId: e,
  productAccessId: t,
  activityState: r
}), lH = (e, t, r, n = S()) => ({
  type: Iv,
  requestId: n,
  costCenterId: e,
  productAccessId: t,
  productAccessType: r
}), mH = (e, t, r, n = S()) => ({
  type: Uv,
  requestId: n,
  costCenterId: e,
  productAccessId: t,
  authorizedDevicesOverride: r
}), SH = (e, t, r, n = S()) => ({
  type: fP,
  requestId: n,
  costCenterId: e,
  productAccessId: t,
  numSeats: r
}), EH = (e, t, r, n, o, a = S()) => ({
  type: hP,
  requestId: a,
  productName: e,
  featureName: t,
  valueType: r,
  startDate: n,
  endDate: o
}), _H = (e, t = S()) => ({
  type: CP,
  requestId: t,
  productName: e
}), AH = (e, t, r, n, o, a = S()) => ({
  type: DP,
  requestId: a,
  featureName: e,
  costCenterId: t,
  productAccessId: r,
  value: n,
  enabled: o
}), fH = (e, t, r, n, o, a, i = S()) => ({
  type: pP,
  requestId: i,
  featureName: e,
  costCenterId: t,
  productAccessId: r,
  userId: n,
  value: o,
  enabled: a
}), hH = (e, t, r, n, o = S()) => ({
  type: TP,
  requestId: o,
  featureName: e,
  costCenterId: t,
  productAccessId: r,
  userId: n
}), CH = (e, t, r = S()) => ({
  type: gP,
  requestId: r,
  costCenterId: e,
  productAccessId: t
}), DH = (e, t, r = S()) => ({
  type: IP,
  requestId: r,
  costCenterId: e,
  productAccessId: t
}), pH = (e, t = S()) => ({
  type: UP,
  requestId: t,
  actions: e
}), TH = (e, t, r = S()) => ({
  type: yv,
  requestId: r,
  costCenterId: e,
  whitelistDomain: t
}), gH = (e, t, r = S()) => ({
  type: Ov,
  requestId: r,
  costCenterId: e,
  whitelistIgnore: t
}), IH = (e, t, r = S()) => ({
  type: vv,
  requestId: r,
  costCenterId: e,
  userEmail: t
}), UH = (e, t, r = S()) => ({
  type: Pv,
  requestId: r,
  costCenterId: e,
  newCostCenterName: t
}), NH = (e, t, r = S()) => ({
  type: Rv,
  requestId: r,
  costCenterId: e,
  whitelistDomain: t
}), yH = (e = S()) => ({
  type: Nv,
  requestId: e
}), OH = (e, t, r = S()) => ({
  type: $v,
  primaryEmail: e,
  emailVerificationState: t,
  requestId: r
}), vH = (e, t, r = S()) => ({
  type: Mv,
  primaryEmail: e,
  optOutDate: t,
  requestId: r
}), PH = (e, t, r = S()) => ({
  type: bv,
  primaryEmail: e,
  requestId: r
}), RH = (e, t = S()) => ({
  type: Fv,
  primaryEmail: e,
  requestId: t
}), $H = (e, t = S()) => ({
  type: wv,
  seconds: e,
  requestId: t
}), MH = (e, t = S()) => ({
  type: Gv,
  userIds: e,
  requestId: t
}), bH = (e, t, r = S()) => ({
  type: jv,
  oldPrimaryEmail: e,
  newPrimaryEmail: t,
  requestId: r
}), VH = (e, t, r = S()) => ({
  type: xv,
  userId: e,
  isPhantom: t,
  requestId: r
}), LH = (e, t, r, n = S()) => ({
  type: kv,
  primaryEmail: e,
  key: t,
  value: r,
  requestId: n
}), qH = (e, t, r, n, o, a, i = S()) => ({
  type: Hv,
  costCenterId: e,
  productName: t,
  productType: r,
  region: n,
  primaryEmail: o,
  numMaxDevices: a,
  requestId: i
}), FH = (e, t, r, n, o, a, i = S()) => ({
  type: Bv,
  costCenterId: e,
  productName: t,
  productType: r,
  region: n,
  primaryEmail: o,
  numRemovals: a,
  requestId: i
}), wH = (e, t, r, n, o, a, i = S()) => ({
  type: Xv,
  costCenterId: e,
  productAccessId: t,
  userId: r,
  valueId: n,
  keyId: o,
  newValue: a,
  requestId: i
}), GH = (e, t, r = S()) => ({
  type: SP,
  searchString: e,
  fields: t,
  requestId: r
}), jH = (e, t, r = S()) => ({
  type: EP,
  requestId: r
}), xH = (e, t, r, n, o, a = S()) => ({
  type: _P,
  searchString: e,
  costCenterType: t,
  productNames: r,
  limit: n,
  offset: o,
  requestId: a
}), kH = (e = S()) => ({
  type: AP,
  requestId: e
}), HH = (e) => ({
  type: VO,
  data: e
}), BH = () => ({
  type: LO,
  data: {}
}), XH = (e) => ({
  type: bO,
  data: e
}), JH = (e, t) => ({
  type: Yv,
  costCenterId: e,
  newValue: t
}), WH = (e, t, r, n, o, a, i = ce()) => ({
  type: zv,
  productName: e,
  productVersion: t,
  productType: r,
  productRegion: n,
  active: o,
  releaseDate: i,
  encryptionBits: a
}), YH = (e, t, r, n = S()) => ({
  type: Yy,
  userId: e,
  key: t,
  value: r,
  requestId: n
}), zH = (e, t, r, n, o, a = S()) => ({
  type: $P,
  userId: e,
  authorizedDeviceId: t,
  startDate: r,
  endDate: n,
  productAccessId: o,
  requestId: a
}), KH = (e, t, r, n, o, a = S()) => ({
  type: MP,
  primaryEmail: e,
  password: t,
  costCenterId: r,
  productAccessId: n,
  eotId: o,
  requestId: a
}), ZH = (e, t, r, n = S()) => ({
  type: bP,
  userId: e,
  date: t,
  productAccessId: r,
  requestId: n
}), QH = (e, t = S()) => ({
  type: VP,
  id: e,
  requestId: t
}), e0 = (e, t, r, n, o, a = S()) => ({
  type: DO,
  userId: e,
  costCenterId: t,
  productAccessId: r,
  fingerprint: n,
  deviceName: o,
  requestId: a
}), t0 = (e = S()) => ({
  type: NP,
  requestId: e
}), r0 = (e, t = [], r = [], n = S()) => ({
  type: yP,
  productId: e,
  addCountries: t.map((o) => o.toUpperCase()),
  removeCountries: r.map((o) => o.toUpperCase()),
  requestId: n
}), n0 = (e, t, r = aE, n = iE, o, a = [], i = !1, c = S()) => ({
  type: OP,
  name: e,
  productVersion: t,
  region: r,
  productType: n,
  releaseDate: o,
  whitelistedCountries: a,
  active: i,
  requestId: c
}), o0 = (e, t = {}, r = S()) => ({
  type: vP,
  productId: e,
  assets: t,
  requestId: r
}), s0 = (e, t, r = S()) => ({
  type: PP,
  productId: e,
  active: t,
  requestId: r
}), a0 = (e, t = [], r = [], n = S()) => ({
  type: RP,
  secretKey: e,
  cacheKeys: t,
  prefixKeys: r,
  requestId: n
}), MX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ADD_USER: Wy,
  ADMIN_ADD_FEATURE_TO_PRODUCT_ACCESS: DP,
  ADMIN_ADD_FEATURE_TO_PRODUCT_ACCESS_USER: pP,
  ADMIN_ADD_INDIVIDUAL_PHANTOM_USER_TO_PRODUCT: nv,
  ADMIN_ADD_PRODUCT_FEATURE: hP,
  ADMIN_ADD_PRODUCT_TO_COST_CENTER: tv,
  ADMIN_ADD_USER_TO_COST_CENTER: rv,
  ADMIN_ADD_USER_TO_PRODUCT: ov,
  ADMIN_ADD_WHITELIST_DOMAIN: yv,
  ADMIN_BATCH_ACTIONS: UP,
  ADMIN_CLEAR_REDIS_CACHE: RP,
  ADMIN_COST_CENTER_DETAILS: dv,
  ADMIN_CREATE_NEW_COST_CENTER: ev,
  ADMIN_CREATE_NEW_USER: QO,
  ADMIN_CREATE_PRODUCT_VERSION: OP,
  ADMIN_CREATE_USER_AGREEMENT: uv,
  ADMIN_DELETE_USER_AUTHORIZED_DEVICES: Zv,
  ADMIN_ELASTICSEARCH_COST_CENTERS_MAPPINGS: AP,
  ADMIN_ELASTICSEARCH_COST_CENTERS_SEARCH: _P,
  ADMIN_ELASTICSEARCH_USERS_MAPPINGS: EP,
  ADMIN_ELASTICSEARCH_USERS_SEARCH: SP,
  ADMIN_EXPORT_CSV_FOR_HUBSPOT: Nv,
  ADMIN_EXTEND_PRODUCT_ACCESS: av,
  ADMIN_FIND_USERS_BY_PRIMARY_EMAIL: qv,
  ADMIN_GENERATE_PRODUCT_KEYPAIR: zv,
  ADMIN_GET_ALL_ACTIVE_COST_CENTER_INVITES: mv,
  ADMIN_GET_COST_CENTERS: Sv,
  ADMIN_GET_COST_CENTERS_BY_USER: fv,
  ADMIN_GET_COST_CENTERS_COUNT: Ev,
  ADMIN_GET_COST_CENTERS_PAGINATE_VERBOSE: Av,
  ADMIN_GET_COST_CENTERS_VERBOSE: _v,
  ADMIN_GET_COST_CENTER_INVITES: lv,
  ADMIN_GET_EXPIRING_LICENSES: Kv,
  ADMIN_GET_FEATURES_FOR_PRODUCT_ACCESS: gP,
  ADMIN_GET_INDIVIDUAL_LICENSES_VERBOSE: pv,
  ADMIN_GET_INSTITUTIONAL_LICENSES_VERBOSE: Tv,
  ADMIN_GET_LICENSE_LAST_USED_FOR_USERS: Gv,
  ADMIN_GET_PRODUCT_AND_VERSION_LIST: NP,
  ADMIN_GET_PRODUCT_FEATURES: CP,
  ADMIN_GET_SEAT_STATE_FOR_PRODUCT_ACCESS: IP,
  ADMIN_GET_USER: Vv,
  ADMIN_GET_USERS_BY_IDS: Lv,
  ADMIN_GET_USERS_COUNT: hv,
  ADMIN_GET_USERS_LAST_USED_N_SECONDS: wv,
  ADMIN_GET_USERS_VERBOSE: Cv,
  ADMIN_GET_USERS_VERBOSE_PAGINATE: Dv,
  ADMIN_GET_USER_GDPR_DATA: Fv,
  ADMIN_MODIFY_PRODUCT_ACCESS_START: iv,
  ADMIN_REMOVE_FEATURE_FROM_PRODUCT_ACCESS_USER: TP,
  ADMIN_REMOVE_WHITELIST_DOMAIN: Rv,
  ADMIN_SET_COADMINS: Wv,
  ADMIN_SET_COUNTRYCODE: Yv,
  ADMIN_SET_EMAIL_VERIFICATION_STATE: $v,
  ADMIN_SET_PASSWORD: cv,
  ADMIN_SET_PRIMARY_EMAIL: jv,
  ADMIN_SET_PRODUCT_ACCESS_ACTIVITY_STATE: gv,
  ADMIN_SET_PRODUCT_ACCESS_MAX_SHARED_COMPUTERS: Jv,
  ADMIN_SET_PRODUCT_ACCESS_TYPE: Iv,
  ADMIN_SET_PRODUCT_DEVICES_OVERRIDE: Uv,
  ADMIN_SET_PRODUCT_NUM_SESSIONS: sv,
  ADMIN_SET_PRODUCT_SEATS: fP,
  ADMIN_SET_USER_AUTH_DEVICES_MAX: Hv,
  ADMIN_SET_USER_AUTH_DEVICES_REMOVALS_PER_BILLING_YEAR: Bv,
  ADMIN_SET_USER_DELETED: bv,
  ADMIN_SET_USER_KEY_VALUE: kv,
  ADMIN_SET_USER_LICENSE_CUSTOM_FIELD_VALUES: Xv,
  ADMIN_SET_USER_OPT_OUT_DATE: Mv,
  ADMIN_SET_USER_PHANTOM: xv,
  ADMIN_SET_WHITELIST_IGNORE: Ov,
  ADMIN_UPDATE_COST_CENTER_AND_PRODCUT_ACCESS_OWNER: vv,
  ADMIN_UPDATE_COST_CENTER_NAME: Pv,
  ADMIN_UPDATE_PRODUCT_ASSETS: vP,
  ADMIN_UPDATE_PRODUCT_IS_ACTIVE: PP,
  ADMIN_UPDATE_PRODUCT_WHITELISTED_COUNTRIES: yP,
  AUTHORIZED_DEVICES: oO,
  AUTHORIZED_DEVICES_DEACTIVATE: hO,
  AUTHORIZED_DEVICES_REMOVALS_REMAINING: sO,
  AUTHORIZED_DEVICE_RENAME: CO,
  CHANGE_PASSWORD: _O,
  CLEAR_PRODUCT_SET_USERS_ARCHIVED_DATE_RESULT: OO,
  CLEAR_PRODUCT_SET_USERS_END_DATE_RESULT: NO,
  CLEAR_SET_USERS_SUSPENDED_RESULT: PO,
  CONVERT_PHANTOM_USER_TO_USER: dO,
  COST_CENTERS: eO,
  CREATE_NEW_COST_CENTER: lO,
  CREATE_NEW_USER: uO,
  CREATE_NEW_USER_SUCCESS: Sx,
  CUSTOM_FIELDS_CREATE_KEYS: zO,
  CUSTOM_FIELDS_CREATE_OR_UPDATE_VALUES: ZO,
  CUSTOM_FIELDS_UPDATE_KEYS: KO,
  DELETE_SITE: lx,
  DELETE_USER: mx,
  EMAIL_VERIFICATION_CLEAR: BO,
  EMAIL_VERIFICATION_EXPIRED: kO,
  EMAIL_VERIFICATION_FAILED: jO,
  EMAIL_VERIFICATION_FETCHING: GO,
  EMAIL_VERIFICATION_TOKEN_RESEND: FO,
  EMAIL_VERIFICATION_TOKEN_SEND: qO,
  EMAIL_VERIFICATION_TOKEN_VERIFY: wO,
  EMAIL_VERIFICATION_UNVERIFIED: xO,
  EMAIL_VERIFICATION_VERIFIED: HO,
  EXPORT_EXTENDED_OFFLINE_TOKEN: MP,
  EXTENDED_OFFLINE_TOKEN_ADD: $P,
  EXTENDED_OFFLINE_TOKEN_GET_FOR_USER_AT_DATE: bP,
  EXTENDED_OFFLINE_TOKEN_ID_ARCHIVE: VP,
  FIND_USER_BY_PRIMARY_EMAIL: nO,
  GENERATE_PASSWORD_RESET_CODE: SO,
  GENERATE_USER_AUTH_TOKEN: AO,
  GET_USER_BY_AUTH_TOKEN: fO,
  IMPORT_AUTHORIZED_DEVICE_FROM_FINGERPRINT: DO,
  INVITE_USER_PRODUCT_ACCESS: XO,
  INVITE_USER_PRODUCT_ACCESS_ACCEPT: JO,
  INVITE_USER_PRODUCT_ACCESS_CANCEL_INVITES: WO,
  INVITE_USER_PRODUCT_ACCESS_GET_COST_CENTER: YO,
  LOGIN: By,
  LOGOUT: Jy,
  PRODUCTS: rO,
  PRODUCT_ADD_USERS: pO,
  PRODUCT_SET_USERS_ARCHIVED_DATE: IO,
  PRODUCT_SET_USERS_END_DATE: gO,
  PRODUCT_SET_USERS_SUSPENDED: TO,
  REGISTER_PRODUCT_TRIAL: mO,
  REGISTER_SEQ_GEQ_TRIAL: Ex,
  RESET_FORGOTTEN_PASSWORD: EO,
  SEND_NOTIFICATION: zy,
  SET_SITE: Ky,
  SET_USER: Zy,
  SET_USER_KEY_VALUE: Yy,
  START_CLOUD_WATCHER: Xy,
  STORE_PRODUCT_SET_USERS_ARCHIVED_DATE_RESULT: yO,
  STORE_PRODUCT_SET_USERS_END_DATE_RESULT: UO,
  STORE_SET_USERS_SUSPENDED_RESULT: vO,
  SUBSCRIBE_TO_SITE: ux,
  UNSUBSCRIBE_TO_SITE: dx,
  UPDATE_USER_TRACKING: aO,
  USERS: tO,
  USER_ADMIN_ADD_SHARED_COMPUTER: uP,
  USER_ADMIN_EXPORT_LICENSE: lP,
  USER_ADMIN_FORCE_UPDATE: cP,
  USER_ADMIN_FORCE_UPDATE_COST_CENTER_LIST: tP,
  USER_ADMIN_GET_ACTIVE_LICENSE: mP,
  USER_ADMIN_SET_SELECTED_COST_CENTER: rP,
  USER_ADMIN_STORE_COST_CENTER_LIST: eP,
  USER_ADMIN_STORE_CURRENT_AUTHORIZED_DEVICES: iP,
  USER_ADMIN_STORE_CURRENT_COST_CENTER: oP,
  USER_ADMIN_STORE_CURRENT_INVITES: _x,
  USER_ADMIN_STORE_CURRENT_LAST_USED: aP,
  USER_ADMIN_STORE_CURRENT_USERS: sP,
  USER_ADMIN_SYNC_INITIALIZE: Qv,
  USER_ADMIN_SYNC_UPDATE: nP,
  USER_ADMIN_UPDATE_SHARED_COMPUTER: dP,
  USER_AGREEMENT_ACCEPTED_GET: $O,
  USER_AGREEMENT_ACCEPTED_SET: MO,
  USER_AGREEMENT_GET: RO,
  USER_AGREEMENT_STOWE: bO,
  USER_HAS_AGREED: LO,
  USER_HAS_NOT_AGREED_YET: VO,
  USER_PRODUCT_LICENSES: Qy,
  USER_UPDATE_FIELD: iO,
  USER_UPDATE_FIELDS: cO,
  addExtendedOfflineToken: zH,
  addUser: rk,
  adminAddFeatureToProductAccess: AH,
  adminAddFeatureToProductAccessUser: fH,
  adminAddPhantomUserToProduct: bk,
  adminAddProductFeature: EH,
  adminAddProductToCostCenter: $k,
  adminAddUserToCostCenter: Mk,
  adminAddUserToProduct: Vk,
  adminAddWhitelistDomain: TH,
  adminBatchActions: pH,
  adminClearRedisCache: a0,
  adminCreateAgreement: Hk,
  adminCreateNewCostCenter: Pk,
  adminCreateProductVersion: n0,
  adminCreateUser: Rk,
  adminDeleteUserAuthorizedDevices: xk,
  adminExportCSVForHubspot: yH,
  adminExtendProductAccess: Lk,
  adminFindUsersByPrimaryEmails: iH,
  adminGenerateProductKeypair: WH,
  adminGetAllActiveCostCenterInvites: uH,
  adminGetCostCenterInvites: cH,
  adminGetExpiringLicenses: jk,
  adminGetFeaturesForProductAccess: CH,
  adminGetLicenseLastUsedForUsers: MH,
  adminGetProductAndVersionList: t0,
  adminGetProductFeatures: _H,
  adminGetSeatStateForProductAccess: DH,
  adminGetUser: sH,
  adminGetUserGPDRData: RH,
  adminGetUsersByIds: aH,
  adminGetUsersLastUsedNSeconds: $H,
  adminModifyProductAccessStart: qk,
  adminRemoveFeatureFromProductAccessUser: hH,
  adminRemoveWhitelistDomain: NH,
  adminSetAuthorizedDevicesOverride: mH,
  adminSetCoadmins: Gk,
  adminSetCountryCode: JH,
  adminSetEmailVerificationState: OH,
  adminSetMaxSharedComputers: wk,
  adminSetPassword: kk,
  adminSetPrimaryEmail: bH,
  adminSetProductAccessActivityState: dH,
  adminSetProductAccessType: lH,
  adminSetProductNumSessions: Fk,
  adminSetProductSeats: SH,
  adminSetUserAuthDevicesMax: qH,
  adminSetUserAuthDevicesRemovalsPerBillingYear: FH,
  adminSetUserDeleted: PH,
  adminSetUserKeyValue: LH,
  adminSetUserLicenseCustomFieldValues: wH,
  adminSetUserOptOutDate: vH,
  adminSetUserPhantom: VH,
  adminSetWhitelistIgnore: gH,
  adminUpdateCostCenterAndProductAccessOwner: IH,
  adminUpdateCostCenterName: UH,
  adminUpdateProductActive: s0,
  adminUpdateProductAssets: o0,
  adminUpdateProductWhitelistedCountries: r0,
  archiveExtendedOfflineTokenById: QH,
  authorizedDeviceDeactivate: yk,
  authorizedDeviceRemovalsRemaining: bx,
  authorizedDeviceRename: Ok,
  authorizedDevices: Mx,
  changePassword: Ik,
  clearProductSetUsersArchivedDateResult: pk,
  clearProductSetUsersEndDateResult: hk,
  clearSetUsersSuspendedResult: _k,
  convertPhantomUserToUser: dk,
  costCenterDetails: Wk,
  costCenters: Fx,
  createNewCostCenter: vk,
  createNewUser: uk,
  customFieldKeysCreate: vx,
  customFieldKeysUpdate: Px,
  customFieldValuesCreateOrUpdate: Rx,
  elasticsearchCostCenterMappings: kH,
  elasticsearchCostCenterSearch: xH,
  elasticsearchUserMappings: jH,
  elasticsearchUserSearch: GH,
  emailVerificationClear: Ix,
  emailVerificationExpired: Tx,
  emailVerificationFailed: Dx,
  emailVerificationFetching: Cx,
  emailVerificationTokenResend: fx,
  emailVerificationTokenSend: Ax,
  emailVerificationTokenVerify: hx,
  emailVerificationUnverified: px,
  emailVerificationVerified: gx,
  exportExtendedOfflineToken: KH,
  findUserByPrimaryEmail: jx,
  generatePasswordResetCode: Tk,
  generateUserAuthToken: Uk,
  getCostCenters: Yk,
  getCostCentersByUser: Qk,
  getCostCentersCount: zk,
  getCostCentersPaginateVerbose: Zk,
  getCostCentersVerbose: Kk,
  getExtendedOfflineTokenForUserAtDate: ZH,
  getIndividualLicensesVerbose: nH,
  getInstitutionalLicensesVerbose: oH,
  getUserByAuthToken: Nk,
  getUsersCount: eH,
  getUsersVerbose: tH,
  getUsersVerbosePaginate: rH,
  importAuthorizedDeviceFromFingerprint: e0,
  inviteUserProductAccessAccept: Ox,
  inviteUserProductCancelInvites: Nx,
  inviteUserProductGetCostCenter: yx,
  inviteUsersProductAccess: Ux,
  login: ok,
  logout: ak,
  productAddUsers: mk,
  productSetUsersArchivedDate: Ck,
  productSetUsersEndDate: Ak,
  productSetUsersSuspended: Sk,
  products: Gx,
  registerProductTrial: LP,
  registerSeqGeqTrial: lk,
  resetForgottenPassword: gk,
  sendNotification: nk,
  setSite: ik,
  setUser: ck,
  setUserKeyValue: YH,
  startCloudWatcher: sk,
  storeProductSetUsersArchivedDateResult: Dk,
  storeProductSetUsersEndDateResult: fk,
  storeSetUsersSuspendedResult: Ek,
  syncAdminCostCenterList: kx,
  syncUserAdmin: zx,
  syncUserAdminAuthorizedDevices: ek,
  syncUserAdminCostCenter: Kx,
  syncUserAdminInitialize: xx,
  syncUserAdminLastUsed: Qx,
  syncUserAdminUsers: Zx,
  updateUserTracking: Vx,
  userAdminAddSharedComputer: Xx,
  userAdminCurrentCostCenter: Hx,
  userAdminExportLicense: Wx,
  userAdminForceUpdate: tk,
  userAdminForceUpdateCostCenterList: Bx,
  userAdminGetActiveLicense: Yx,
  userAdminUpdateSharedComputer: Jx,
  userAgreementAcceptedGet: Jk,
  userAgreementAcceptedSet: Xk,
  userAgreementGet: Bk,
  userAgreementStowe: XH,
  userHasAgreed: BH,
  userHasNotAgreedYet: HH,
  userProductLicenses: $x,
  userUpdateField: Lx,
  userUpdateFields: qx,
  users: wx
}, Symbol.toStringTag, { value: "Module" })), bX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), i0 = "1.0", c0 = {
  flowJoDesktop: "flowjo-desktop",
  seqGeqDesktop: "seqgeq-desktop"
}, u0 = {
  userSummary: "userSummary",
  currentUser: "currentUser"
}, d0 = "default", l0 = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  PARTIAL_CONTENT: 206,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  GONE: 401,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504
}, m0 = {
  // FJ 10 legacy headers
  productName: "x-flowjo-product-name",
  productVersion: "x-flowjo-product-version",
  serialNumber: "x-flowjo-serial-number",
  dongleId: "x-flowjo-dongle-id",
  hwAddress: "x-flowjo-hw-address",
  // New headers for generic client
  clientName: "x-client-name",
  clientVersion: "x-client-version",
  clientPlatform: "x-client-platform",
  clientDistro: "x-client-distro",
  clientRelease: "x-client-release",
  // Request tracking
  requestId: "x-request-id"
}, S0 = 1e4, VX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CLIENT_HEADERS: m0,
  PRODUCTS: c0,
  REGIONAL_DEFAULT: d0,
  RESPONSES: l0,
  SCHEMA_VERSION: i0,
  SEARCH_RESULT_WINDOW: S0,
  USER_TYPES: u0
}, Symbol.toStringTag, { value: "Module" })), qP = "cost-center", FP = "invite", wP = "invite-public", GP = "userProductInviteToken", jP = "create-cost-center", xP = "custom-fields", kP = `/api/${qP}/${Z}`;
function nt() {
  return kP;
}
function E0(e) {
  return e + nt();
}
function HP() {
  return `${nt()}/${jP}`;
}
function _0(e) {
  return e + HP();
}
function BP() {
  return `${nt()}/${xP}`;
}
function A0(e) {
  return e + BP();
}
function XP() {
  return `${nt()}/${FP}`;
}
function f0(e) {
  return e + XP();
}
function JP() {
  return `${nt()}/${wP}`;
}
function h0(e) {
  return e + JP();
}
function C0() {
  return `${GP}`;
}
const LX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  COST_CENTER: qP,
  COST_CENTER_BASE_PATH: kP,
  CREATE_COST_CENTER: jP,
  CUSTOM_FIELDS: xP,
  INVITE: FP,
  INVITE_PUBLIC: wP,
  INVITE_PUBLIC_FRONT_END_PATH: GP,
  acceptInviteFrontEndPath: C0,
  costCenterBasePath: nt,
  costCenterBaseUrl: E0,
  createCostCenterPath: HP,
  createCostCenterUrl: _0,
  customFieldsPath: BP,
  customFieldsUrl: A0,
  invitePath: XP,
  invitePublicPath: JP,
  invitePublicUrl: h0,
  inviteUrl: f0
}, Symbol.toStringTag, { value: "Module" })), qX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVITY_STATES: se,
  ActivityStatesSchema: ru,
  AnnualChangesSchema: Qc,
  COST_CENTER_SCHEMA_VERSION: Vt,
  COST_CENTER_TYPES: x,
  CURRENT_SCHEMA_VERSION: ys,
  CUSTOM_FIELD_KEY_STATUSES: rc,
  CostCenter: ee,
  CostCenterAdminsSchema: kc,
  CostCenterObjectSchema: $u,
  CostCenterStamp: Lt,
  CostCenterTypesSchema: jc,
  CostCenterUsersSchema: xc,
  CostCenterValidators: cy,
  CustomFieldKeyOrderSchema: au,
  CustomFieldKeySchema: iu,
  CustomFieldValueRecordSchema: uu,
  CustomFieldValueSchema: cu,
  DOMAIN_MAX_LENGTH: yc,
  DOMAIN_MIN_LENGTH: Nc,
  EmailDomainValidation: Vc,
  EmailDomainValidationSchema: Lc,
  EndDateSchema: Zc,
  FWMEncryptedFingerprintSchema: hu,
  FWMEncryptedSharedComputerFingerprintIdentifierSchema: gu,
  FWMSharedComputerStamp: cc,
  FacsWorkflowSharedComputerSchema: Pu,
  FingerprintSchema: Du,
  FlowJoUserStamp: lc,
  HardwareAddressSchema: Cu,
  KNOWN_VERSIONS: en,
  LogLevelSchema: mu,
  LoggingUrlSchema: Su,
  MAX_COST_CENTER_PRODUCTS: $c,
  MAX_COST_CENTER_USERS: Rc,
  MAX_PRODUCT_ACCESS_ADMINS: Mc,
  MAX_WHITELIST_EMAIL_DOMAINS: Pc,
  MaxActiveUsersSchema: eu,
  MaxAnnualDeviceDeactivationsSchema: to,
  MaxBoundDevicesSchema: eo,
  MaxClientsSchema: Ou,
  MaxConnectionsSchema: vu,
  MaxSimultaenousSessionsSchema: ro,
  NAME_MAX_LENGTH: Uc,
  NAME_MIN_LENGTH: Ic,
  NameValidationSchema: xe,
  OfflineDurationDaysSchema: no,
  PRODUCT_ACCESS_TYPES: k,
  PRODUCT_NAMES: bc,
  PRODUCT_NAMES_LIST: Zn,
  ProductAccessAdminsSchema: Hc,
  ProductAccessCustomFieldKeysSchema: du,
  ProductAccessCustomFieldStatusSchema: su,
  ProductAccessCustomKeyValidator: nu,
  ProductAccessFeatureStamp: sc,
  ProductAccessFeatureTypeSchema: Xc,
  ProductAccessFeatureValueSchema: Jc,
  ProductAccessFeatureValueTypesList: Bc,
  ProductAccessSchema: Ao,
  ProductAccessSchemaValidator: _o,
  ProductAccessStamp: oc,
  ProductAccessTypesSchema: lu,
  ProductAccessUserArchivedDate: co,
  ProductAccessUserEndDate: so,
  ProductAccessUserLastUsedDate: io,
  ProductAccessUserStamp: je,
  ProductAccessUserStartDate: ao,
  ProductAccessUsersProductSchema: mo,
  ProductAccessUsersValidator: lo,
  ProductBaseValidator: So,
  ProductFeatureSchema: Wc,
  ProductFeaturesSchema: zc,
  ProductFeaturesSchemaValidator: Yc,
  ProductLicenseStamp: uc,
  ProductNameSchema: qc,
  ProductRegionSchema: Fc,
  ProductSchema: Eo,
  ProductUserSchema: uo,
  REGION_MAX_LENGTH: vc,
  REGION_MIN_LENGTH: Oc,
  RegionValidationSchema: Gc,
  SHARED_COMPUTER_IDENTIFIER_TYPES: Ge,
  SHARED_COMPUTER_STATUSES: ve,
  SchemaVersionSchema: Qn,
  SeqGeqUserStamp: dc,
  SharedComputerFWMIdentifierTypeSchema: fu,
  SharedComputerFingerprintIdentifierSchema: Tu,
  SharedComputerFingerprintIdentifierTypeSchema: Au,
  SharedComputerHWAIdentifierSchema: pu,
  SharedComputerHWAIdentifierTypeSchema: _u,
  SharedComputerIdentifiersSchema: Nu,
  SharedComputerIdentifiersSchemaValidator: Uu,
  SharedComputerSchema: yu,
  SharedComputerSchemaValidator: Iu,
  SharedComputerStamp: ic,
  SharedComputerStatusSchema: Eu,
  SharedComputersMaxSchema: tu,
  SharedComputersSchema: Ru,
  StartDateSchema: Kc,
  UserLicenseCustomFieldValuesSchema: oo,
  UserLicenseCustomValueValidator: ou,
  UsersLicenseStamp: ac,
  WORLD_WIDE: nc,
  WhilelistDomainsSchema: wc,
  costCenterSchemas: Ie,
  createCostCenter: qt,
  createCostCenterFromJson: pc,
  createIndividualCostCenter: Tc,
  createInstitutionalCostCenter: gc,
  createProductAccess: Sc,
  createProductAccessFeature: Ec,
  createProductUser: Dc,
  createSharedComputer: mc,
  currentCostCenterSchema: am,
  findFirstProduct: fc,
  findProduct: Ac,
  getIndividualCostCenterName: Kn,
  isUserMemberOfCostCenter: hc,
  isUserMemberOfUserProductAccess: Cc,
  isUserValid: Mu,
  iterateProducts: _c,
  productUserStamp: zn
}, Symbol.toStringTag, { value: "Module" })), WP = "DEFAULT_STATE", D0 = () => ({
  type: WP
}), FX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_STATE: WP,
  defaultStateAction: D0
}, Symbol.toStringTag, { value: "Module" })), p0 = {
  USER_ID: "cloud_username",
  // FlowJo Portal User ID
  FIRST_NAME: "firstname",
  LAST_NAME: "lastname",
  EMAIL: "email",
  // primaryEmail
  COUNTRY_CODE: "hs_country_region_code"
  // two letter country code
}, T0 = {
  COMPANY: "company",
  PHONE: "phone",
  // (optional)
  PRODUCT_NAME: "cloud_trial_product",
  // PRODUCT.NAMES
  TITLE: "jobtitle",
  // (optional)
  POSTAL_CODE: "zip",
  FLOWJO_TRIAL_START_DATE: "flowjo_trial_start_date",
  FLOWJO_TRIAL_EXPIRATION_DATE: "flowjo_trial_expiration",
  COST_CENTER_ID: "costcenterid",
  PRODUCT_ACCESS_ID: "productaccessid"
}, g0 = {
  BASE_URL: "portal_environment"
}, I0 = {
  HS_LEGAL_BASIS: "hs_legal_basis",
  // legal basis for processing contact's data (set automatically by hubspot for the time being)
  API_MARKETING_CONTACT: "api_marketing_contact"
  // whether the contact is a marketing contact (user must opt in, not set by default)
}, U0 = {
  LEGITIMATE_INTEREST_PROSPECT: "Legitimate interest – prospect/lead",
  // this mapping uses a non-standard hyphen in hubspot
  LEGITIMATE_INTEREST_CUSTOMER: "Legitimate interest – existing customer",
  // this mapping uses a non-standard hyphen in hubspot
  LEGITIMATE_INTEREST_OTHER: "Legitimate interest - other",
  PERFORMANCE_OF_CONTRACT: "Performance of a contract",
  FREELY_GIVEN: "Freely given consent from contact",
  NOT_APPLICABLE: "Not applicable"
}, N0 = {
  MARKETING_CONTACT: "Marketing Contact",
  NON_MARKETING_CONTACT: "Non-Marketing Contact"
};
function y0(e) {
  const t = new Date(e);
  return t.setUTCHours(0, 0, 0, 0), t.toISOString();
}
const wX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  APPLICATION_MAPPINGS: g0,
  HS_API_MARKETING_CONTACT_VALUES: N0,
  HS_LEGAL_BASIS_VALUES: U0,
  HUBSPOT_MAPPINGS: I0,
  LICENSE_MAPPINGS: T0,
  USER_MAPPINGS: p0,
  convertDateToMidnightUTC: y0
}, Symbol.toStringTag, { value: "Module" }));
function O0(e, t, r = "utf8", n = "base64", o = "aes-256-cbc") {
  const a = Km(16), i = Km(32), c = uS(e, i, 32), m = PM(o, c, a);
  let d = m.update(t, r, n);
  return d += m.final(n), {
    salt: i.toString(n),
    iv: a.toString(n),
    encrypted: d,
    algorithm: o,
    inputEncoding: r,
    outputEncoding: n
  };
}
function v0(e, t, r, n, o = "utf8", a = "base64", i = "aes-256-cbc") {
  const c = uS(e, Buffer.from(n, a), 32), m = vM(i, c, Buffer.from(r, a));
  let d = m.update(t, a, o);
  return d += m.final(o), d;
}
const GX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decryptDataWithSecret: v0,
  encryptDataWithSecret: O0
}, Symbol.toStringTag, { value: "Module" })), YP = "userAgreementAccepted", zP = "userAgreement", KP = "authorizedDevices", ZP = "extendedOfflineTokens", QP = "license", P0 = (e) => Number.isInteger(e) ? `v${e}` : Z, Q = (e) => `/api/license/${P0(e)}`;
function eR(e) {
  return Q(e);
}
function R0(e, t) {
  return e + eR(t);
}
function tR(e) {
  return `${Q(e)}/heartbeat`;
}
function $0(e, t) {
  return e + tR(t);
}
function rR(e) {
  return `${Q(e)}/${QP}`;
}
function M0(e) {
  return e + rR();
}
function nR() {
  return `${Q()}/acceptEula`;
}
function b0(e) {
  return e + nR();
}
function oR() {
  return `${Q()}/checkEula`;
}
function V0(e) {
  return e + oR();
}
function sR() {
  return `${Q()}/${zP}`;
}
function L0(e) {
  return e + sR();
}
function aR() {
  return `${Q()}/${YP}`;
}
function q0(e) {
  return e + aR();
}
function iR() {
  return `${Q()}/files/user-agreements`;
}
function F0(e) {
  return e + iR();
}
function cR(e) {
  return `${Q(e)}/${KP}`;
}
function w0(e, t) {
  return e + cR(t);
}
function uR(e) {
  return `${Q(e)}/${ZP}`;
}
function G0(e, t) {
  return e + uR(t);
}
const jX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AUTHORIZED_DEVICES: KP,
  EXTENDED_OFFLINE_TOKENS: ZP,
  LICENSE: QP,
  USER_AGREEMENT: zP,
  USER_AGREEMENT_ACCEPTED: YP,
  authorizedDevicesPath: cR,
  authorizedDevicesUrl: w0,
  extendedOfflineTokensPath: uR,
  extendedOfflineTokensUrl: G0,
  getEulaPath: oR,
  getEulaUrl: V0,
  heartbeatPath: tR,
  heartbeatUrl: $0,
  licenseBasePath: eR,
  licenseBaseUrl: R0,
  licensePath: rR,
  licenseUrl: M0,
  setEulaPath: nR,
  setEulaUrl: b0,
  userAgreementAcceptedPath: aR,
  userAgreementAcceptedUrl: q0,
  userAgreementPath: sR,
  userAgreementUrl: L0,
  userAgreementsFilePath: iR,
  userAgreementsFileUrl: F0
}, Symbol.toStringTag, { value: "Module" })), j0 = {
  added: "added",
  existing: "existing",
  whitelistMismatch: "whitelistMismatch",
  noRemainingSeatsAvailable: "noRemainingSeatsAvailable",
  userAddFailed: "userAddFailed",
  noUserAccountForUserEmail: "noUserAccountForUserEmail",
  invalidEmailString: "invalidEmailString",
  error: "error"
}, x0 = {
  removed: "removed",
  nonExisting: "nonExisting",
  error: "error"
};
function k0(e, t, r) {
  if (!e.match(Pe) || !t.match(Pe) || !r.match(Pe))
    throw new Error("Invalid arguments.  Must supply userId, costCenterId, productAccessId");
  const n = (o) => cS.createHash("md5").update(o).digest("hex");
  return n(n(e) + n(t) + n(r));
}
function H0(e, t) {
  if (!e || !(e.length > 0) || !t)
    return;
  const r = [], n = [];
  if (e && e.length > 0)
    for (const i in e) {
      const c = e[i].billingUnit.id, m = e[i].billingUnit.type, d = ln(e[i].productAccess);
      d.costCenterId = c, d.costCenterType = m, r.push(d), n.push(e[i].billingUnit);
    }
  const a = _R(r, t, !0);
  if (a)
    return { billingUnit: AR(n, a.costCenterId), productAccess: a };
}
function B0(e, t, r, n = Mn.release) {
  const o = [];
  if (!r)
    return o;
  for (const a of Object.keys(r)) {
    const i = r[a];
    for (const c of i.productAccess)
      if (t === c.name && c.users[e] && n === c.type) {
        const m = ln(c);
        m.costCenterId = i.id, m.costCenterType = i.type, o.push({ billingUnit: i, productAccess: c });
      }
  }
  return o;
}
function X0(e, t) {
  const { whitelistDomains: r, whitelistIgnore: n } = t;
  if (n) return !0;
  const o = e.split("@")[1];
  if (o) {
    for (const a of r)
      if (o.toLowerCase().includes(a.toLowerCase().split("@")[1])) return !0;
  }
  return !1;
}
function dR(e) {
  const t = new Date(9999, 12, 1);
  return e.sort((r, n) => {
    const o = new Date(r.endDate || t);
    return new Date(n.endDate || t).valueOf() - o.valueOf();
  });
}
function J0(e, t, r, n = !0) {
  if (!e || !t || !r)
    return;
  const o = Object.values(r).filter(
    (c) => n && c.type === x.individual
  ).map((c) => c.productAccess).reduce((c, m) => c.concat(m), []).filter(
    (c) => c.name === e && c.owner === t && c.type === k.trial && (c.activityState === se.active || c.activityState === se.pending)
  ), i = dR(o)[0];
  return i ? { endDate: i.endDate, lastTrial: i } : void 0;
}
function W0(e, t) {
  for (const r in e) {
    const n = e[r], { productAccess: o } = n;
    for (const a of o)
      if (a.name === t && qy(a))
        return { costCenterId: r, costCenter: n, productId: a.id, product: a };
  }
  return {};
}
function fa(e, t, r, n, o, a, i) {
  const c = new Date(Date.UTC(e, t, r, n, o, a, i));
  return c.getUTCMonth() !== t ? new Date(Date.UTC(e, t + 1, 0, n, o, a, i)) : c;
}
function Em(e, t = /* @__PURE__ */ new Date()) {
  if (!e)
    return;
  const r = new Date(e), n = new Date(t);
  if (!(n instanceof Date)) return;
  const o = r.getUTCMonth(), a = r.getUTCDate(), i = r.getUTCHours(), c = r.getUTCMinutes(), m = r.getUTCSeconds(), d = r.getUTCMilliseconds();
  let p = n.getUTCFullYear(), N = fa(
    p,
    o,
    a,
    i,
    c,
    m,
    d
  );
  return N.valueOf() - n.valueOf() > 0 && (p--, N = fa(
    p,
    o,
    a,
    i,
    c,
    m,
    d
  )), e instanceof Date ? N : N.toISOString();
}
function Y0(e, t, r = void 0) {
  const n = r ? new Date(r) : /* @__PURE__ */ new Date();
  let o = 0;
  return e.forEach((a) => {
    const i = new Date(
      Em(t, n)
    );
    new Date(a) > i && (o += 1);
  }), o;
}
function z0(e, t = /* @__PURE__ */ new Date()) {
  const r = Em(e, t);
  if (!r)
    return;
  const n = new Date(e), o = n.getUTCMonth(), a = n.getUTCDate(), i = n.getUTCHours(), c = n.getUTCMinutes(), m = n.getUTCSeconds(), d = n.getUTCMilliseconds(), p = new Date(r).getUTCFullYear() + 1, N = fa(
    p,
    o,
    a,
    i,
    c,
    m,
    d
  );
  return e instanceof Date ? N : N.toISOString();
}
const ha = (e) => e.sort((t, r) => {
  let n = t.active ? 1 : 0, o = r.active ? 1 : 0;
  if (n !== o)
    return o - n;
  const a = {
    [k.release]: 4,
    [k.trial]: 3,
    [k.training]: 2,
    [k.beta]: 1
  };
  if (a[t.type] > a[r.type] ? n++ : a[t.type] < a[r.type] && o++, n === o) {
    const i = new Date(t.sortStartDate), c = new Date(r.sortStartDate), m = /* @__PURE__ */ new Date();
    i < m && o++, c < m && n++, i < c ? o++ : i > c && n++;
    const d = new Date(t.sortEndDate), p = new Date(r.sortEndDate);
    t.sortEndDate && !r.sortEndDate ? o++ : !t.sortEndDate && r.sortEndDate || d > p ? n++ : d < p && o++;
  }
  return n === o && (t.costCenterType === x.institutional && r.costCenterType !== x.institutional && n++, r.costCenterType === x.institutional && t.costCenterType !== x.institutional && o++), o > n ? 1 : o < n ? -1 : 0;
}), lR = (e, t, r, n, o, a) => {
  const i = /* @__PURE__ */ new Date(), c = new Date(r), m = new Date(n), d = new Date(o), p = new Date(a), N = e !== se.active && e !== se.pending, M = t === !0, q = r && c < i, G = n && m < i, b = o && d > i, j = a && p > i;
  return !(N || M || q || G || b || j);
}, K0 = (e, t) => !e && !t ? null : e && !t ? e : t && !e ? t : e && new Date(t) > new Date(e) ? e : t, Z0 = (e, t) => !e && !t ? null : e && !t ? e : t && !e || e && new Date(t) > new Date(e) ? t : e, mR = (e, t) => {
  if (!e || !t)
    return;
  const { id: r, costCenterId: n, costCenterType: o, type: a, name: i, activityState: c, endDate: m, startDate: d, users: p, authorizedDevicesOverride: N } = e, M = i, q = m, G = d, b = p[t];
  if (b && b) {
    const j = b.startDate, Oe = b.endDate, NM = b.suspended;
    return {
      id: r,
      // string
      costCenterId: n,
      // string
      costCenterType: o,
      // string
      type: a,
      // string
      productName: M,
      // string
      activityState: c,
      // string
      active: lR(
        c,
        NM,
        q,
        Oe,
        G,
        j
      ),
      // boolean
      sortEndDate: K0(q, Oe),
      // timestamp
      sortStartDate: Z0(G, j),
      // timestamp
      authorizedDevicesOverride: N
      // boolean
    };
  }
}, Q0 = (e, t) => {
  const r = [], n = [], o = {
    activeLicensesInfo: [],
    inactiveLicensesInfo: []
  };
  return e && (e.forEach((a) => {
    const i = mR(a, t);
    i && i.active ? r.push(i) : i && n.push(i);
  }), r && r.length > 0 && (o.activeLicensesInfo = ha(r)), n && n.length > 0 && (o.inactiveLicensesInfo = ha(n))), o;
}, tS = (e, t) => {
  if (!(!t || !e)) {
    for (const r in e)
      if (t === e[r].id)
        return e[r];
  }
};
function SR(e, t = void 0) {
  return e.filter((r) => r.type === k.beta || t && t.includes(r.id));
}
function ER(e, t = void 0) {
  return e.filter((r) => (!t || !t.includes(r.id)) && r.type !== k.beta);
}
const _R = (e, t, r = !1, n = !1, o = void 0) => {
  if (!e || !t)
    return;
  let a = [];
  n ? a = SR(e, o) : a = ER(e, o);
  const i = Q0(a, t), { activeLicensesInfo: c, inactiveLicensesInfo: m } = i;
  if (c && c.length) {
    const d = c[0].id;
    return tS(e, d);
  } else if (!r && m && m.length) {
    const d = m[0].id;
    return tS(e, d);
  }
}, e2 = (e, t) => {
  const r = [];
  for (const n of Object.keys(t)) {
    const o = t[n];
    for (const a of o.productAccess)
      if (e.toLowerCase() === a.name.toLowerCase()) {
        const i = ln(a);
        i.costCenterId = o.id, i.costCenterType = o.type, r.push(i);
      }
  }
  return r;
};
function t2(e, t, r) {
  if (!r || !e || !t)
    return;
  const n = [];
  for (const o of Object.keys(r)) {
    const a = r[o];
    for (const i of a.productAccess)
      if (t === i.name && i.users[e]) {
        const c = ln(i);
        c.costCenterId = a.id, c.costCenterType = a.type, n.push(c);
      }
  }
  return n;
}
const AR = (e, t) => {
  for (const r of e)
    if (r.id === t)
      return r;
};
function r2(e, t) {
  let r = {};
  return Object.keys(e).forEach((n) => {
    const o = e[n];
    Object.keys(o).forEach((a) => {
      const i = o[a].authorizedDeviceJson;
      i.productAccessId === t && i.lastUsed && (!r[n] || new Date(r[n]) < new Date(i.lastUsed)) && (r = {
        ...r,
        [n]: i.lastUsed
      });
    });
  }), r;
}
function n2(e) {
  return e.split(".")[0] === "11" && e.includes("-");
}
const o2 = (e) => {
  const { activityState: t, startDate: r, endDate: n } = e, o = (/* @__PURE__ */ new Date()).toISOString(), a = new Date(r).toISOString(), i = new Date(n).toISOString();
  return !(t !== se.active || r && a > o || n && i < o);
};
function Ca(e, t) {
  return t && TS[t] ? !0 : !e || !e.whitelistedCountries || !Array.isArray(e.whitelistedCountries) || e.whitelistedCountries.length === 0 ? !1 : !t || !e.whitelistedCountries.includes(t);
}
function s2(e, t, r) {
  return e ? !!(t && Ca(e, t) || r && Ca(e, r)) : !1;
}
const xX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ADD_USER_STATES: j0,
  REMOVE_USER_STATES: x0,
  analyzeLicense: mR,
  calculateBillingYTDDeactivations: Y0,
  checkWhitelist: X0,
  chooseLicense: _R,
  findFirstProduct: W0,
  getActiveLicenseForUser: H0,
  getAuthorizedBypassLicenseUsageDeviceIdHash: k0,
  getAuthorizedDeviceRemovalResetDate: z0,
  getCostCenterFromId: AR,
  getCurrentBillingYearStartDate: Em,
  getLastUsedDateForUserSeats: r2,
  getLicensesForProduct: e2,
  getUserLicensesForProduct: B0,
  getUserProductAccessesForProduct: t2,
  isBlockedCountry: Ca,
  isFlowJo11PreRelease: n2,
  isLicenseActive: lR,
  isProductAccessActive: o2,
  productTrialAndExpirationDate: J0,
  selectPreReleaseLicenses: SR,
  selectStandardLicenses: ER,
  shouldBlockAssetAccess: s2,
  sortLicensesInfo: ha,
  sortProductsByEndDate: dR
}, Symbol.toStringTag, { value: "Module" })), rS = "0.0.0";
function fR(e, t) {
  return MM(t?.productVersion || rS, e?.productVersion || rS);
}
function hR(e) {
  return [...e].sort(fR);
}
function a2(e) {
  return hR(e)[0] ?? null;
}
const kX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareProductVersionsDescending: fR,
  getLatestProductVersion: a2,
  sortProductVersionsDescending: hR
}, Symbol.toStringTag, { value: "Module" }));
function y(e) {
  Error.captureStackTrace(this, this.constructor), this.name = "NotificationError", this.message = e || "";
}
y.prototype = Object.create(Error.prototype);
function CR(e, t) {
  y.call(this), this.userId = e, this.name = "NotificationRecipientNotFound", t ? t = ` ${t}` : t = "", this.message = `User ${e} could not be found to send a message to.${t}`;
}
CR.prototype = Object.create(y.prototype);
function DR(e, t) {
  y.call(this), this.userId = e, this.name = "UserNotificationsNotFoundError", t ? t = ` ${t}` : t = "", this.message = `UserNotifications ${e} could not be found.${t}`;
}
DR.prototype = Object.create(y.prototype);
function Gs(e, t) {
  y.call(this), this.id = e, this.name = "NotificationNotFound", t ? t = ` ${t}` : t = "", this.message = `Notification id ${e} not found.${t}`;
}
Gs.prototype = Object.create(y.prototype);
function js(e, t, r) {
  y.call(this), this.userId = t, this.expectedUserId = e, this.name = "NotificationUserIdMismatch", r ? r = ` ${r}` : r = "", this.message = `Got notification for user ${t}, expected user ${t}.${r}`;
}
js.prototype = Object.create(y.prototype);
function _m(e, t) {
  y.call(this), this.userId = e, this.name = "DuplicateNotificationId", t ? t = ` ${t}` : t = "", this.message = `Notification id ${e} already exists.${t}`;
}
_m.prototype = Object.create(y.prototype);
function pR(e, t, r, n) {
  y.call(this), this.userId = e, this.oldVersion = t, this.newVersion = r, this.name = "UserNotificationsOutOfDate", n ? n = ` ${n}` : n = "", this.message = `UserNotification version for ${e} is out of date.  Expected version ${t}, latest version ${r}.${n}`;
}
pR.prototype = Object.create(y.prototype);
function TR(e, t, r, n) {
  y.call(this), this.userId = e, this.versionExpected = t, this.versionGiven = r, this.name = "UserNotificationsVersionMismatch", n ? n = ` ${n}` : n = "", this.message = `Incorrect UserNotification version found for ${e}.  Expected version ${t}, was given version ${r}.${n}`;
}
TR.prototype = Object.create(y.prototype);
function gR(e, t) {
  y.call(this), this.userId = e, this.name = "NotificationFailedValidation", t ? t = ` ${t}` : t = "", this.message = `Notification ${e} failed validation.${t}`;
}
gR.prototype = Object.create(y.prototype);
function nn(e, t) {
  y.call(this), this.userId = e, this.name = "InvalidNotificationId", t ? t = ` ${t}` : t = "", this.message = `Notification id ${e} is invalid.${t}`;
}
nn.prototype = Object.create(y.prototype);
function IR(e, t, r) {
  y.call(this), this.userId = e, this.notificationObjectId = t, this.name = "InvalidNotificationObjectId", r ? r = ` ${r}` : r = "", this.message = `Notification object id ${t} for taskspace ${e} is invalid.${r}`;
}
IR.prototype = Object.create(y.prototype);
const HX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DuplicateNotificationId: _m,
  InvalidNotificationId: nn,
  InvalidNotificationObjectId: IR,
  NotificationError: y,
  NotificationFailedValidation: gR,
  NotificationNotFound: Gs,
  NotificationRecipientNotFound: CR,
  NotificationUserIdMismatch: js,
  UserNotificationsNotFoundError: DR,
  UserNotificationsOutOfDate: pR,
  UserNotificationsVersionMismatch: TR
}, Symbol.toStringTag, { value: "Module" })), i2 = 1, Am = l({
  refs: {
    userId: null,
    version: 1,
    schemaVersion: i2,
    notifications: {}
  },
  init: ({ instance: e }) => {
    e.version || (e.version = 1), e.notifications || (e.notifications = {});
  },
  methods: {
    addNotification(e, t = !0, r = !1) {
      const n = e.id;
      if (!r && this.notifications[n])
        throw new _m(n, "Duplicate notification id");
      if (this.userId !== e.userId)
        throw new js(this.userId, e.userId);
      const o = this.clone();
      return o.notifications[e.id] = e, t && (o.version += 1), o;
    },
    markNotificationRead(e, t = !0) {
      const r = this.clone(), n = r.notifications[e];
      if (!n)
        throw new Gs(e);
      return r.notifications[e] = n.markRead(), t && (r.version += 1), r;
    },
    deleteNotification(e, t = !0) {
      const r = this.clone();
      return r.notifications[e] ? (delete r.notifications[e], t && (r.version += 1), r) : this;
    },
    /**
     * Returns a semi-shallow clone of this object
     * <p>
     * Taskspace#objects will be cloned as well, however it will contain the same references
     * to objects as the original.
     * @returns {JOSN} - a clone of this taskspace
     */
    clone() {
      const e = { ...this };
      return e.notifications = { ...this.notifications }, Am(e);
    }
  }
}), UR = l({
  refs: {
    id: null,
    userId: null,
    type: null,
    siteId: null,
    eventDate: null,
    version: 1,
    priority: 1,
    read: !1,
    object: {},
    subject: {},
    message: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = F()), e.version || (e.version = 1), e.object || (e.object = {}), e.eventDate || (e.eventDate = ce()), e.priority || (e.priority = 1), e.read || (e.read = !1);
  },
  methods: {
    markRead() {
      const e = this.clone();
      return e.read = !0, e.version += 1, e;
    },
    clone() {
      const e = { ...this };
      return UR(e);
    }
  }
});
function NR(e) {
  if (!e)
    throw new y("Expected Notification, got null");
  const { userId: t } = e;
  if (!t)
    throw new nn(null);
  if (!t.match(Pe))
    throw new nn(t);
}
const BX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NotificationStamp: UR,
  UserNotificationsStamp: Am,
  validateNotification: NR
}, Symbol.toStringTag, { value: "Module" })), fm = "SEND_NOTIFICATION", hm = "MARK_NOTIFICATION_READ", Cm = "DELETE_NOTIFICATION";
function c2(e, t = null) {
  return t || (t = S()), {
    type: fm,
    notification: e,
    requestId: t
  };
}
function u2(e, t, r = null) {
  return r || (r = S()), {
    type: hm,
    userId: e,
    notificationId: t,
    requestId: r
  };
}
function d2(e, t, r = null) {
  return r || (r = S()), {
    type: Cm,
    userId: e,
    notificationId: t,
    requestId: r
  };
}
const XX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DELETE_NOTIFICATION: Cm,
  MARK_NOTIFICATION_READ: hm,
  SEND_NOTIFICATION: fm,
  deleteNotification: d2,
  markNotificationRead: u2,
  sendNotification: c2
}, Symbol.toStringTag, { value: "Module" }));
function Dm(e) {
  return Am({ userId: e });
}
function yR(e, t) {
  const { notification: r } = t;
  NR(r);
  const { userId: n } = r;
  let o;
  return e ? o = !0 : (e = Dm(n), o = !1), e = e.addNotification(r, o), e;
}
function OR(e, t) {
  const { notificationId: r, userId: n } = t;
  if (!e)
    throw new Gs(r);
  if (n !== e.userId)
    throw new js(e.userId, n);
  return e = e.markNotificationRead(r), e;
}
function vR(e, t) {
  const { notificationId: r, userId: n } = t;
  let o;
  if (e ? o = !0 : (e = Dm(n), o = !1), n !== e.userId)
    throw new Error(
      `Cannot delete notification ${r} for user ${n} with action for user ${t.userId}`
    );
  return e = e.deleteNotification(r, o), e;
}
function l2(e, t) {
  switch (t.type) {
    case fm:
      return yR(e, t);
    case hm:
      return OR(e, t);
    case Cm:
      return vR(e, t);
    default:
      return e;
  }
}
const JX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  handleDeleteNotification: vR,
  handleMarkNotificationRead: OR,
  handleSendNotification: yR,
  initNotificationsStore: Dm,
  userNotifications: l2
}, Symbol.toStringTag, { value: "Module" })), PR = `/api/notification/${Z}`;
function RR() {
  return PR;
}
function m2(e) {
  return e + RR();
}
function $R() {
  return `${PR}/send`;
}
function S2(e) {
  return e + $R();
}
const WX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  notificationBasePath: RR,
  notificationBaseUrl: m2,
  sendPath: $R,
  sendUrl: S2
}, Symbol.toStringTag, { value: "Module" })), pm = "product", MR = "latest", bR = "trial", VR = `/api/${pm}/${Z}`;
function ar() {
  return VR;
}
function E2(e) {
  return e + ar();
}
function LR() {
  return `${ar()}/${MR}`;
}
function _2(e) {
  return e + LR();
}
function qR() {
  return `${ar()}/${bR}`;
}
function A2(e) {
  return e + qR();
}
function FR() {
  return `${ar()}/${pm}`;
}
function f2(e) {
  return e + FR();
}
const YX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LATEST: MR,
  PRODUCT: pm,
  PRODUCT_BASE_PATH: VR,
  TRIAL: bR,
  latestProductPath: LR,
  latestProductUrl: _2,
  productBasePath: ar,
  productBaseUrl: E2,
  productPath: FR,
  productUrl: f2,
  trialPath: qR,
  trialUrl: A2
}, Symbol.toStringTag, { value: "Module" }));
function h2(e, t, r) {
  const { AuthorizedDeviceValidators: n } = or[t], o = n.AuthorizedDeviceObjectSchema.validate(r).error;
  if (o)
    throw new Error(
      `Cannot migrate authorizedDevice ${r.id} from schema version ${e} to schema ${t} due to validation error: ${o}`
    );
  return r;
}
function C2(e, t, r) {
  if (e !== t)
    throw new Error(
      `Cannot upgrade cost center schema from unknown schema version ${e} to ${r}`
    );
}
function wR(e) {
  if (!e)
    return e;
  C2(
    `${e.schemaVersion || "1"}`,
    "1",
    "2"
  );
  const n = {
    id: e.id,
    userId: e.userId,
    productAccessId: e.productAccessId,
    name: e.name,
    identifiers: e.identifiers || {},
    createdAt: e.createdAt,
    updatedAt: e.updatedAt,
    lastUsed: e.lastUsed,
    deactivatedAt: e.deactivatedAt,
    schemaVersion: "2"
  };
  return h2("1", "2", n);
}
function D2(e) {
  if (!e || e.schemaVersion === nr)
    return e;
  const t = `${e.schemaVersion || 1}`;
  switch (t) {
    case "1":
      e = wR(e);
    case "2":
      break;
    default:
      throw new Error(
        `Cannot upgrade AuthorizedDevice object schema from unknown schema version ${t}`
      );
  }
  return e;
}
const p2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  migrateSchema: D2,
  migrateSchema1to2: wR
}, Symbol.toStringTag, { value: "Module" })), { AuthorizedDevice: T2, AuthorizedDeviceValidators: g2 } = sr, zX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AuthorizedDevice: T2,
  AuthorizedDeviceConstants: cx,
  AuthorizedDeviceMigrate: p2,
  AuthorizedDeviceValidators: g2
}, Symbol.toStringTag, { value: "Module" })), gr = "2017-03-08T17:34:50.581Z", I2 = "us", GR = "worldwide", { newUUID: U2 } = U;
function V(e, t, r) {
  const { CostCenterValidators: n } = Ie[t], o = n.CostCenterObjectSchema.validate(r).error;
  if (o)
    throw new Error(
      `Cannot migrate CostCenter ${r.id} from schema version ${e} to schema ${t} due to validation error: ${o}`
    );
  return r;
}
function L(e, t, r) {
  if (e !== t)
    throw new Error(
      `Cannot upgrade cost center schema from unknown schema version ${e} to ${r}`
    );
}
function jR(e, t) {
  const { CostCenter: n } = Ie[2], o = {
    id: e.id || U2(),
    owner: e.owner || t,
    admins: e.admins || [],
    type: e.type || n.PRODUCT_ACCESS_TYPES.release,
    createdAt: e.createdAt || gr,
    updatedAt: e.updatedAt || null,
    startDate: e.startDate || gr,
    endDate: e.endDate || gr,
    version: e.version,
    activityState: e.activityState || n.ACTIVITY_STATES.active,
    diskSpaceGb: e.diskSpaceGb,
    monthlyDlGb: e.monthlyDlGb
  }, a = e.name || e.product;
  if (a.match(/seqgeq/i))
    o.name = O.seqGeq, o.region = GR, o.users = e.users || {}, o.logLevel = e.newProductAccess || 0, o.loggingUrl = e.loggingUrl || null;
  else
    throw new Error(`Unable to migrate productName ${a}`);
  return o;
}
function xR(e) {
  let t;
  if (e.name === O.envoy)
    t = (e.region || "US").toUpperCase();
  else if (e.name === O.seqGeq)
    t = Ut;
  else
    return e;
  return { ...e, region: t };
}
function kR(e) {
  const { CostCenter: r } = Ie[4];
  if (e.name === O.seqGeq) {
    let n = {};
    for (const a in e.users) {
      const i = e.users[a];
      let c = ce();
      const { endDate: m } = i;
      m && (/* @__PURE__ */ new Date()).valueOf(c) > new Date(m).valueOf() && (c = m);
      const d = r.createSeqGeqUser(a, !1, c, m);
      n = { ...n, [a]: d };
    }
    let o = { ...e };
    return o = { ...o, users: n }, o;
  }
  if (e.name === O.envoy) {
    const n = e.monthlyDlGb * 12;
    let o = { ...e };
    return o = { ...o, yearlyDlGb: n }, delete o.monthlyDlGb, o;
  }
  return e;
}
function HR(e) {
  return (e.name === O.seqGeq || e.name === O.flowJo) && Object.keys(e.users).forEach((t) => {
    const r = e.users[t];
    r.maxAnnualDeviceDeactivations = 4;
  }), e;
}
function BR(e) {
  if (e.name === O.seqGeq || e.name === O.flowJo) {
    let t = {};
    for (const r in e.users) {
      let n = e.users[r];
      n = {
        ...n,
        customFieldValues: {}
      }, t = {
        ...t,
        [r]: n
      };
    }
    return {
      ...e,
      users: t,
      customFieldKeys: {}
    };
  }
  return e;
}
function XR(e) {
  return e.name === O.seqGeq || e.name === O.flowJo ? {
    ...e,
    maxSharedComputers: 0,
    sharedComputers: {}
  } : e;
}
function JR(e) {
  return e.name !== O.envoy ? { ...e, authorizedDevicesOverride: !1 } : e;
}
const WR = (e) => e.name === "Envoy" ? null : SS(e, ["groups"]);
function YR(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion || "1"}`, "1", "2");
  const { CostCenter: n } = Ie[2], { owner: o } = e;
  let a = e.productAccess || [];
  a = a.map((c) => jR(c, o));
  const i = {
    id: e.id,
    name: e.name,
    owner: o,
    users: e.users || [],
    groups: e.groups || [],
    version: e.version,
    productAccess: a,
    whitelistDomains: e.whitelistDomains || [],
    schemaVersion: "2",
    createdAt: e.createdAt || gr,
    updatedAt: e.updatedAt || null,
    type: e.type || n.COST_CENTER_TYPES.institutional
  };
  return i.groups.length > 0 && Object.assign(i, {
    groups: Array.from(new Set(i.groups))
  }), V("1", "2", i);
}
function zR(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "2", "3");
  let n = e.productAccess || [];
  n = n.map((i) => xR(i));
  const o = Array.from(new Set(e.users)), a = {
    ...e,
    schemaVersion: "3",
    countryCode: "US",
    productAccess: n,
    users: o
  };
  return a.groups.length > 0 && Object.assign(a, {
    groups: Array.from(new Set(a.groups))
  }), V("2", "3", a);
}
function KR(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "3", "4");
  let n = e.productAccess || [];
  n = n.map((a) => kR(a));
  const o = { ...e, schemaVersion: "4", productAccess: n };
  return o.groups.length > 0 && Object.assign(o, {
    groups: Array.from(new Set(o.groups))
  }), V("3", "4", o);
}
function ZR(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "4", "5");
  let n = e.productAccess || [];
  n = n.map((a) => HR(a));
  const o = { ...e, schemaVersion: "5", productAccess: n };
  return V("4", "5", o);
}
function QR(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "5", "6");
  let n = e.productAccess || [];
  n = n.map((a) => BR(a));
  const o = { ...e, schemaVersion: "6", productAccess: n };
  return V("5", "6", o);
}
function e$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "6", "7");
  let n = e.productAccess || [];
  n = n.map((a) => XR(a));
  const o = { ...e, schemaVersion: "7", productAccess: n };
  return V("6", "7", o);
}
function t$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "7", "8");
  const n = {
    ...e,
    schemaVersion: "8",
    whitelistIgnore: !1
  };
  return V("7", "8", n);
}
function r$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "8", "9");
  const n = {
    ...e,
    schemaVersion: "9",
    admins: []
  };
  return V("8", "9", n);
}
function n$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "9", "10");
  const n = e.productAccess.map(
    (a) => JR(a)
  ), o = {
    ...e,
    schemaVersion: "10",
    productAccess: n
  };
  return V("9", "10", o);
}
function o$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "10", "11");
  const n = e.productAccess.map((i) => WR(i)).filter((i) => i !== null), a = {
    ...SS(e, ["groups"]),
    schemaVersion: "11",
    productAccess: n
  };
  return V("10", "11", a);
}
function s$(e) {
  return {
    ...e,
    features: {}
  };
}
function a$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "11", "12");
  const n = e.productAccess.map(
    (a) => s$(a)
  ), o = {
    ...e,
    schemaVersion: "12",
    productAccess: n
  };
  return V("11", "12", o);
}
function i$(e) {
  function t(n) {
    const o = {
      ...n,
      identifiers: [
        { type: n.identifier.type, value: n.identifier.value }
      ]
    };
    return delete o.identifier, o;
  }
  const { sharedComputers: r } = e;
  return Object.keys(r).forEach((n) => {
    r[n] = t(e.sharedComputers[n]);
  }), e;
}
function c$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "12", "13");
  const n = e.productAccess.map(
    (a) => i$(a)
  ), o = {
    ...e,
    schemaVersion: "13",
    productAccess: n
  };
  return V("12", "13", o);
}
function u$(e) {
  const { users: t } = e;
  return t && Object.keys(t).forEach((r) => {
    t[r] = {
      ...t[r],
      archivedDate: null
      // null means not archived
    };
  }), e;
}
function d$(e) {
  if (!e)
    return e;
  L(`${e.schemaVersion}`, "13", "14");
  const n = e.productAccess.map(
    (a) => u$(a)
  ), o = {
    ...e,
    schemaVersion: "14",
    productAccess: n
  };
  return V("13", "14", o);
}
function N2(e) {
  if (!e || e.schemaVersion === ys)
    return e;
  const t = `${e.schemaVersion || 1}`;
  switch (t) {
    case "1":
      e = YR(e);
    case "2":
      e = zR(e);
    case "3":
      e = KR(e);
    case "4":
      e = ZR(e);
    case "5":
      e = QR(e);
    case "6":
      e = e$(e);
    case "7":
      e = t$(e);
    case "8":
      e = r$(e);
    case "9":
      e = n$(e);
    case "10":
      e = o$(e);
    case "11":
      e = a$(e);
    case "12":
      e = c$(e);
    case "13":
      e = d$(e);
    case "14":
      break;
    default:
      throw new Error(
        `Cannot upgrade CostCenter object schema from unknown schema version ${t}`
      );
  }
  return e;
}
const KX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_ENVOY_REGION: I2,
  DEFAULT_SEQGEQ_REGION: GR,
  migrateProductAccessSchema11to12: s$,
  migrateProductAccessSchema12to13: i$,
  migrateProductAccessSchema13to14: u$,
  migrateProductAccessSchema1to2: jR,
  migrateProductAccessSchema2to3: xR,
  migrateProductAccessSchema3to4: kR,
  migrateProductAccessSchema4to5: HR,
  migrateProductAccessSchema5to6: BR,
  migrateProductAccessSchema6to7: XR,
  migrateProductAccessSchema7to8: JR,
  migrateProductAccessSchema8to9: WR,
  migrateSchema: N2,
  migrateSchema10to11: o$,
  migrateSchema11to12: a$,
  migrateSchema12to13: c$,
  migrateSchema13to14: d$,
  migrateSchema1to2: YR,
  migrateSchema2to3: zR,
  migrateSchema3to4: KR,
  migrateSchema4to5: ZR,
  migrateSchema5to6: QR,
  migrateSchema6to7: e$,
  migrateSchema7to8: t$,
  migrateSchema8to9: r$,
  migrateSchema9to10: n$
}, Symbol.toStringTag, { value: "Module" })), { newUUID: y2, currentTime: nS } = U, Tm = "1", gm = l({
  refs: {
    id: null,
    userId: null,
    emailAddress: null,
    firstname: null,
    lastname: null,
    costCenterId: null,
    costCenterName: null,
    productAccessId: null,
    productAccessName: null,
    ttlSeconds: null,
    isCancelled: null,
    createdAt: null,
    updatedAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = y2()), e.createdAt || (e.createdAt = nS()), e.updatedAt || (e.updatedAt = nS()), e.isCancelled || (e.isCancelled = !1), e.schemaVersion = Tm;
  }
});
function O2(e) {
  const t = { ...e, objects: {} };
  return gm(t);
}
function v2(e, t, r, n, o, a, i, c, m, d, p, N) {
  return gm({
    userId: e,
    emailAddress: t,
    firstname: r,
    lastname: n,
    costCenterId: o,
    costCenterName: a,
    productAccessId: i,
    productAccessName: c,
    ttlSeconds: m,
    isCancelled: d,
    createdAt: p,
    updatedAt: N
  });
}
function P2(e) {
  const t = /* @__PURE__ */ new Date(), r = Ua(new Date(e.updatedAt || ""), e.ttlSeconds);
  return t < r;
}
const R2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: Tm,
  UserProductInviteStamp: gm,
  createUserAgreementFromJson: O2,
  createUserProductInvite: v2,
  isExpired: P2
}, Symbol.toStringTag, { value: "Module" })), $2 = s.extend((e) => ({
  base: e.string(),
  type: "product",
  messages: {
    invalidRegionCode: "{{#value}} is not a valid productType"
  },
  validate(t, r) {
    ka.includes(t);
  }
})), ir = s.string().required(), de = s.any().valid(...Zn).required(), cr = $2.product().required(), ur = s.string().required(), dr = s.number().integer().min(19700101).max(99999999999999).required(), lr = s.any().valid(te.eula, te.privacyPolicy).required(), mr = s.any().valid(Ze).required(), Sr = s.alternatives().try(ne, s.valid(K)).required(), Er = s.alternatives().try(R, s.valid(K)).required(), xs = s.object().keys({
  id: u,
  text: ir,
  productName: de,
  productType: cr,
  productVersion: ur,
  agreementVersion: dr,
  ccCountry: Er,
  region: Sr,
  type: lr,
  createdAt: D,
  schemaVersion: mr
}), Im = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AgreementTextSchema: ir,
  AgreementVersionSchema: dr,
  ProductNameSchema: de,
  ProductVersionSchema: ur,
  SchemaVersionSchema: mr,
  UserAgreementCountryCodeSchema: Er,
  UserAgreementObjectSchema: xs,
  UserAgreementProductTypeSchema: cr,
  UserAgreementRegionCodeSchema: Sr,
  UserAgreementTypeSchema: lr
}, Symbol.toStringTag, { value: "Module" })), M2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserAgreement: im,
  UserAgreementValidators: Im
}, Symbol.toStringTag, { value: "Module" })), gt = ["1"], ks = gt[gt.length - 1], Hs = {
  1: M2
}, Um = Hs[ks], l$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AgreementTextSchema: ir,
  AgreementVersionSchema: dr,
  CURRENT_SCHEMA_VERSION: ks,
  KNOWN_VERSIONS: gt,
  ProductNameSchema: de,
  ProductVersionSchema: ur,
  REGIONAL_DEFAULT: K,
  SchemaVersionSchema: mr,
  TYPES: te,
  TYPE_VALUES: Jt,
  USER_AGREEMENT_PRODUCT_TYPES: Ps,
  USER_AGREEMENT_SCHEMA_VERSION: Ze,
  UserAgreementCountryCodeSchema: Er,
  UserAgreementObjectSchema: xs,
  UserAgreementProductTypeSchema: cr,
  UserAgreementRegionCodeSchema: Sr,
  UserAgreementStamp: Qe,
  UserAgreementTypeSchema: lr,
  convertDateToAgreementVersion: Wt,
  createUserAgreement: $s,
  createUserAgreementFromJson: Rs,
  currentUserAgreementSchema: Um,
  userAgreementSchemas: Hs
}, Symbol.toStringTag, { value: "Module" })), ZX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AgreementTextSchema: ir,
  AgreementVersionSchema: dr,
  CURRENT_SCHEMA_VERSION: ks,
  KNOWN_VERSIONS: gt,
  ProductNameSchema: de,
  ProductVersionSchema: ur,
  REGIONAL_DEFAULT: K,
  SchemaVersionSchema: mr,
  TYPES: te,
  TYPE_VALUES: Jt,
  USER_AGREEMENT_PRODUCT_TYPES: Ps,
  USER_AGREEMENT_SCHEMA_VERSION: Ze,
  UserAgreement: im,
  UserAgreementConstants: l$,
  UserAgreementCountryCodeSchema: Er,
  UserAgreementObjectSchema: xs,
  UserAgreementProductTypeSchema: cr,
  UserAgreementRegionCodeSchema: Sr,
  UserAgreementStamp: Qe,
  UserAgreementTypeSchema: lr,
  UserAgreementValidators: Im,
  convertDateToAgreementVersion: Wt,
  createUserAgreement: $s,
  createUserAgreementFromJson: Rs,
  currentUserAgreementSchema: Um,
  userAgreementSchemas: Hs
}, Symbol.toStringTag, { value: "Module" })), { newUUID: b2, currentTime: V2 } = U, L2 = 1, Nm = l({
  refs: {
    id: null,
    version: null,
    authenticated: null,
    firstName: null,
    lastName: null,
    emails: null,
    sites: null,
    licenses: null,
    createdAt: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = b2()), e.createdAt || (e.createdAt = V2()), e.version || (e.version = 1), e.emails || (e.emails = {});
  },
  methods: {
    getPrimaryEmail() {
      for (const e of Object.keys(this.emails))
        if (this.emails[e])
          return e;
      throw new Error(`User ${this.id} has no emails`);
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function q2(e) {
  const t = { ...e, objects: {} };
  return Nm(t);
}
function F2(e, t, r) {
  return Nm({ primaryEmail: e, firstname: t, lastname: r });
}
const w2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_SCHEMA_VERSION: L2,
  UserStamp: Nm,
  createUser: F2,
  createUserFromJson: q2
}, Symbol.toStringTag, { value: "Module" })), G2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: w2
}, Symbol.toStringTag, { value: "Module" })), { newUUID: j2, currentTime: x2 } = U, on = "2", ym = l({
  refs: {
    id: null,
    version: null,
    firstname: null,
    lastname: null,
    primaryEmail: null,
    emails: {},
    createdAt: null,
    updatedAt: null,
    schemaVersion: on
  },
  init: ({ instance: e }) => {
    e.id || (e.id = j2()), e.createdAt || (e.createdAt = x2()), e.version || (e.version = 1), e.emails || (e.emails = {}), e.schemaVersion = on;
  },
  methods: {
    getPrimaryEmail() {
      for (const e of Object.keys(this.emails))
        if (this.emails[e])
          return e;
      throw new Error(`User ${this.id} has no emails`);
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function k2(e) {
  const t = { ...e, objects: {} };
  return ym(t);
}
function H2(e, t, r) {
  return ym({ primaryEmail: e, firstname: t, lastname: r });
}
const B2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_SCHEMA_VERSION: on,
  UserStamp: ym,
  createUser: H2,
  createUserFromJson: k2
}, Symbol.toStringTag, { value: "Module" })), Om = 35, m$ = 6, S$ = 254, vm = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  validate(t, r) {
    if (t.match(/[\^\/:\*\?<>\\\|]/))
      return { value: t, errors: r.error(f.INVALID_CHARS_SYMBOLS) };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error(f.NEW_LINE) };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error(f.TABS) };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error(f.CONSECUTIVE_SPACES) };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error(f.LEADING_OR_TRAILING_SPACES) };
  }
})), E$ = s.extend((e) => ({
  base: e.string(),
  type: "emailString",
  messages: {
    emailString: "invalid email"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailString") };
    if (t.length < m$ || t.length > S$)
      return { value: t, errors: r.error("string.emailString") };
    const n = t.indexOf("@");
    if (n < 1)
      return { value: t, errors: r.error("string.emailString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailString") };
        m = d;
      }
  }
})), _$ = E$.emailString(), A$ = s.any().valid(on).required(), f$ = vm.nameString().max(Om).required(), h$ = s.alternatives().try(
  "",
  vm.nameString().max(Om)
), C$ = s.object().keys({
  id: u,
  firstname: f$,
  lastname: h$,
  primaryEmail: _$,
  version: g,
  createdAt: D,
  updatedAt: A,
  emails: s.object().required(),
  schemaVersion: A$
});
function X2(e) {
  return !C$.validate(e).error;
}
const J2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EMAIL_MAX_LENGTH: S$,
  EMAIL_MIN_LENGTH: m$,
  EmailValidation: E$,
  EmailValidationSchema: _$,
  FirstnameSchema: f$,
  LastnameSchema: h$,
  NAME_MAX_LENGTH: Om,
  NameString: vm,
  SchemaVersionSchema: A$,
  UserObjectSchema: C$,
  isUserValid: X2
}, Symbol.toStringTag, { value: "Module" })), W2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: B2,
  UserValidators: J2
}, Symbol.toStringTag, { value: "Module" })), { newUUID: Y2, currentTime: z2 } = U, sn = "3", Pm = l({
  refs: {
    id: null,
    version: null,
    firstname: null,
    lastname: null,
    primaryEmail: null,
    emails: {},
    countryCode: null,
    createdAt: null,
    updatedAt: null,
    schemaVersion: sn
  },
  init: ({ instance: e }) => {
    e.id || (e.id = Y2()), e.createdAt || (e.createdAt = z2()), e.version || (e.version = 1), e.emails || (e.emails = {}), e.schemaVersion = sn;
  },
  methods: {
    getPrimaryEmail() {
      return this.primaryEmail;
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function K2(e) {
  return Pm(e);
}
function D$(e, t, r, n) {
  return Pm({ primaryEmail: e, firstname: t, lastname: r, countryCode: n });
}
function Z2(e) {
  const { primaryEmail: t, firstname: r, lastname: n, countryCode: o } = e;
  return D$(t, r, n, o);
}
const Q2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_SCHEMA_VERSION: sn,
  UserStamp: Pm,
  createUser: D$,
  createUserFromAction: Z2,
  createUserFromJson: K2
}, Symbol.toStringTag, { value: "Module" })), Rm = 35, p$ = 6, T$ = 254, $m = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: "contains invalid characters ^/:*?<>\\|",
    newlines: "contains invalid characters ^/:*?<>\\|",
    tabs: "contains invalid tabs",
    consecutiveSpaces: "contains two or more consecutive spaces",
    leadingOrTrailingSpaces: "contains leading or trailing spaces"
  },
  validate(t, r) {
    if (t.match(/[\^\/:\*\?<>\\\|]/))
      return { value: t, errors: r.error(f.INVALID_CHARS_SYMBOLS) };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error(f.NEW_LINE) };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error(f.TABS) };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error(f.CONSECUTIVE_SPACES) };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error(f.LEADING_OR_TRAILING_SPACES) };
  }
})), g$ = s.extend((e) => ({
  base: e.string(),
  type: "emailString",
  messages: {
    emailString: "invalid email"
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("string.emailString") };
    if (t.length < p$ || t.length > T$)
      return { value: t, errors: r.error("string.emailString") };
    const n = t.indexOf("@");
    if (n < 1)
      return { value: t, errors: r.error("string.emailString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("string.emailString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("string.emailString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("string.emailString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("string.emailString") };
        m = d;
      }
  }
})), I$ = g$.emailString(), U$ = s.any().valid(sn).required(), N$ = $m.nameString().max(Rm).required(), y$ = s.alternatives().try(
  "",
  $m.nameString().max(Rm)
), O$ = s.object().keys({
  id: u,
  firstname: N$,
  lastname: y$,
  primaryEmail: I$,
  version: g,
  createdAt: D,
  updatedAt: A,
  countryCode: R,
  emails: s.object().required(),
  schemaVersion: U$
});
function eB(e) {
  return !O$.validate(e).error;
}
const tB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EMAIL_MAX_LENGTH: T$,
  EMAIL_MIN_LENGTH: p$,
  EmailValidation: g$,
  EmailValidationSchema: I$,
  FirstnameSchema: N$,
  LastnameSchema: y$,
  NAME_MAX_LENGTH: Rm,
  NameString: $m,
  SchemaVersionSchema: U$,
  UserObjectSchema: O$,
  isUserValid: eB
}, Symbol.toStringTag, { value: "Module" })), rB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: Q2,
  UserValidators: tB
}, Symbol.toStringTag, { value: "Module" })), { newUUID: nB, currentTime: oB } = U, an = "4", Mm = l({
  refs: {
    id: null,
    version: null,
    firstname: null,
    lastname: null,
    primaryEmail: null,
    emails: {},
    countryCode: null,
    createdAt: null,
    updatedAt: null,
    schemaVersion: an
  },
  init: ({ instance: e }) => {
    e.id || (e.id = nB()), e.createdAt || (e.createdAt = oB()), e.version || (e.version = 1), e.primaryEmail && (e.emails = {
      [e.primaryEmail]: {
        verified: !1
      }
    }), e.schemaVersion = an;
  },
  methods: {
    getPrimaryEmail() {
      return this.primaryEmail;
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function sB(e) {
  return Mm(e);
}
function v$(e, t, r, n) {
  return Mm({ primaryEmail: e, firstname: t, lastname: r, countryCode: n });
}
function aB(e) {
  const { primaryEmail: t, firstname: r, lastname: n, countryCode: o } = e;
  return v$(t, r, n, o);
}
const iB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_SCHEMA_VERSION: an,
  UserStamp: Mm,
  createUser: v$,
  createUserFromAction: aB,
  createUserFromJson: sB
}, Symbol.toStringTag, { value: "Module" })), bm = 35, P$ = 6, R$ = 254, Vm = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: f.INVALID_CHARS_SYMBOLS,
    newlines: f.NEW_LINE,
    tabs: f.TABS,
    consecutiveSpaces: f.CONSECUTIVE_SPACES,
    leadingOrTrailingSpaces: f.LEADING_OR_TRAILING_SPACES
  },
  validate(t, r) {
    if (t.match(/[\^/:*?<>\\|]/))
      return { value: t, errors: r.error("invalidChars") };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error("newlines") };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error("tabs") };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error("consecutiveSpaces") };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error("leadingOrTrailingSpaces") };
  }
})), $$ = s.extend((e) => ({
  base: e.string(),
  type: "emailString",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("emailString") };
    if (t.length < P$ || t.length > R$)
      return { value: t, errors: r.error("emailString") };
    const n = t.indexOf("@");
    if (n < 1)
      return { value: t, errors: r.error("emailString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("emailString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("emailString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("emailString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("emailString") };
        m = d;
      }
  }
})), Lm = $$.emailString(), M$ = s.any().valid(an).required(), b$ = Vm.nameString().max(bm).required(), V$ = s.alternatives().try(
  "",
  Vm.nameString().max(bm)
), L$ = s.object().keys({
  verified: T.required()
}), Da = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    for (const n in t)
      if (Lm.validate(n).error)
        return { value: t, errors: r.error("emailString") };
  }
})), q$ = Da.object().keys({
  id: u,
  firstname: b$,
  lastname: V$,
  primaryEmail: Lm,
  version: g,
  createdAt: D,
  updatedAt: A,
  countryCode: R,
  emails: Da.objects().pattern(/^/, L$),
  schemaVersion: M$
});
function cB(e) {
  return !q$.validate(e).error;
}
const uB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EMAIL_MAX_LENGTH: R$,
  EMAIL_MIN_LENGTH: P$,
  EmailValidation: $$,
  EmailValidationSchema: Lm,
  EmailsObjectSchema: L$,
  FirstnameSchema: b$,
  LastnameSchema: V$,
  NAME_MAX_LENGTH: bm,
  NameString: Vm,
  SchemaVersionSchema: M$,
  UserObjectSchema: q$,
  UserObjectValidator: Da,
  isUserValid: cB
}, Symbol.toStringTag, { value: "Module" })), dB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: iB,
  UserValidators: uB
}, Symbol.toStringTag, { value: "Module" })), { newUUID: oS, currentTime: lB } = U, cn = "5", un = {
  active: "active",
  deleted: "deleted"
}, qm = l({
  refs: {
    id: null,
    trackingId: null,
    version: null,
    firstname: null,
    lastname: null,
    primaryEmail: null,
    optOutDate: null,
    deletedDate: null,
    accountState: null,
    emails: {},
    countryCode: null,
    createdAt: null,
    updatedAt: null,
    schemaVersion: cn
  },
  init: ({ instance: e }) => {
    e.id || (e.id = oS()), e.trackingId || (e.trackingId = oS()), e.createdAt || (e.createdAt = lB()), e.accountState || (e.accountState = un.active), e.version || (e.version = 1), e.primaryEmail && (e.emails = {
      [e.primaryEmail]: {
        verified: !1
      }
    }), e.schemaVersion = cn;
  },
  methods: {
    getPrimaryEmail() {
      return this.primaryEmail;
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function mB(e) {
  return qm(e);
}
function F$(e, t, r, n) {
  return qm({ primaryEmail: e, firstname: t, lastname: r, countryCode: n });
}
function SB(e) {
  const { primaryEmail: t, firstname: r, lastname: n, countryCode: o } = e;
  return F$(t, r, n, o);
}
const EB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_ACCOUNT_STATES: un,
  USER_SCHEMA_VERSION: cn,
  UserStamp: qm,
  createUser: F$,
  createUserFromAction: SB,
  createUserFromJson: mB
}, Symbol.toStringTag, { value: "Module" })), Fm = 35, w$ = 6, G$ = 254, wm = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: f.INVALID_CHARS_SYMBOLS,
    newlines: f.NEW_LINE,
    tabs: f.TABS,
    consecutiveSpaces: f.CONSECUTIVE_SPACES,
    leadingOrTrailingSpaces: f.LEADING_OR_TRAILING_SPACES
  },
  validate(t, r) {
    if (t.match(/[\^/:*?<>\\|]/))
      return { value: t, errors: r.error("invalidChars") };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error("newlines") };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error("tabs") };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error("consecutiveSpaces") };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error("leadingOrTrailingSpaces") };
  }
})), j$ = s.extend((e) => ({
  base: e.string(),
  type: "emailString",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("emailString") };
    if (t.length < w$ || t.length > G$)
      return { value: t, errors: r.error("emailString") };
    const n = t.indexOf("@");
    if (n < 1)
      return { value: t, errors: r.error("emailString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("emailString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("emailString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("emailString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("emailString") };
        m = d;
      }
  }
})), Gm = j$.emailString(), x$ = s.alternatives().try(null, u).required(), k$ = s.any().valid(cn).required(), H$ = wm.nameString().max(Fm).required(), B$ = s.alternatives().try(
  "",
  wm.nameString().max(Fm)
), X$ = s.alternatives().try(null, h).required(), J$ = s.alternatives().try(null, h).required(), _B = Object.keys(un).map((e) => un[e]), W$ = s.string().valid(..._B).required(), Y$ = s.object().keys({
  verified: T.required()
}), pa = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    for (const n in t)
      if (Gm.validate(n).error)
        return { value: t, errors: r.error("emailString") };
  }
})), z$ = pa.object().keys({
  id: u,
  trackingId: x$,
  firstname: H$,
  lastname: B$,
  primaryEmail: Gm,
  version: g,
  optOutDate: X$,
  deletedDate: J$,
  accountState: W$,
  createdAt: D,
  updatedAt: A,
  countryCode: R,
  emails: pa.objects().pattern(/^/, Y$),
  schemaVersion: k$
});
function AB(e) {
  return !z$.validate(e).error;
}
const fB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountStateSchema: W$,
  DeletedDateSchema: J$,
  EMAIL_MAX_LENGTH: G$,
  EMAIL_MIN_LENGTH: w$,
  EmailValidation: j$,
  EmailValidationSchema: Gm,
  EmailsObjectSchema: Y$,
  FirstnameSchema: H$,
  LastnameSchema: B$,
  NAME_MAX_LENGTH: Fm,
  NameString: wm,
  OptOutDateSchema: X$,
  SchemaVersionSchema: k$,
  TrackingIdSchema: x$,
  UserObjectSchema: z$,
  UserObjectValidator: pa,
  isUserValid: AB
}, Symbol.toStringTag, { value: "Module" })), hB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: EB,
  UserValidators: fB
}, Symbol.toStringTag, { value: "Module" })), { newUUID: sS, currentTime: CB } = U, Me = "6", be = {
  active: "active",
  deleted: "deleted"
}, ot = l({
  refs: {
    id: null,
    trackingId: null,
    version: null,
    firstname: null,
    lastname: null,
    primaryEmail: null,
    optOutDate: null,
    deletedDate: null,
    accountState: null,
    emails: {},
    countryCode: null,
    createdAt: null,
    updatedAt: null,
    schemaVersion: Me,
    phantom: !1
  },
  init: ({ instance: e }) => {
    e.id || (e.id = sS()), e.trackingId || (e.trackingId = sS()), e.createdAt || (e.createdAt = CB()), e.accountState || (e.accountState = be.active), e.version || (e.version = 1), e.primaryEmail && (e.emails = {
      [e.primaryEmail]: {
        verified: !1
      }
    }), e.schemaVersion = Me;
  },
  methods: {
    getPrimaryEmail() {
      return this.primaryEmail;
    },
    getFullName() {
      return `${this.firstname} ${this.lastname}`.trim();
    }
  }
});
function jm(e) {
  return ot(e);
}
function Bs(e, t, r, n) {
  return ot({ primaryEmail: e, firstname: t, lastname: r, countryCode: n });
}
function xm(e) {
  const { primaryEmail: t, firstname: r, lastname: n, countryCode: o } = e;
  return Bs(t, r, n, o);
}
const Xs = ot.refs({
  phantom: !0
});
function km(e, t = {}) {
  return Xs({ primaryEmail: e, ...t });
}
const DB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PhantomUserStamp: Xs,
  USER_ACCOUNT_STATES: be,
  USER_SCHEMA_VERSION: Me,
  UserStamp: ot,
  createPhantomUserAsync: km,
  createUser: Bs,
  createUserFromAction: xm,
  createUserFromJson: jm
}, Symbol.toStringTag, { value: "Module" })), _r = 35, Js = 6, Ws = 254, Ar = s.extend((e) => ({
  base: e.string(),
  type: "nameString",
  messages: {
    invalidChars: f.INVALID_CHARS_SYMBOLS,
    newlines: f.NEW_LINE,
    tabs: f.TABS,
    consecutiveSpaces: f.CONSECUTIVE_SPACES,
    leadingOrTrailingSpaces: f.LEADING_OR_TRAILING_SPACES
  },
  validate(t, r) {
    if (t.match(/[\^/:*?<>\\|]/))
      return { value: t, errors: r.error("invalidChars") };
    if (t.match(/[\r\n\f]/))
      return { value: t, errors: r.error("newlines") };
    if (t.match(/[\t\b]/))
      return { value: t, errors: r.error("tabs") };
    if (t.match(/ {2}/))
      return { value: t, errors: r.error("consecutiveSpaces") };
    if (t.match(/^\s|\s$/))
      return { value: t, errors: r.error("leadingOrTrailingSpaces") };
  }
})), Ys = s.extend((e) => ({
  base: e.string(),
  type: "emailString",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    if (t.match(/[\s\r\n\t\b\f<>()"[\]:;]/))
      return { value: t, errors: r.error("emailString") };
    if (t.length < Js || t.length > Ws)
      return { value: t, errors: r.error("emailString") };
    const n = t.indexOf("@");
    if (n < 1)
      return { value: t, errors: r.error("emailString") };
    const o = t.substring(n + 1), a = o.lastIndexOf(".");
    if (o.length - a - 1 < 2)
      return { value: t, errors: r.error("emailString") };
    const c = o.substring(0, a);
    if (c.length < 1)
      return { value: t, errors: r.error("emailString") };
    if (c[0] === ".")
      return { value: t, errors: r.error("emailString") };
    let m = -1;
    for (let d = 0; d < o.length; d += 1)
      if (o[d] === ".") {
        if (m === d - 1)
          return { value: t, errors: r.error("emailString") };
        m = d;
      }
  }
})), le = Ys.emailString(), zs = s.alternatives().try(null, u).required(), Ks = s.any().valid(Me).required(), Ue = Ar.nameString().max(_r).required(), Ne = s.alternatives().try(
  null,
  "",
  Ar.nameString().max(_r)
), Zs = s.alternatives().try(null, h).required(), Qs = s.alternatives().try(null, h).required(), pB = Object.keys(be).map((e) => be[e]), ea = s.string().valid(...pB).required(), ta = s.object().keys({
  verified: T.required()
}), fr = s.extend((e) => ({
  base: e.object(),
  type: "objects",
  messages: {
    emailString: f.INVALID_EMAIL
  },
  validate(t, r) {
    for (const n in t)
      if (le.validate(n).error)
        return { value: t, errors: r.error("emailString") };
  }
})), TB = {
  id: u,
  trackingId: zs,
  firstname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ue
  }),
  lastname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ne
  }),
  primaryEmail: le,
  version: g,
  optOutDate: Zs,
  deletedDate: Qs,
  accountState: ea,
  createdAt: D,
  updatedAt: A,
  countryCode: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: R
  }),
  emails: fr.objects().pattern(/^/, ta),
  schemaVersion: Ks,
  phantom: T
}, ra = fr.object().keys(TB);
function Hm(e) {
  return !ra.validate(e).error;
}
const gB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountStateSchema: ea,
  DeletedDateSchema: Qs,
  EMAIL_MAX_LENGTH: Ws,
  EMAIL_MIN_LENGTH: Js,
  EmailValidation: Ys,
  EmailValidationSchema: le,
  EmailsObjectSchema: ta,
  FirstnameSchema: Ue,
  LastnameSchema: Ne,
  NAME_MAX_LENGTH: _r,
  NameString: Ar,
  OptOutDateSchema: Zs,
  SchemaVersionSchema: Ks,
  TrackingIdSchema: zs,
  UserObjectSchema: ra,
  UserObjectValidator: fr,
  isUserValid: Hm
}, Symbol.toStringTag, { value: "Module" })), IB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  User: DB,
  UserValidators: gB
}, Symbol.toStringTag, { value: "Module" })), dn = ["1", "2", "3", "4", "5", "6"], na = dn[dn.length - 1], re = {
  1: G2,
  2: W2,
  3: rB,
  4: dB,
  5: hB,
  6: IB
}, Bm = re[na], { User: K$, UserValidators: Z$ } = Bm, QX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountStateSchema: ea,
  CURRENT_SCHEMA_VERSION: na,
  DeletedDateSchema: Qs,
  EMAIL_MAX_LENGTH: Ws,
  EMAIL_MIN_LENGTH: Js,
  EmailValidation: Ys,
  EmailValidationSchema: le,
  EmailsObjectSchema: ta,
  FirstnameSchema: Ue,
  KNOWN_VERSIONS: dn,
  LastnameSchema: Ne,
  NAME_MAX_LENGTH: _r,
  NameString: Ar,
  OptOutDateSchema: Zs,
  PhantomUserStamp: Xs,
  SchemaVersionSchema: Ks,
  TrackingIdSchema: zs,
  USER_ACCOUNT_STATES: be,
  USER_SCHEMA_VERSION: Me,
  User: K$,
  UserObjectSchema: ra,
  UserObjectValidator: fr,
  UserStamp: ot,
  UserValidators: Z$,
  createPhantomUserAsync: km,
  createUser: Bs,
  createUserFromAction: xm,
  createUserFromJson: jm,
  currentUserSchema: Bm,
  isUserValid: Hm,
  userSchemas: re
}, Symbol.toStringTag, { value: "Module" })), Q$ = s.number().integer().min(0).required(), eM = s.any().valid(Tm).required(), UB = s.object().keys({
  id: u,
  userId: u,
  emailAddress: le,
  firstname: Ue,
  lastname: Ne,
  costCenterId: u,
  costCenterName: xe,
  productAccessId: u,
  productAccessName: de,
  ttlSeconds: Q$,
  isCancelled: T,
  createdAt: D,
  updatedAt: A,
  schemaVersion: eM
}), NB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SchemaVersionSchema: eM,
  TtlSecondsSchema: Q$,
  UserProductInviteObjectSchema: UB
}, Symbol.toStringTag, { value: "Module" })), yB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserProductInvite: R2,
  UserProductInviteValidators: NB
}, Symbol.toStringTag, { value: "Module" })), { newUUID: OB, currentTime: aS } = U, Xm = "2", Jm = l({
  refs: {
    id: null,
    userId: null,
    emailAddress: null,
    firstname: null,
    lastname: null,
    costCenterId: null,
    costCenterName: null,
    productAccessId: null,
    productAccessName: null,
    ttlSeconds: null,
    isCancelled: null,
    createdAt: null,
    updatedAt: null,
    phantom: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = OB()), e.createdAt || (e.createdAt = aS()), e.updatedAt || (e.updatedAt = aS()), e.isCancelled || (e.isCancelled = !1), e.phantom || (e.phantom = !1), e.schemaVersion = Xm;
  }
});
function vB(e) {
  const t = { ...e, objects: {} };
  return Jm(t);
}
function PB(e, t, r, n, o, a, i, c, m, d, p, N, M) {
  return Jm({
    userId: e,
    emailAddress: t,
    firstname: r,
    lastname: n,
    costCenterId: o,
    costCenterName: a,
    productAccessId: i,
    productAccessName: c,
    ttlSeconds: m,
    isCancelled: d,
    phantom: p,
    createdAt: N,
    updatedAt: M
  });
}
function RB(e) {
  const t = /* @__PURE__ */ new Date(), r = Ua(new Date(e.updatedAt || ""), e.ttlSeconds);
  return t < r;
}
const $B = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: Xm,
  UserProductInviteStamp: Jm,
  createUserAgreementFromJson: vB,
  createUserProductInvite: PB,
  isExpired: RB
}, Symbol.toStringTag, { value: "Module" })), tM = s.number().integer().min(0).required(), rM = s.any().valid(Xm).required(), MB = s.object().keys({
  id: u,
  userId: u,
  emailAddress: le,
  firstname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ue
  }),
  lastname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ne
  }),
  costCenterId: u,
  costCenterName: xe,
  productAccessId: u,
  productAccessName: de,
  ttlSeconds: tM,
  isCancelled: T,
  createdAt: D,
  updatedAt: A,
  schemaVersion: rM,
  phantom: T
}), bB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SchemaVersionSchema: rM,
  TtlSecondsSchema: tM,
  UserProductInviteObjectSchema: MB
}, Symbol.toStringTag, { value: "Module" })), VB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserProductInvite: $B,
  UserProductInviteValidators: bB
}, Symbol.toStringTag, { value: "Module" })), { newUUID: LB, currentTime: iS } = U, st = "3", at = l({
  refs: {
    id: null,
    userId: null,
    emailAddress: null,
    firstname: null,
    lastname: null,
    costCenterId: null,
    costCenterName: null,
    productAccessId: null,
    productAccessName: null,
    inviterId: null,
    ttlSeconds: null,
    isCancelled: null,
    createdAt: null,
    updatedAt: null,
    phantom: null
  },
  init: ({ instance: e }) => {
    e.id || (e.id = LB()), e.createdAt || (e.createdAt = iS()), e.updatedAt || (e.updatedAt = iS()), e.isCancelled || (e.isCancelled = !1), e.phantom || (e.phantom = !1), e.inviterId || (e.inviterId = !1), e.schemaVersion = st;
  }
});
function oa(e) {
  const t = { ...e, objects: {} };
  return at(t);
}
function sa(e, t, r, n, o, a, i, c, m, d, p, N, M, q) {
  return at({
    userId: e,
    emailAddress: t,
    firstname: r,
    lastname: n,
    costCenterId: o,
    costCenterName: a,
    productAccessId: i,
    productAccessName: c,
    inviterId: m,
    ttlSeconds: d,
    isCancelled: p,
    phantom: N,
    createdAt: M,
    updatedAt: q
  });
}
function aa(e) {
  const t = /* @__PURE__ */ new Date(), r = Ua(new Date(e.updatedAt || ""), e.ttlSeconds);
  return t < r;
}
const nM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: st,
  UserProductInviteStamp: at,
  createUserAgreementFromJson: oa,
  createUserProductInvite: sa,
  isExpired: aa
}, Symbol.toStringTag, { value: "Module" })), hr = s.number().integer().min(0).required(), Cr = s.any().valid(st).required(), ia = s.object().keys({
  id: u,
  userId: u,
  emailAddress: le,
  firstname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ue
  }),
  lastname: s.alternatives().conditional("phantom", {
    is: !0,
    then: me,
    otherwise: Ne
  }),
  costCenterId: u,
  costCenterName: xe,
  productAccessId: u,
  productAccessName: de,
  inviterId: s.alternatives(u, null),
  ttlSeconds: hr,
  isCancelled: T,
  createdAt: D,
  updatedAt: A,
  schemaVersion: Cr,
  phantom: T
}), oM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SchemaVersionSchema: Cr,
  TtlSecondsSchema: hr,
  UserProductInviteObjectSchema: ia
}, Symbol.toStringTag, { value: "Module" })), qB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UserProductInvite: nM,
  UserProductInviteValidators: oM
}, Symbol.toStringTag, { value: "Module" })), It = ["1", "2", "3"], Dr = It[It.length - 1], it = {
  1: yB,
  2: VB,
  3: qB
}, Wm = it[Dr], FB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENT_SCHEMA_VERSION: Dr,
  KNOWN_VERSIONS: It,
  SchemaVersionSchema: Cr,
  TtlSecondsSchema: hr,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: st,
  UserProductInviteObjectSchema: ia,
  UserProductInviteStamp: at,
  createUserAgreementFromJson: oa,
  createUserProductInvite: sa,
  currentUserProductInviteSchema: Wm,
  isExpired: aa,
  userProductInviteSchemas: it
}, Symbol.toStringTag, { value: "Module" }));
function sM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "1"}`;
  if (n !== "1")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = {
    ...e,
    schemaVersion: "2",
    phantom: e.phantom || !1
  }, { UserProductInviteValidators: a } = it[2], i = a.UserProductInviteObjectSchema.validate(o).error;
  if (i)
    throw new Error(
      `Cannot migrate userProductInvite ${e.id} from schema version 1 to schema 2 due to // validation error: ${i}`
    );
  return o;
}
function aM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "2"}`;
  if (n !== "2")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = {
    ...e,
    schemaVersion: "3",
    inviterId: null
  }, { UserProductInviteValidators: a } = it[3], i = a.UserProductInviteObjectSchema.validate(o).error;
  if (i)
    throw new Error(
      `Cannot migrate userProductInvite ${e.id} from schema version 2 to schema 3 due to // validation error: ${i}`
    );
  return o;
}
function wB(e) {
  if (!e || e.schemaVersion === Dr)
    return e;
  const t = `${e.schemaVersion || 1}`;
  switch (t) {
    case 1:
    case "1":
      e = sM(e);
      break;
    case "2":
      e = aM(e);
      break;
    default:
      throw new Error(
        `Cannot upgrade user object schema from unknown schema version ${t}`
      );
  }
  return e;
}
const GB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  migrateSchema: wB,
  migrateSchema1to2: sM,
  migrateSchema2to3: aM
}, Symbol.toStringTag, { value: "Module" })), jB = "2017-03-08T17:34:50.581Z";
function iM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "1"}`;
  if (n !== "1")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = {
    id: e.id,
    version: e.version,
    firstname: e.firstname || "Unknown",
    lastname: e.lastname || "",
    primaryEmail: e.primaryEmail,
    emails: e.emails,
    createdAt: e.createdAt || jB,
    updatedAt: e.updatedAt || null,
    schemaVersion: "2"
  };
  o.emails || (o.emails = {}), o.emails[e.primaryEmail] || (o.emails[e.primaryEmail] = !1);
  const { UserValidators: a } = re[2], i = a.UserObjectSchema.validate(o).error;
  if (i)
    throw new Error(
      `Cannot migrate user ${e.id} from schema version 1 to schema 2 due to validation error: ${i}`
    );
  return o;
}
function cM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "2"}`;
  if (n !== "2")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = { ...e, countryCode: "US", schemaVersion: "3" };
  o.updatedAt = e.updatedAt || null;
  const { UserValidators: a } = re[3], i = a.UserObjectSchema.validate(o).error;
  if (i)
    throw new Error(
      `Cannot migrate user ${e.id} from schema version 2 to schema 3 due to validation error: ${i}`
    );
  return o;
}
function uM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "3"}`;
  if (n !== "3")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = { ...e.emails, [e.primaryEmail]: { verified: !1 } }, a = { ...e, emails: o, schemaVersion: "4" }, { UserValidators: i } = re[4], c = i.UserObjectSchema.validate(a).error;
  if (c)
    throw new Error(
      `Cannot migrate user ${e.id} from schema version 3 to schema 4 due to validation error: ${c}`
    );
  return a;
}
function dM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "4"}`;
  if (n !== "4")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const { User: o } = re[5], a = {
    ...e,
    optOutDate: null,
    deletedDate: null,
    accountState: o.USER_ACCOUNT_STATES.active,
    schemaVersion: "5"
  };
  a.trackingId === void 0 && (a.trackingId = F());
  const { UserValidators: i } = re[5], c = i.UserObjectSchema.validate(a).error;
  if (c)
    throw new Error(
      `Cannot migrate user ${e.id} from schema version 4 to schema 5 due to validation error: ${c}`
    );
  return a;
}
function lM(e) {
  if (!e)
    return e;
  const n = `${e.schemaVersion || "5"}`;
  if (n !== "5")
    throw new Error(
      `Cannot upgrade user object schema from unknown schema version ${n}`
    );
  const o = {
    ...e,
    schemaVersion: "6",
    phantom: e.phantom || !1
  }, { UserValidators: a } = re[6], i = a.UserObjectSchema.validate(o).error;
  if (i)
    throw new Error(
      `Cannot migrate user ${e.id} from schema version 5 to schema 6 due to validation error: ${i}`
    );
  return o;
}
function xB(e) {
  if (!e || e.schemaVersion === na)
    return e;
  const t = `${e.schemaVersion || 1}`;
  switch (t) {
    case 1:
    case "1":
      e = iM(e);
    case "2":
      e = cM(e);
    case "3":
      e = uM(e);
    case "4":
      e = dM(e);
    case "5":
      e = lM(e);
      break;
    default:
      throw new Error(
        `Cannot upgrade user object schema from unknown schema version ${t}`
      );
  }
  return e;
}
const eJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  migrateSchema: xB,
  migrateSchema1to2: iM,
  migrateSchema2to3: cM,
  migrateSchema3to4: uM,
  migrateSchema4to5: dM,
  migrateSchema5to6: lM
}, Symbol.toStringTag, { value: "Module" }));
function mM(e, t) {
  return Array.isArray(e) ? e.find((r) => r?.type === t) ?? null : null;
}
function SM(e, t) {
  return mM(e, t)?.value ?? null;
}
function ca(e, t) {
  return !e || !e.identifiers ? null : SM(e.identifiers, t);
}
function kB(e) {
  return ca(
    e,
    Ge.hwa
  );
}
function HB(e) {
  return ca(
    e,
    Ge.fingerprint
  );
}
function BB(e) {
  return ca(
    e,
    Ge.fwmEncryptedFingerprint
  );
}
const tJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getIdentifierByType: mM,
  getIdentifierValueByType: SM,
  getSharedComputerFingerprintIdentifierValue: HB,
  getSharedComputerFwmEncryptedFingerprintIdentifierValue: BB,
  getSharedComputerHwaIdentifierValue: kB,
  getSharedComputerIdentifierValueByType: ca
}, Symbol.toStringTag, { value: "Module" })), rJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountStateSchema: ea,
  CURRENT_SCHEMA_VERSION: na,
  DeletedDateSchema: Qs,
  EMAIL_MAX_LENGTH: Ws,
  EMAIL_MIN_LENGTH: Js,
  EmailValidation: Ys,
  EmailValidationSchema: le,
  EmailsObjectSchema: ta,
  FirstnameSchema: Ue,
  KNOWN_VERSIONS: dn,
  LastnameSchema: Ne,
  NAME_MAX_LENGTH: _r,
  NameString: Ar,
  OptOutDateSchema: Zs,
  PhantomUserStamp: Xs,
  SchemaVersionSchema: Ks,
  TrackingIdSchema: zs,
  USER_ACCOUNT_STATES: be,
  USER_SCHEMA_VERSION: Me,
  User: K$,
  UserObjectSchema: ra,
  UserObjectValidator: fr,
  UserStamp: ot,
  UserValidators: Z$,
  createPhantomUserAsync: km,
  createUser: Bs,
  createUserFromAction: xm,
  createUserFromJson: jm,
  currentUserSchema: Bm,
  isUserValid: Hm,
  userSchemas: re
}, Symbol.toStringTag, { value: "Module" })), EM = "user-admin", _M = "sync", AM = `/api/${EM}/${Z}`;
function Ym() {
  return AM;
}
function XB(e) {
  return e + Ym();
}
function zm() {
  return `${Ym()}/${_M}`;
}
function JB(e) {
  return e + zm();
}
function fM(e) {
  return `${zm()}/${e}`;
}
function WB(e, t) {
  return e + fM(t);
}
const nJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  API_VERSION: Z,
  SYNC: _M,
  USER_ADMIN: EM,
  USER_ADMIN_BASE_PATH: AM,
  userAdminBasePath: Ym,
  userAdminBaseUrl: XB,
  userAdminSyncBasePath: zm,
  userAdminSyncBaseURL: JB,
  userAdminSyncPath: fM,
  userAdminSyncURL: WB
}, Symbol.toStringTag, { value: "Module" })), oJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AgreementTextSchema: ir,
  AgreementVersionSchema: dr,
  CURRENT_SCHEMA_VERSION: ks,
  KNOWN_VERSIONS: gt,
  ProductNameSchema: de,
  ProductVersionSchema: ur,
  REGIONAL_DEFAULT: K,
  SchemaVersionSchema: mr,
  TYPES: te,
  TYPE_VALUES: Jt,
  USER_AGREEMENT_PRODUCT_TYPES: Ps,
  USER_AGREEMENT_SCHEMA_VERSION: Ze,
  UserAgreement: im,
  UserAgreementConstants: l$,
  UserAgreementCountryCodeSchema: Er,
  UserAgreementObjectSchema: xs,
  UserAgreementProductTypeSchema: cr,
  UserAgreementRegionCodeSchema: Sr,
  UserAgreementStamp: Qe,
  UserAgreementTypeSchema: lr,
  UserAgreementValidators: Im,
  convertDateToAgreementVersion: Wt,
  createUserAgreement: $s,
  createUserAgreementFromJson: Rs,
  currentUserAgreementSchema: Um,
  userAgreementSchemas: Hs
}, Symbol.toStringTag, { value: "Module" })), sJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENT_SCHEMA_VERSION: Dr,
  KNOWN_VERSIONS: It,
  SchemaVersionSchema: Cr,
  TtlSecondsSchema: hr,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: st,
  UserProductInvite: nM,
  UserProductInviteConstants: FB,
  UserProductInviteMigrate: GB,
  UserProductInviteObjectSchema: ia,
  UserProductInviteStamp: at,
  UserProductInviteValidators: oM,
  createUserAgreementFromJson: oa,
  createUserProductInvite: sa,
  currentUserProductInviteSchema: Wm,
  isExpired: aa,
  userProductInviteSchemas: it
}, Symbol.toStringTag, { value: "Module" })), aJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENT_SCHEMA_VERSION: Dr,
  KNOWN_VERSIONS: It,
  SchemaVersionSchema: Cr,
  TtlSecondsSchema: hr,
  USER_PRODUCT_INVITE_SCHEMA_VERSION: st,
  UserProductInviteObjectSchema: ia,
  UserProductInviteStamp: at,
  createUserAgreementFromJson: oa,
  createUserProductInvite: sa,
  currentUserProductInviteSchema: Wm,
  isExpired: aa,
  userProductInviteSchemas: it
}, Symbol.toStringTag, { value: "Module" })), ye = `/api/user/${Z}`, YB = `${ye}/changesneeded`, zB = `${ye}/email-verification`;
function pr() {
  return ye;
}
function KB() {
  return `${pr()}/membership`;
}
function hM() {
  return `${pr()}/sync`;
}
function CM(e) {
  return `${hM()}/${e}`;
}
function ZB(e, t) {
  return e + CM(t);
}
function QB(e) {
  return e + pr();
}
function DM() {
  return YB;
}
function eX(e) {
  return e + DM();
}
function pM() {
  return zB;
}
function tX(e) {
  return e + pM();
}
function ct(e) {
  return my(e), `${pr()}/${e}`;
}
function rX(e, t) {
  return e + ct(t);
}
function TM() {
  return `${ye}/createUser`;
}
function nX(e) {
  return e + TM();
}
function gM() {
  return `${ye}/convertPhantomUserToUser`;
}
function oX(e) {
  return e + gM();
}
function IM() {
  return `${ye}/findUserByEmail`;
}
function sX(e) {
  return e + IM();
}
function UM(e) {
  return `${ye}/${e}/tracking`;
}
function aX(e, t) {
  return `${e}${UM(t)}`;
}
const iX = (e) => `${ct(e)}/update-field`, cX = (e, t) => {
  const r = ct(t);
  return `${e}${r}/update-field`;
}, uX = (e) => `${ct(e)}/update-fields`, dX = (e, t) => {
  const r = ct(t);
  return `${e}${r}/update-fields`;
}, iJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  changesNeededPath: DM,
  changesNeededUrl: eX,
  convertPhantomUserPath: gM,
  convertPhantomUserUrl: oX,
  createUserPath: TM,
  createUserUrl: nX,
  emailVerificationPath: pM,
  emailVerificationUrl: tX,
  findUserByEmailPath: IM,
  findUserByEmailUrl: sX,
  trackingPath: UM,
  trackingUrl: aX,
  updateUserFieldPath: iX,
  updateUserFieldUrl: cX,
  updateUserFieldsPath: uX,
  updateUserFieldsUrl: dX,
  userBasePath: pr,
  userBaseUrl: QB,
  userMembershipBasePath: KB,
  userPath: ct,
  userSyncBasePath: hM,
  userSyncPath: CM,
  userSyncURL: ZB,
  userUrl: rX
}, Symbol.toStringTag, { value: "Module" }));
export {
  yX as AdminUrls,
  OX as AuthServiceUrls,
  vX as AuthUtils,
  PX as AuthValidators,
  RX as AuthorizedDevice,
  p2 as AuthorizedDeviceMigrate,
  zX as AuthorizedDeviceSchema,
  $X as AuthorizedDeviceValidators,
  bX as CloudActionTypes,
  MX as CloudActions,
  VX as CloudConstants,
  TX as CloudErrors,
  NX as CloudUtils,
  Y1 as CostCenter,
  KX as CostCenterMigrate,
  LX as CostCenterServiceUrls,
  qX as CostCenterValidators,
  GX as CryptoFJ,
  FX as DefaultState,
  gX as FlowjoCommons,
  UX as FwmConstants,
  wX as HubspotUtils,
  jX as LicenseServiceUrls,
  xX as LicenseUtils,
  BX as Notification,
  XX as NotificationActions,
  HX as NotificationErrors,
  JX as NotificationReducers,
  WX as NotificationServiceUrls,
  IX as Product,
  YX as ProductServiceUrls,
  kX as ProductVersionUtils,
  tJ as SharedComputerUtils,
  rJ as User,
  nJ as UserAdminServiceUrls,
  oJ as UserAgreement,
  ZX as UserAgreementValidators,
  eJ as UserMigrate,
  sJ as UserProductInvite,
  GB as UserProductInviteMigrate,
  aJ as UserProductInviteValidators,
  iJ as UserServiceUrls,
  QX as UserValidators
};
//# sourceMappingURL=index.mjs.map
